const cities = [
  "балларат",
  "бендиго",
  "варрнамбул",
  "водонга",
  "гилонг",
  "мелтон",
  "мельбурн",
  "милдура",
  "траралгон",
  "шеппартон",
  "бунбури",
  "гералдтон",
  "калгурли",
  "мандурах",
  "олбани",
  "перт",
  "брисбен",
  "бундаберг",
  "гладстон",
  "каирнс",
  "калундра",
  "маккей",
  "мариборо",
  "маунт-иса",
  "рокхамптон",
  "таунсвилл",
  "тувумба",
  "албури",
  "армидейл",
  "батурст",
  "брокен-хилл",
  "вагга-вагга",
  "воллонгонг",
  "гоулбурн",
  "дуббо-дуббо",
  "коффс-харбор",
  "куэнбиан",
  "лисмор",
  "ньюкастл",
  "оранж",
  "сидней",
  "тамворт",
  "алис спрингс",
  "дарвин",
  "девонпорт",
  "лаункестон",
  "хобарт",
  "канберра",
  "аделаида",
  "маунт-гамбир",
  "вена",
  "велс",
  "линц",
  "стир",
  "зальцбург",
  "виллач",
  "клагенфурт",
  "венер-нойштадт",
  "грац",
  "иннсбрук",
  "леобен",
  "агдам",
  "агдаш",
  "агджабеди",
  "аджикенд",
  "акстафа",
  "али-байрамлы",
  "алунитаг",
  "артем-остров",
  "астара",
  "ахсу",
  "баку",
  "балаханы",
  "банк",
  "барда",
  "белоканы",
  "бинагади",
  "бирмай",
  "бузовна",
  "варташен",
  "гадрут",
  "геокчай",
  "гобустан",
  "горадиз",
  "гэтргян",
  "дальмамедли",
  "дашкесан",
  "джалилабад",
  "джебраил",
  "дивичи",
  "евлах",
  "ждановск",
  "закаталы",
  "зангелан",
  "зардоб",
  "имишли",
  "исмаиллы",
  "истису",
  "казанбулак",
  "казах",
  "кази-магомед",
  "карачала",
  "касум-исмаилов",
  "кахи",
  "кедабек",
  "кельбаджар",
  "кергез",
  "кировобад",
  "кировск",
  "кировский",
  "куба",
  "кубатлы",
  "куткашен",
  "кюрдамир",
  "ленкорань",
  "лерик",
  "маргуни",
  "мардакерт",
  "масаллы",
  "маштага",
  "мингечаур",
  "мир-башир",
  "нафталан",
  "нефтечала",
  "пушкино",
  "саатлы",
  "сабирабад",
  "сабуичи",
  "сальяны",
  "сиазань",
  "сумгаит",
  "тауз",
  "уджары",
  "физули",
  "ханлар",
  "хачмас",
  "худат",
  "шамхор",
  "шаумяновск",
  "шеки",
  "шемаха",
  "ярдымлы",
  "степанокерт",
  "шуша",
  "джульфа",
  "ильичевск",
  "нахичевань",
  "ордубад",
  "шахбуз",
  "ангуилья",
  "сомбреро",
  "азул",
  "байя-бланка",
  "буэнос-айрес",
  "кампана",
  "ла-плата",
  "мар-дель-плата",
  "мерседес",
  "некочеа",
  "олаварриа",
  "пергамино",
  "пунта-альта",
  "сан-николас",
  "тандил",
  "трес-арройос",
  "чивилкой",
  "хухуй",
  "катамарка",
  "альта-грасия",
  "вилла-мариа",
  "кордова",
  "рио-куарто",
  "сан-франсиско",
  "гойя",
  "корриентес",
  "женераль-рока",
  "санта-роза",
  "ла-риойя",
  "мендоза",
  "сан-рафаель",
  "посадас",
  "ньюкуэн",
  "салта",
  "сан-луис",
  "сан-хуан",
  "рио-галльегос",
  "росарио",
  "санта-фе",
  "сантьяго-дел-эстеро",
  "тукуман",
  "формоза",
  "пресиденсиа-рокуэ-сенз",
  "ресистенсиа",
  "комодоро-ривадавия",
  "конкордиа",
  "консепсион-дель-уругвай",
  "парана",
  "ереван",
  "антополь",
  "барановичи",
  "белоозерск",
  "береза",
  "береза картуска",
  "брест",
  "высокое",
  "ганцевичи",
  "городище",
  "давид-городок",
  "домачево",
  "дрогичин",
  "жабинка",
  "ивацевичи",
  "каменец",
  "кобрин",
  "лунинец",
  "ляховичи",
  "малорита",
  "минск",
  "пружаны",
  "столин",
  "барань",
  "бегомль",
  "бешенковичи",
  "богушевск",
  "браслав",
  "верхнедвинск",
  "ветрино",
  "видзы",
  "витебск",
  "воропаево",
  "глубокое",
  "городок",
  "дисна",
  "докшицы",
  "друя",
  "дубровно",
  "езерище",
  "лепель",
  "лиозно",
  "миоры",
  "новополоцк",
  "орша",
  "полоцк",
  "поставы",
  "россоны",
  "сенно",
  "толочин",
  "ушачи",
  "чашники",
  "шарковщина",
  "шумилино",
  "белицк",
  "большевик",
  "брагин",
  "буда-кошелево",
  "василевичи",
  "васильевка",
  "ветка",
  "гомель",
  "добруш",
  "ельск",
  "житковичи",
  "жлобин",
  "калинковичи",
  "корма",
  "лельчицы",
  "лоев",
  "мозырь",
  "наровля",
  "октябрьский",
  "петриков",
  "речица",
  "рогачев",
  "светлогорск",
  "хойники",
  "чечерск",
  "большая берестовица",
  "волковыск",
  "вороново",
  "гродно",
  "желудок",
  "зельва",
  "ивье",
  "козловщина",
  "кореличи",
  "лида",
  "мосты",
  "новогрудок",
  "островец",
  "ошмяны",
  "свислочь",
  "слоним",
  "сморгонь",
  "щучин",
  "березино",
  "бобр",
  "борисов",
  "вилейка",
  "воложин",
  "городея",
  "дзержинск",
  "жодино",
  "заславль",
  "зеленый бор",
  "ивенец",
  "клецк",
  "копыль",
  "крупки",
  "логойск",
  "марьина горка",
  "пинск",
  "молодечно",
  "мядель",
  "несвиж",
  "слуцк",
  "смолевичи",
  "солигорск",
  "старые дороги",
  "столбцы",
  "узда",
  "червень",
  "белыничи",
  "бобруйск",
  "быхов",
  "глуск",
  "глуша",
  "горки",
  "гродзянка",
  "елизово",
  "климовичи",
  "кличев",
  "костюковичи",
  "краснополье",
  "кричев",
  "круглое",
  "могилев",
  "мстиславль",
  "осиповичи",
  "славгород",
  "хотимск",
  "чаусы",
  "чериков",
  "шклов",
  "белиз-сити",
  "антверпен",
  "мешлен",
  "брюссель",
  "алост",
  "сант-никлас",
  "бруже",
  "куртра",
  "роселар",
  "генк",
  "льеж",
  "сераинг",
  "ла-лювьер",
  "шарлеруа",
  "гамильтон",
  "бургас",
  "варна",
  "велико тарново",
  "горна джумая",
  "видин",
  "габрово",
  "пазарджик",
  "перник",
  "плевен",
  "асеновград",
  "пловдив",
  "рус",
  "силистра",
  "сливен",
  "софия",
  "казанлак",
  "стара загора",
  "димитровград",
  "кхасково",
  "шумен",
  "ямбол",
  "рио-бранко",
  "арапирака",
  "макейо",
  "манаус",
  "макапа",
  "алагойнас",
  "байя",
  "виториа-да-конкиста",
  "витория",
  "жекуи",
  "жуазейро",
  "илхеус",
  "итабуна",
  "итапетинга",
  "сальвадор",
  "санта-мария",
  "фейра-де-сантана",
  "анаполис",
  "гояния",
  "бакабаль",
  "кахиас",
  "куйяба",
  "кампо-гранде",
  "корумба",
  "трес-лагоас",
  "арха",
  "барбасена",
  "белу-оризонти",
  "варгина",
  "говернадор-валадарес",
  "дивинополис",
  "жуис-де-фора",
  "итажуба",
  "каратинга",
  "катагуасес",
  "монтес-кларос",
  "пассос",
  "покос-де-кальдас",
  "сан-жоау-дель-рей",
  "теофилу-отони",
  "убераба",
  "уберландиа",
  "белен",
  "сантарем",
  "жоао-пессоа",
  "кажазейрас",
  "кампина-гранде",
  "куритиба",
  "лондрина",
  "паранагуа",
  "понтахгросса",
  "гаранхунс",
  "каруару",
  "олинда",
  "петролина",
  "ресифе",
  "парнаиба",
  "тересина",
  "вольта-редонда",
  "кампос",
  "масау",
  "нитерои",
  "параиба-ду-сул",
  "петрополис",
  "рио-де-жанейро",
  "кайку",
  "моссору",
  "наталь",
  "алегрете",
  "баге",
  "кахиас-до-сул",
  "качоэйра-до-сул",
  "круз-альта",
  "пассо-фундо",
  "пелотас",
  "порту-алегри",
  "рио-гранде",
  "сан-леопольдо",
  "сантана-до-ливраменто",
  "санто-ангело",
  "уругвайяна",
  "порту-велью",
  "аракатуба",
  "арараквира",
  "барретос",
  "бауру",
  "бебедоуро",
  "ботукату",
  "жау",
  "жундиаи",
  "кампинас",
  "катандува",
  "лимейра",
  "линс",
  "марилия",
  "пиракикаба",
  "пресиденте-пруденте",
  "рибейрао-прето",
  "сан-бернардо-ду-кампу",
  "сан-жоау-да-боа-виста",
  "сан-паулу",
  "сан-хосе-до-рио-прето",
  "сантос",
  "сорокаба",
  "таубати",
  "франка",
  "арагуари",
  "блуменау",
  "жоинвиле",
  "итажаи",
  "лахес",
  "тубарао",
  "флорианополис",
  "жуазейру-ду-норте",
  "игуату",
  "крато",
  "собраль",
  "форталеза",
  "аракажу",
  "бразилия",
  "качоэйру-де-итапемирим",
  "колатина",
  "абингдон",
  "айлесбюри",
  "аккрингтон",
  "алдершот",
  "алтринчам",
  "андовер",
  "аштон-андер-лин",
  "аштон-ин-макерфилд",
  "байдфорд",
  "банбери",
  "банстед",
  "барнли",
  "барнсли",
  "барнстапл",
  "барроу-ин-фарнесс",
  "бартон-он-трент",
  "бас",
  "басингсток",
  "батли",
  "беверли",
  "бедворт",
  "бедфорд",
  "бексли",
  "бервик-он-твид",
  "биркенхед",
  "бирмингем",
  "бистон",
  "бишоп-окленд",
  "блэкберн",
  "блэкпул",
  "болтон",
  "боримут",
  "бостон",
  "брадфорд",
  "брайтон",
  "брентвуд",
  "бриджуотер",
  "бридлингтон",
  "бристоль",
  "бромсгров",
  "бури",
  "бури-сант-эдмондс",
  "бутл",
  "валласи",
  "валлсенд",
  "валсалл",
  "валтон",
  "варвик",
  "варрингтон",
  "ватерлоо",
  "ватфорд",
  "вейкфилд",
  "велвин-гарден-сити",
  "вест-бромвич",
  "вестон-супер-мар",
  "виган",
  "виднес",
  "вимоут",
  "виндзор",
  "винчестер",
  "висбеч",
  "вокинг",
  "вокингем",
  "ворчестер",
  "вулвергемптон",
  "гейтшид",
  "глоссоп",
  "глочестер",
  "годалминг",
  "голборн",
  "госпорт",
  "госфорт",
  "грантхем",
  "гримсби",
  "грисби",
  "грэйт-ярмут",
  "гуилдфорд",
  "дадли",
  "дарлингтон",
  "дартфорд",
  "дерби",
  "джерроу",
  "донкастер",
  "дувр",
  "дурхем",
  "дьюсбури",
  "ексетер",
  "ипсвич",
  "ист-гринстед",
  "истлейг",
  "йорк",
  "каннок",
  "карлисл",
  "карлтон",
  "кастлфорд",
  "кейгли",
  "кембридж",
  "кендал",
  "кенилворт",
  "кентербери",
  "кеттеринг",
  "киддерминстер",
  "кингс-линн",
  "киркби",
  "клактон-он-си",
  "ковентри",
  "колчестер",
  "корби",
  "кристчерч",
  "кросби",
  "кроули",
  "крю",
  "ланкастер",
  "лаустофт",
  "лейг",
  "ливерпуль",
  "лидс",
  "линкольн",
  "литам-сант-аннес",
  "литерхед",
  "литлгемптон",
  "личфилд",
  "лондон",
  "лугборо",
  "лутон",
  "майденхед",
  "майдстоун",
  "макклесфилд",
  "мансфилд",
  "манчестер",
  "маргейт",
  "миддлсбро",
  "миддлтаун",
  "морли",
  "наилси",
  "норвич",
  "нортвич",
  "нортгемптон",
  "нортфлит",
  "ноттингем",
  "нунитон",
  "ньюарк",
  "ньюкасл-он-тайн",
  "ньюкастле-андер-лим",
  "ньюпорт",
  "олдхам",
  "ормскирк",
  "оссетт",
  "падси",
  "пайнтон",
  "пензанк",
  "петерборо",
  "петерли",
  "плимут",
  "портсмут",
  "прескот",
  "престон",
  "пул",
  "рагби",
  "радклифф",
  "райд",
  "рамсгейт",
  "ранкорн",
  "реддитч",
  "редкар",
  "рейгейт",
  "рейли",
  "ридинг",
  "роиал-тунбридж-уэллс",
  "ротерхам",
  "рочестер",
  "рошдейл",
  "салфорд",
  "сандерленд",
  "сант-албанс",
  "сант-аустель",
  "сант-хеленс",
  "саттон-ин-ашфилд",
  "саут-шилдс",
  "саутгэмптон",
  "саутенд-он-си",
  "саутпорт",
  "сванли",
  "свиндон",
  "свинтон",
  "севеноакс",
  "сейл",
  "сейлсбури",
  "ситтингборн",
  "сихам",
  "сканторп",
  "скарборо",
  "слоуг",
  "солихалл",
  "стайнс",
  "стаффорд",
  "стенли",
  "стивенейдж",
  "стокпорт",
  "стоктон",
  "стоктон-он-тис",
  "стоурбридж",
  "стратфорд-он-эйвон",
  "стретфорд",
  "строуд",
  "татчхем",
  "таунтон",
  "тонбридж",
  "торкуэй",
  "торнаби-он-тис",
  "траубридж",
  "уайтхейен",
  "урмстон",
  "фалмаут",
  "фарнборо",
  "фарнворт",
  "фарнхем",
  "фейрхам",
  "феликстов",
  "флитвуд",
  "фолькстон",
  "формби",
  "хавант",
  "хаддерсфилд",
  "хазел-гров",
  "хай-викомб",
  "халифакс",
  "харлоу",
  "харпенден",
  "харрогейт",
  "хартлепул",
  "хастингс",
  "хатфилд",
  "хейвардс-хит",
  "хейлсовен",
  "хемел-хемпстед",
  "херефорд",
  "хертфорд",
  "хивуд",
  "хид",
  "хиндли",
  "хинкли",
  "хойлайк",
  "хорсхем",
  "хоув",
  "хьютон-вит-роби",
  "чапелтаун",
  "чатхем",
  "челмсфорд",
  "челтенхам",
  "честер",
  "честерфилд",
  "чешант",
  "чичестер",
  "чорли",
  "шеффилд",
  "шипли",
  "шревсбури",
  "эллесмер-порт",
  "эпсом",
  "эшер",
  "эшфорд",
  "баллимена",
  "бангор",
  "белфаст",
  "колерайн",
  "лондондерри",
  "ньюри",
  "ньютаунабби",
  "абердар",
  "барри",
  "врексхам",
  "кардифф",
  "керфилли",
  "мертир-тидвил",
  "порт талбот",
  "рондда",
  "сванси",
  "абердин",
  "айрдри",
  "арброат",
  "глазго",
  "гринок",
  "данди",
  "данфермлин",
  "думбартон",
  "думфрис",
  "инвернесс",
  "ирвин",
  "ист-килбрайд",
  "камберналд",
  "килмарнок",
  "кирккалди",
  "коатбридж",
  "мотервелл",
  "паисли",
  "ренфро",
  "стирлинг",
  "фалкирк",
  "хамилтон",
  "эдинбург",
  "сольнок",
  "яшберены",
  "печ",
  "кечкемет",
  "кискунфелегихаза",
  "бекешсаба",
  "мишкольц",
  "озд",
  "будапешт",
  "жомбатели",
  "вешпрем",
  "сопрон",
  "залегержег",
  "нагиканиша",
  "татабаня",
  "салготарян",
  "сеглед",
  "ныйрегихаза",
  "дунауйварош",
  "шекесфехервар",
  "дебрецен",
  "хайдубошормены",
  "гионгиос",
  "эгер",
  "сегед",
  "сентес",
  "ходмезовасархели",
  "кан-то",
  "рач-гиа",
  "нам-динх",
  "хайфон",
  "ханой",
  "вунг-тау",
  "сайгон",
  "дананг",
  "нячанг",
  "пхан-тхит",
  "туи-хоа",
  "винь",
  "хуэ",
  "хон-гаи",
  "плейку",
  "гонаивес",
  "джереми",
  "порт-де-пакс",
  "порт-о-пренс",
  "лес-кайес",
  "джакмель",
  "пойнт-а-питр",
  "бассе-терре",
  "берлин",
  "бранденбург",
  "котбус",
  "потсдам",
  "франкфурт-на-одере",
  "висмар",
  "грейфсвальд",
  "гюстров",
  "нойебранденбург",
  "росток",
  "шверин",
  "штральзунд",
  "баутцен",
  "герлиц",
  "дрезден",
  "лейпциг",
  "мейссен",
  "пирна",
  "плауэн",
  "радебюль",
  "риса",
  "фрейтал",
  "хемниц",
  "хойерсверда",
  "цвикау",
  "циттау",
  "бернбург",
  "вейссенфельс",
  "виттенберг",
  "дессау",
  "зейтз",
  "магдебург",
  "мерсебург",
  "халберштадт",
  "шонебек",
  "альтенбург",
  "веймар",
  "вернигероде",
  "гера",
  "гота",
  "йена",
  "мёлхаусен",
  "нордхаузен",
  "эизенах",
  "эрфурт",
  "амберг",
  "аугсбург",
  "ашхаффенбург",
  "бамберг",
  "бэйреут",
  "вейден",
  "вюрцбург",
  "ерланген",
  "ингольштадт",
  "кемптен",
  "кобург",
  "ландсхут",
  "нюрнберг",
  "пасау",
  "регенсбург",
  "фурт",
  "хоф",
  "швейнфурт",
  "баден-баден",
  "гоппинген",
  "зинделфинген",
  "карлсруэ",
  "констанц",
  "людвигсбург",
  "мангейм",
  "пфорзхейм",
  "рютлинген",
  "тюбинген",
  "ульм",
  "фрейберг",
  "фридрихсхафен",
  "хейдельберг",
  "хейденхейм-ан-дер-бренц",
  "хейлбронн",
  "швабиш-гмунд",
  "штутгарт",
  "эсслинген",
  "бремен",
  "бремерхавен",
  "гамбург",
  "бад-хомбург-вор-дер-хох",
  "висбаден",
  "гиссен",
  "дармштадт",
  "кассель",
  "марбург-ан-дер-лан",
  "оффенбах",
  "руссельшейм",
  "франкфурт-на-майне",
  "фульда",
  "ханау",
  "вильгельмсхавен",
  "волфенбуттель",
  "вольфсбург",
  "ганновер",
  "гослар",
  "готтинген",
  "дельменхорст",
  "куксхавен",
  "лунебург",
  "нордхорн",
  "олденбург",
  "оснабрюк",
  "селл",
  "хамельн",
  "хильдешейм",
  "эмден",
  "бад-крейцнах",
  "вормс",
  "кайзерслаутерн",
  "кобленц",
  "людвигшафен",
  "майнц",
  "ньюштадт-ан-дер-вейнштрассе",
  "пирмасенс",
  "спейер",
  "трир",
  "франкенталь",
  "ньюнкирхен",
  "саарбрюкен",
  "аахен",
  "айзерлон",
  "ален",
  "бад-зальцуфлен",
  "бергиш-гладбах",
  "билефельд",
  "бонн",
  "бохольт",
  "бохум",
  "брул",
  "весел",
  "вирсен",
  "виттен",
  "вупперталь",
  "гельзенкирхен",
  "гуммерсбах",
  "гутерсло",
  "детмольд",
  "дойсбург",
  "дурен",
  "дюссельдорф",
  "золинген",
  "кёльн",
  "крефельд",
  "леверкузен",
  "липпштадт",
  "лунен",
  "люденсхейд",
  "малхейм-ан-дер-рур",
  "марл",
  "минден",
  "монхенгладбах",
  "мюнстер",
  "ньюсс",
  "оберхаузен",
  "падерборн",
  "ратинген",
  "рейн",
  "ремшейд",
  "сест",
  "зиген",
  "стендаль",
  "хаген",
  "харт",
  "херн",
  "херфорд",
  "эскирхен",
  "эссен",
  "киль",
  "любек",
  "фленсбург",
  "эльмсхорн",
  "апельдоорн",
  "арнхем",
  "нижмеген",
  "реден",
  "эд",
  "гронинген",
  "эммен",
  "венло",
  "керкрад",
  "маастрихт",
  "хеерлен",
  "альмело",
  "девентер",
  "хенгело",
  "эншед",
  "алькмаар",
  "амстельвеен",
  "амстердам",
  "велсен",
  "ден-хельдер",
  "хаарлем",
  "хилверсум",
  "бреда",
  "тилбург",
  "хелмонд",
  "эйндховен",
  "амерсфоорт",
  "зейст",
  "утрехт",
  "лееварден",
  "влаардинген",
  "гуда",
  "дельфт",
  "дордрехт",
  "заандам",
  "зволь",
  "лейден",
  "роттердам",
  "хаге",
  "шевенинген",
  "шидам",
  "патры",
  "афины",
  "пирей",
  "драма",
  "александруполис",
  "хания",
  "иоаннина",
  "ираклион",
  "кавалла",
  "волос",
  "фессалоники",
  "авадхара",
  "гагра",
  "гали",
  "гудаута",
  "гульрипш",
  "новый афон",
  "очамчиров",
  "пицунда",
  "сухуми",
  "ткварчели",
  "батуми",
  "кобулети",
  "хуло",
  "абастумани",
  "абаша",
  "агара",
  "адигени",
  "амбролаури",
  "аспиндза",
  "ахалкалаки",
  "ахалцихе",
  "ахмета",
  "бакуриани",
  "богдановка",
  "болниси",
  "боржоми",
  "вани",
  "гардабани",
  "гегечкори",
  "гори",
  "гурджаани",
  "джвари",
  "дманиси",
  "душети",
  "зестафони",
  "зугдиди",
  "казбеги",
  "карели",
  "каспи",
  "кваиси",
  "кварели",
  "коджори",
  "кутаиси",
  "лагодехи",
  "ланчхути",
  "ленингори",
  "лентехи",
  "марнеули",
  "махарадзе",
  "маяковский",
  "местиа",
  "они",
  "орджоникидзе",
  "пасанаури",
  "поти",
  "рустави",
  "сагареджо",
  "самтредиа",
  "сачхере",
  "сигнахи",
  "тбилиси",
  "телави",
  "тержола",
  "тетри-цкаро",
  "тианети",
  "ткибули",
  "хашури",
  "хоби",
  "цагери",
  "цаленджиха",
  "цалка",
  "цители-цкаро",
  "цнори",
  "цулукидзе",
  "цхакая",
  "цхалтубо",
  "чиатура",
  "чохатаури",
  "чхороцку",
  "джава",
  "цхинвали",
  "колдинг",
  "альборг",
  "орхус",
  "рандерс",
  "роскилде",
  "эсбйерг",
  "оденс",
  "каир",
  "асуан",
  "асыут",
  "бени суэф",
  "танта",
  "думият",
  "арад",
  "ашдод",
  "ашкелон",
  "бээр-шева",
  "димона",
  "кирьят-гат",
  "кирьят-малахи",
  "эйлат",
  "бнэй-брак",
  "гэдера",
  "лод",
  "натания",
  "нэс-циона",
  "пэтах-тиква",
  "раанана",
  "рамла",
  "ришон-лецион",
  "рош-ха-аин",
  "рэховот",
  "явне",
  "акко",
  "акко (порт)",
  "афула",
  "кармиэль",
  "кирьят-тивон",
  "кирьят-шмона",
  "нагария",
  "нацэрэт",
  "сахнин",
  "тверия",
  "цфат",
  "хайфа",
  "далият-эль-кармэль",
  "зихрон-яаков",
  "кирьят-бялик",
  "кирьят-моцкин",
  "кирьят-ям",
  "нэшэр",
  "ор-акива",
  "пардэс-ханна",
  "тират-кармэль",
  "хэдэра",
  "бат-ям",
  "герцелия",
  "гиватаим",
  "кирьят-оно",
  "рамат-ган",
  "рамат-хашарон",
  "тель-авив",
  "холон",
  "иерусалим",
  "асансол",
  "байдьябати",
  "балли",
  "банкура",
  "барасат",
  "бхатпара",
  "даржилинг",
  "дум-дум",
  "дургапур",
  "камархати",
  "кришнанагар",
  "кхарагпур",
  "наихати",
  "панихати",
  "титагарх",
  "биласпур",
  "бхилаи",
  "дург",
  "раипур",
  "багалкот",
  "белгаум",
  "беллари",
  "бияпур",
  "гадаг",
  "давангер",
  "колар голд филдс",
  "мангалор",
  "раичур",
  "сагар",
  "тумкур",
  "хоспет",
  "хубли",
  "шимога",
  "дехра дун",
  "сринагар",
  "адони",
  "анакапал",
  "анантапур",
  "визианагарам",
  "вияиавада",
  "гунтакал",
  "гунтур",
  "какинада",
  "куддапах",
  "мачилипатнам",
  "нандиал",
  "низамабад",
  "проддатур",
  "тенали",
  "чирала",
  "читтур",
  "элуру",
  "дибругарх",
  "силчар",
  "беттиах",
  "бихар",
  "бхагалпур",
  "гэйа",
  "дарбханга",
  "катихар",
  "музаффарпур",
  "патна",
  "ахмадабад",
  "бхуй",
  "веравал",
  "годхра",
  "гондал",
  "дхорайи",
  "йодхпур",
  "морви",
  "навсари",
  "надиад",
  "патан",
  "порбандар",
  "райкот",
  "сурат",
  "сурендранагар",
  "юнагадх",
  "ямнагар",
  "дханбад",
  "ранчи",
  "ямму",
  "ямшедпур",
  "кожикод",
  "коттэйам",
  "барейлли",
  "бурханпур",
  "бхопал",
  "гвалиор",
  "дамох",
  "индаур",
  "кхандва",
  "мау",
  "мурвара",
  "ратлам",
  "рева",
  "уйяин",
  "имфал",
  "акола",
  "амальнер",
  "ахалпур",
  "ахмаднагар",
  "барси",
  "бхиванди",
  "бхусавал",
  "вардха",
  "дхулиа",
  "калиан",
  "колхапур",
  "кхамгаон",
  "латур",
  "малегаон",
  "нагпур",
  "нандурбар",
  "пандхарпур",
  "сангли",
  "сатара",
  "тана",
  "улхаснагар",
  "шолапур",
  "шиллонг",
  "пури",
  "рауркела",
  "амритсар",
  "батала",
  "лудхиана",
  "патиала",
  "пондичерри",
  "аймер",
  "альвар",
  "бивар",
  "биканер",
  "бхаратпур",
  "бхилвара",
  "ганганагар",
  "кота",
  "сикар",
  "тонк",
  "удаипур",
  "фатехгарх",
  "чуру",
  "аруппокоттаи",
  "бодинэйакканур",
  "ванииамбади",
  "виллупурам",
  "диндигул",
  "ерод",
  "карур",
  "кумбаконам",
  "мадурай",
  "нагеркоил",
  "пудуккоттаи",
  "раяпалаииам",
  "тируваннамалаи",
  "тирунелвели",
  "тируччираппалли",
  "чидамбарам",
  "агартала",
  "агра",
  "алигар",
  "аллахабад",
  "бахраич",
  "будаун",
  "варанаси",
  "гонда",
  "горакхпур",
  "гхазиабад",
  "етавах",
  "йханси",
  "канпур",
  "матура",
  "мирзапур",
  "морадабад",
  "музаффарнагар",
  "пилибхит",
  "рампур",
  "самбхал",
  "ситапур",
  "фаизабад",
  "фирозабад",
  "хатрас",
  "шахяханпур",
  "амбала",
  "бхивани",
  "карнал",
  "панипат",
  "чандигарх",
  "марагех",
  "тебриз",
  "кашан",
  "хамадан",
  "санандай",
  "арак",
  "захедан",
  "иезд",
  "керман",
  "керманшах",
  "бабол",
  "сари",
  "тегеран",
  "абадан",
  "шираз",
  "бендер-аббас",
  "ахваз",
  "хоррамшахр",
  "корк",
  "дан-логер",
  "дублин",
  "лимерик",
  "луимнич",
  "уотерфорд",
  "сантандер",
  "сеута",
  "гранада",
  "логроно",
  "саламанка",
  "аликанте",
  "алкантара",
  "алкой",
  "альбасете",
  "алмерия",
  "гийон",
  "овьедо",
  "баладона",
  "барселона",
  "манреса",
  "сабадель",
  "тарраса",
  "хоспиталет",
  "бильбао",
  "бургос",
  "валенсия",
  "валладолид",
  "алжекирас",
  "кадис",
  "кацерес",
  "ла-линея",
  "херес-де-ла-фронтера",
  "лас-пальмас-де-гран-канар",
  "леон",
  "лерида",
  "луго",
  "мадрид",
  "малага",
  "мурсия",
  "палма-де-мальорка",
  "виго",
  "паленсия",
  "замора",
  "санта-круз-де-тенерифе",
  "сарагоса",
  "севилья",
  "пуэртоллано",
  "линарес",
  "пескара",
  "альтамура",
  "андрия",
  "бари",
  "бискегли",
  "бриндизи",
  "корато",
  "лечче",
  "мольфетта",
  "сан-северо",
  "таранто",
  "трани",
  "фоджия",
  "верона",
  "виченца",
  "тревисо",
  "катанцаро",
  "косенца",
  "реджио-ди-калабриа",
  "аверса",
  "беневенто",
  "кастелламмаре-ди-стабия",
  "ночера-инфериоре",
  "поццуоли",
  "салерно",
  "торре-аннунциата",
  "торре-дель-греко",
  "рим",
  "генуя",
  "ла-специя",
  "савона",
  "сан-ремо",
  "бергамо",
  "брескиа",
  "бусто-арсизио",
  "варезе",
  "комо",
  "кремона",
  "леччо",
  "мантуя",
  "милан",
  "монца",
  "павия",
  "анкона",
  "песаро",
  "каглиари",
  "сассари",
  "алькамо",
  "витториа",
  "гела",
  "калтагирон",
  "калтаниссетта",
  "катания",
  "ликата",
  "мессина",
  "палермо",
  "патерно",
  "рагуса",
  "сиракузы",
  "трапани",
  "асти",
  "биелла",
  "верцелли",
  "новара",
  "турин",
  "ареццо",
  "виареджио",
  "гроссето",
  "каррара",
  "лючча",
  "масса",
  "пиза",
  "пистойя",
  "прато",
  "сьена",
  "флоренция",
  "больцано",
  "тренто",
  "перуджиа",
  "терни",
  "триест",
  "удин",
  "болонья",
  "модена",
  "парма",
  "пиаченца",
  "равенна",
  "фенца",
  "феррара",
  "форли",
  "актюбинск",
  "акшам",
  "алга",
  "байганин",
  "батамшинский",
  "иргиз",
  "карабутак",
  "мартук",
  "новоалексеевка",
  "октябрьск",
  "уил",
  "хромтау",
  "челкар",
  "шубаркудук",
  "эмба",
  "алма-ата",
  "алматы",
  "баканас",
  "бурундай",
  "иссык",
  "капчагай",
  "каскелен",
  "нарынкол",
  "талгар",
  "узунагач",
  "чилик",
  "чунджа",
  "акжар",
  "алексеевка",
  "асубулак",
  "белогорский",
  "белоусовка",
  "верхнеберезовский",
  "зайсан",
  "зыряновск",
  "карагужиха",
  "катон-карагай",
  "курчум",
  "лениногорск",
  "самарское",
  "серебрянск",
  "усть-каменогорск",
  "шемонаиха",
  "байчунас",
  "балыкши",
  "ганюшкино",
  "атырау(гурьев)",
  "доссор",
  "индерборский",
  "искининский",
  "каратон",
  "кульсары",
  "макат",
  "миялы",
  "акколь",
  "байкадам",
  "брлик",
  "бурное",
  "георгиевка",
  "гранитогорск",
  "джамбул",
  "жанатас",
  "каратау",
  "коктал",
  "луговое",
  "мерке",
  "михайловка",
  "новотроицкое",
  "ойтал",
  "отар",
  "фурмановка",
  "чиганак",
  "чу",
  "агадырь",
  "акжал",
  "актас",
  "актогай",
  "атасу",
  "балхаш",
  "восточно-коунрадский",
  "гульшад",
  "дарьинский",
  "джезды",
  "джезказган",
  "жарык",
  "кайракты",
  "каражал",
  "никольский",
  "сарышаган",
  "тараз",
  "улытау",
  "абай",
  "актау",
  "егиндыбулак",
  "карагайлы",
  "караганда",
  "каркаралинск",
  "киевка",
  "осакаровка",
  "сарань",
  "темиртау",
  "токаревка",
  "топар",
  "ульяновский",
  "шахтинск",
  "аралсульфат",
  "аральск",
  "джалагаш",
  "джусалы",
  "казалинск",
  "кзыл-орда",
  "новоказалинск",
  "тасбугет",
  "чиили",
  "яныкурган",
  "айдабул",
  "боровое",
  "володарское",
  "зеренда",
  "келлеровка",
  "кзылту",
  "кокчетав",
  "красноармейск",
  "красный яр",
  "куйбышевский",
  "ленинградское",
  "рузаевка",
  "степняк",
  "талшик",
  "чистополье",
  "чкалово",
  "щучинск",
  "боровской",
  "джетыгара",
  "затобольск",
  "камышное",
  "комсомолец",
  "кустанай",
  "кушмурун",
  "ленинское",
  "лисаковск",
  "рудный",
  "семиозерное",
  "тобол",
  "урицкий",
  "баутино",
  "бейнеу",
  "новый узень",
  "форт-шевченко",
  "шевченко",
  "баянаул",
  "ермак",
  "железинка",
  "иртышск",
  "калкаман",
  "краснокутск",
  "лебяжье",
  "майкаин",
  "павлодар",
  "успенка",
  "щербакты",
  "экибастуз",
  "благовещенка",
  "булаево",
  "корнеевка",
  "мамлютка",
  "петропавловск",
  "пресновка",
  "сергеевка",
  "соколовка",
  "явленка",
  "аксуат",
  "ауэзов",
  "аягуз",
  "баршатас",
  "бельагаш",
  "боко",
  "большая владимировка",
  "бородулиха",
  "жангизтобе",
  "жарма",
  "кайнар",
  "кокпекты",
  "маканчи",
  "новая шульба",
  "семипалатинск",
  "таскескен",
  "урджар",
  "чарск",
  "андреевка",
  "джансугуров",
  "капал",
  "карабулак",
  "кугалы",
  "панфилов",
  "сарканд",
  "сарыозек",
  "талды-курган",
  "текели",
  "учарал",
  "уштобе",
  "амангельды",
  "аркалык",
  "державинск",
  "есиль",
  "жаксы",
  "октябрьское",
  "тургай",
  "акбеит",
  "акмолинск",
  "аксу",
  "астана",
  "астраханка",
  "атабасар",
  "балкащино",
  "бестобе",
  "вишневка",
  "ерментау",
  "жалтыр",
  "жолымбет",
  "кургальджинский",
  "макинск",
  "целиноград",
  "шортанды",
  "арысь",
  "ачисай",
  "байжансай",
  "белые воды",
  "ванновка",
  "джетысай",
  "кентау",
  "ленгер",
  "сарыагач",
  "темирлановка",
  "туркестан",
  "чардара",
  "чаян",
  "чимкент",
  "чулаккурган",
  "шаульдер",
  "дуала",
  "виктория",
  "гаруа",
  "яунде",
  "гранд-праири",
  "калгари",
  "летбридж",
  "медикин-хат",
  "ред-дир",
  "сант-альберт",
  "эдмонтон",
  "бурнаби",
  "ванкувер",
  "вернон",
  "вест-ванкувер",
  "дельта",
  "камлупс",
  "кампбелл-ривер",
  "коквитлам",
  "мапл-ридж",
  "миссион-сити",
  "нанаимо",
  "норт-ванкувер",
  "нью-вестминстер",
  "порт-коквитлам",
  "порт-муди",
  "принц-джордж",
  "ричмонд",
  "сарри",
  "чилливак",
  "аутремонт",
  "боучервилл",
  "броссард",
  "бьюпорт",
  "вердан",
  "вестмаунт",
  "викториавилл",
  "джонкуир",
  "доллард-дес-ормо",
  "драммондвилл",
  "квебек",
  "лаваль",
  "левис",
  "монреаль",
  "пиррифондс",
  "репентигни",
  "римауски",
  "роуин",
  "сант-хуберт",
  "сорел",
  "труа-ривьер",
  "халл",
  "чарльсбург",
  "чатогуэй",
  "чикоутими",
  "шербрук",
  "элма",
  "брандон",
  "виннипег",
  "галифакс",
  "дартмут",
  "монктон",
  "сент-джон",
  "фредериктон",
  "корнер-брук",
  "сент-джонс",
  "аврора",
  "анкастер",
  "аякс",
  "барлингтон",
  "беллвилл",
  "брамптон",
  "брантфорд",
  "броквилл",
  "вауган",
  "велланд",
  "витби",
  "вудсток",
  "гуэлф",
  "каледон",
  "кингстон",
  "китченер",
  "корнуолл",
  "ла-саль",
  "маркхам",
  "миссиссуга",
  "ниагара-фоллс",
  "норт-бэй",
  "оаквилл",
  "овен-саунд",
  "ориллиа",
  "оттава",
  "ошава",
  "пикеринг",
  "ричмонд-хилл",
  "садбури",
  "сант-катаринс",
  "сант-томас",
  "сарниа",
  "солт-сант-мари",
  "стони-крик",
  "стратфорд",
  "тимминс",
  "торонто",
  "тундер бэй",
  "форт-эри",
  "шарлоттаун",
  "мус-яв",
  "реджайна",
  "саскатун",
  "лимассол",
  "никосия",
  "фамагуста",
  "ак-шыйрак",
  "ананьево",
  "боконбаевское",
  "бостери",
  "каджи-сай",
  "кызыл туу",
  "покровка",
  "пржевальск",
  "рыбачье",
  "тюп",
  "чолпон-ата",
  "бишкек",
  "бордунский",
  "быстровка",
  "ивановка",
  "каинды",
  "кант",
  "кара-балта",
  "соколук",
  "токмак",
  "фрунзе",
  "ат-баши",
  "дюрбельджин",
  "казарман",
  "кочкорка",
  "кош-дебе",
  "мин-куш",
  "нарын",
  "сары-булак",
  "суусамыр",
  "угют",
  "чаек",
  "чолпон",
  "ак-там",
  "ала-бука",
  "араван",
  "арсланбоб",
  "базар-курган",
  "баткен",
  "гульча",
  "джалал-абад",
  "исфана",
  "кара-кульджа",
  "кара-суу",
  "караван",
  "карамык",
  "кок-янгак",
  "кызыл-кия",
  "майли-сай",
  "ош",
  "сары-таш",
  "сопу-коргон",
  "сулюкта",
  "таш-кумыр",
  "узген",
  "хайдаркен",
  "аманбаево",
  "кара-куль",
  "кировское",
  "ленинполь",
  "талас",
  "токтогул",
  "толук",
  "урумчи",
  "хами",
  "баотоу",
  "хайлар",
  "ланьчжоу",
  "пинглианг",
  "юмень",
  "наннинг",
  "аншань",
  "далянь",
  "ляоян",
  "шэньян",
  "иаан",
  "суининг",
  "нанпинг",
  "ухань",
  "шаси",
  "иянг",
  "чангша",
  "шихайкванг",
  "харбин",
  "кайфенг",
  "нанянь",
  "лиаоиуан",
  "чанчунь",
  "нанчанг",
  "иангчау",
  "нанкин",
  "венчоу",
  "нингпо",
  "ханчоу",
  "шаохинь",
  "шанхай",
  "вейфанг",
  "тайюань",
  "алагуела",
  "либериа",
  "хередиа",
  "лимон",
  "пунтаренас",
  "сан-хосе",
  "аль-яхра",
  "эль-кувейт",
  "айзпуте",
  "айнажи",
  "алоя",
  "алсунга",
  "алуксне",
  "апе",
  "ауце",
  "балви",
  "балдоне",
  "баложи",
  "бауска",
  "бене",
  "броцены",
  "валдемарпилс",
  "валка",
  "валмиера",
  "варакляны",
  "вентспилс",
  "виесите",
  "виляка",
  "виляны",
  "гробиня",
  "гулбитис",
  "гульбене",
  "даугавпилс",
  "добеле",
  "дундага",
  "дурбе",
  "елгава",
  "зилупе",
  "иецава",
  "илуксте",
  "калнциемс",
  "кандава",
  "карсава",
  "кегумс",
  "кокнесе",
  "колка",
  "краслава",
  "кулдига",
  "ливаны",
  "лиепая",
  "лимбажи",
  "лудза",
  "мадона",
  "огре",
  "плявиняс",
  "прейли",
  "резекне",
  "рига",
  "салдус",
  "сигулда",
  "стучка",
  "талси",
  "тукумс",
  "цесис",
  "экабпилс",
  "элея",
  "юрмала",
  "триполи",
  "бенгази",
  "адутишкис",
  "алитус",
  "аникщчяй",
  "ариогала",
  "балтойи-воке",
  "бальберишкис",
  "биржай",
  "бирштонас",
  "вабальнинкас",
  "ванджиогала",
  "варена",
  "варняй",
  "вейсеяй",
  "виевис",
  "вилкавишкис",
  "вилькия",
  "вильно",
  "вильнюс",
  "вирбалис",
  "гаргждай",
  "гарлява",
  "гелгаудишкис",
  "гиедрайчяй",
  "даугай",
  "дотнува",
  "друскининкай",
  "дукштас",
  "дусетос",
  "езнас",
  "ейшишес",
  "жагаре",
  "жямайчю наумиестис",
  "зарасай",
  "игналина",
  "ионишкис",
  "йодкранте",
  "йонава",
  "казлу-руда",
  "кайшядорис",
  "калвария",
  "капсукас",
  "каунас",
  "качергине",
  "кедайняй",
  "кельме",
  "кибартай",
  "клайпеда",
  "ковно",
  "кретинга",
  "кудиркос наумиестис",
  "кулаутува",
  "куодас",
  "купишкис",
  "куршенай",
  "лаздияй",
  "лейпалингис",
  "лентварис",
  "мажейкяй",
  "майшягала",
  "меркине",
  "молетай",
  "науйойи-акмяне",
  "неринга",
  "пабраде",
  "пагегяй",
  "пакруоис",
  "паланга",
  "паневежис",
  "пасвалис",
  "плунге",
  "прейла",
  "приекуле",
  "приенай",
  "рагува",
  "радвилишкис",
  "расейняй",
  "риетавас",
  "рокишкис",
  "русне",
  "салантай",
  "симнас",
  "скаудвиле",
  "таураге",
  "тельшяй",
  "тракай",
  "укмерге",
  "утена",
  "шакяй",
  "шальчининкай",
  "швенченеляй",
  "швенчионис",
  "шета",
  "шилале",
  "шилуте",
  "ширвинтос",
  "шяуляй",
  "эжярелис",
  "юрбаркас",
  "люксембург",
  "агуаскалинтес",
  "акаюкан",
  "алтотонга",
  "альварадо",
  "веракрус",
  "коатепек",
  "коатцакоалькос",
  "кордоба",
  "косамалоапан (де карпио)",
  "мартинес-де-ла-торре",
  "минатитлан",
  "оризаба",
  "пануко",
  "папантла (де оларте)",
  "поза-рика-де-хидальго",
  "сан-андрес-тукстла",
  "тихуатлан",
  "тукспан-де-родригес-кано",
  "тьерра-бланка",
  "акапулько",
  "игуала",
  "такско-де-аларкон",
  "текпан-де-галина",
  "телолоапан",
  "чилпанкинго",
  "акамбаро",
  "валле-де-сантъяго",
  "гуанахуато",
  "ирапуато",
  "леон (де лос альдамас)",
  "пенхамо",
  "селая",
  "силао",
  "гомес-палацио",
  "дуранго",
  "канатлан",
  "сьюдад-лердо",
  "гуэхутла-де-рейес",
  "иксмикуилпан",
  "пачука (де сото)",
  "туланкинго",
  "кампеч",
  "куэретаро",
  "четумал",
  "матаморос",
  "монклова",
  "пьедрас-неграс",
  "салтилло",
  "торреон",
  "фронтера",
  "колима",
  "манзанилло",
  "текоман",
  "куаутитлан",
  "наукалпан",
  "текскоко (де мора)",
  "толука (де лердо)",
  "хилотепек-де-абасоло",
  "чалко",
  "апачинган",
  "закапу",
  "замора-де-хидальго",
  "зитакуаро",
  "ла-пидад (кавадас)",
  "морелиа",
  "пацкуаро",
  "пуруандиро",
  "сахуэйо",
  "куаутла-морелос",
  "куэрнавака",
  "хохутла",
  "акапонета",
  "компостела",
  "текуала",
  "тепик",
  "мехикали",
  "тиюана",
  "энсенада",
  "кадерита-хименес",
  "монтеррей",
  "оаксака (де хуарес)",
  "почутла",
  "техуантепек",
  "тлаколула (де матаморос)",
  "тукстепек",
  "хуахуапан-де-леон",
  "хучитан (де сарагоса)",
  "ицукар-де-матаморос",
  "пуэбла (де зарагоза)",
  "техуакан",
  "хуаучинанго",
  "закатекас",
  "сан-мигель",
  "сомбререт",
  "фреснилло",
  "матехуала",
  "риоверде",
  "сан-луис-потоси",
  "сбюдад-де-валлес",
  "херез-де-гарсиа-салинас",
  "гуасейв",
  "кулиакан",
  "мазатлан",
  "эскуинапа (де хидальго)",
  "гуэймас",
  "емпалм",
  "навохоа",
  "сан-луис-рио-колорадо",
  "сьюдад-обрегон",
  "хермосилло",
  "хероика-ногалес",
  "хуатабампо",
  "виллахермоса",
  "макуспана",
  "хуимангуилло",
  "валле-хермосо",
  "нуэво-ларедо",
  "риноса",
  "сьюдад-мадеро",
  "тампико",
  "чиудад-викториа",
  "мехико",
  "амека",
  "арандас",
  "атотонилко",
  "аутлан-де-наварро",
  "гвадалахара",
  "ла-барка",
  "лагос-де-морено",
  "сьюдад-гузман",
  "тепатитлан (де морелос)",
  "чиуауа",
  "комитан (де домингес)",
  "тапачула",
  "тонала",
  "тукстла-гутьеррес",
  "чинталапа-де-фигуэра",
  "мерида",
  "атаки",
  "бельцы",
  "бендеры",
  "бессарабка",
  "бричаны",
  "быковец",
  "вулканешты",
  "глодяны",
  "григориополь",
  "дондюшаны",
  "дрокия",
  "дубоссары",
  "единцы",
  "кагул",
  "калараш",
  "каменка",
  "каушаны",
  "кишинев",
  "комрат",
  "корнешты",
  "котовск",
  "криуляны",
  "леово",
  "ниспорены",
  "новые анены",
  "окница",
  "оргеев",
  "резина",
  "рыбница",
  "рышканы",
  "слободзея",
  "сороки",
  "страшены",
  "тараклия",
  "теленешты",
  "тирасполь",
  "унгены",
  "фалешты",
  "флорешты",
  "чадыр-лунга",
  "чимишлия",
  "чишмикиой",
  "монако",
  "монте-карло",
  "манукау",
  "окленд",
  "роторуа",
  "тауранга",
  "ашбуртон",
  "тимару",
  "гисборн",
  "напир",
  "вангануи",
  "палмерстон-норт",
  "бленхейм",
  "нельсон",
  "вангарей",
  "дунедин",
  "гор",
  "инверкаргилл",
  "нью-плимут",
  "хавера",
  "таупо",
  "веллингтон",
  "ловер-хатт",
  "мастертон",
  "греймоут",
  "драммен",
  "кристиансанд",
  "нарвик",
  "осло",
  "ставангер",
  "тронхейм",
  "скин",
  "берген",
  "билава",
  "богатыня",
  "болеславец",
  "валбржич",
  "вроцлав",
  "вроцлав оа",
  "глогов",
  "дзирзонев",
  "желеня-гора",
  "згорзелец",
  "клодзко",
  "легница",
  "любан",
  "нова-руда",
  "олава",
  "олесница",
  "полковице",
  "свибоджице",
  "свидница",
  "явор",
  "бродница",
  "быдгощ",
  "влоцлавек",
  "грудзядзь",
  "иновроцлав",
  "накло-над-нотеча",
  "свечье",
  "торун",
  "челмно",
  "горзов-виелкопольски",
  "заган",
  "зары",
  "зелона-гора",
  "меджиржеч",
  "нова-сол",
  "свебоджин",
  "андрыхов",
  "бочния",
  "горлице",
  "закопане",
  "краков",
  "краков (обс. ул. коперника)",
  "краков (обс. форт скала)",
  "краков (ш. им. еромского)",
  "краков (ш. им. нарутауича)",
  "краков (ш. ул. вроклавска)",
  "краков (ш. ул. галла)",
  "краков (ш. ул. коперника)",
  "краков (ш. ул. симирадзка)",
  "науи сач",
  "новы-тарг",
  "олкуш",
  "освецим",
  "скавина",
  "тарнов",
  "хрзанов",
  "варшава",
  "варшава оа пв",
  "варшава оа ув",
  "воломин",
  "вышков",
  "гостынин",
  "гроджиск-мазовецки",
  "жирардов",
  "козенице",
  "легионово",
  "минск-мазовецки",
  "млава",
  "новы-двор-мазовецки",
  "остров-мазовецки",
  "остролека",
  "отвок",
  "пионки",
  "плонск",
  "плоцк",
  "прушков",
  "пьястов",
  "радом",
  "седльце",
  "сохачев",
  "дебица",
  "кросно",
  "мелец",
  "пржемысл",
  "рхешов",
  "санок",
  "сталова-вола",
  "тарнобржег",
  "ярослав",
  "ясло",
  "аугустов",
  "белосток",
  "бельск подласки",
  "граево",
  "замбров",
  "ломжа",
  "сувалки",
  "хайнавка",
  "вейхерово",
  "гданьск",
  "гдыня",
  "квиджин",
  "косцержина",
  "леборк",
  "мальборк",
  "прущ-гданьски",
  "румия",
  "слупск",
  "сопот",
  "старогард-гданьски",
  "тчев",
  "чойнице",
  "беджин",
  "белско-бяла",
  "берун-новы",
  "бытом",
  "водзислав-сласки",
  "гливице",
  "даброваа-горница",
  "живец",
  "забрже",
  "заверцие",
  "зоры",
  "катовице",
  "люблинец",
  "миколов",
  "мысловице",
  "мышков",
  "пекары-слаские",
  "пшчина",
  "пысковице",
  "рачиборз",
  "руда-сласка",
  "рыбник",
  "сосновец",
  "тарновские-горы",
  "тыхи",
  "цеховице-дзедзице",
  "честохова",
  "чешин",
  "чорзов",
  "яворзно",
  "кельце",
  "конские",
  "островец-свитокржиски",
  "сандомерж",
  "скаржиско-каменна",
  "стараховице",
  "бартошице",
  "гижичко",
  "дзялдово",
  "илава",
  "кетржин",
  "мрагово",
  "ольштын",
  "острода",
  "шхов",
  "элблаг",
  "элк",
  "вагровец",
  "вржесня",
  "гнезно",
  "гостын",
  "калиш",
  "коло",
  "конин",
  "косциян",
  "кротошин",
  "лешно",
  "любон",
  "остров-велкопольски",
  "пила",
  "познань",
  "равич",
  "сваржедж",
  "срем",
  "срода-велкопольска",
  "турек",
  "чодзиеж",
  "яроцин",
  "валч",
  "голенёв",
  "грифино",
  "колобржег",
  "кошалин",
  "поличе",
  "свинойски",
  "старгард-щецинский",
  "щецин",
  "щецинек",
  "александров-ёдзжи",
  "вилун",
  "згерз",
  "здунска-вола",
  "кутно",
  "ласк",
  "ловиц",
  "лодзь",
  "озорков",
  "опочно",
  "пабьянице",
  "пиотрков-трыбунальски",
  "радомско",
  "серадзь",
  "скерневице",
  "томашов-мазовецки",
  "биала подласка",
  "билгорай",
  "замосц",
  "красник",
  "красныстав",
  "лешна",
  "лубартов",
  "луков",
  "люблин",
  "пулавы",
  "свидник",
  "томашов любельски",
  "хрубешов",
  "челм",
  "бржег",
  "кедзержин-козле",
  "ключборк",
  "ныса",
  "ополе",
  "прудник",
  "стржельце-опольские",
  "коимбра",
  "фунчал",
  "амадора",
  "лиссабон",
  "сетубаль",
  "брага",
  "вила-нова-де-гайя",
  "матосинхос",
  "опорто",
  "порту",
  "сант-денис",
  "акташ",
  "акутиха",
  "алейск",
  "алтайский",
  "баево",
  "барнаул",
  "белово",
  "белокуриха",
  "белоярск",
  "бийск",
  "благовещенск",
  "боровлянка",
  "бурла",
  "бурсоль",
  "волчиха",
  "горно-алтайск",
  "горняк",
  "ельцовка",
  "залесово",
  "заринск",
  "заток",
  "змеиногорск",
  "камень-на-оби",
  "ключи",
  "кош-агач",
  "красногорское",
  "краснощеково",
  "кулунда",
  "кытманово",
  "мамонтово",
  "новичиха",
  "новоалтайск",
  "онгудай",
  "павловск",
  "петропавловское",
  "поспелиха",
  "ребриха",
  "родино",
  "рубцовск",
  "смоленское",
  "солонешное",
  "солтон",
  "староаллейское",
  "табуны",
  "тальменка",
  "топчиха",
  "троицкое",
  "турочак",
  "тюменцево",
  "угловское",
  "усть-калманка",
  "усть-кан",
  "усть-кокса",
  "усть-улаган",
  "усть-чарышская пристань",
  "хабары",
  "целинное",
  "чарышское",
  "шебалино",
  "шелаболиха",
  "шипуново",
  "айгунь",
  "архара",
  "белогорск",
  "благовещенск (амурская обл.)",
  "бурея",
  "возжаевка",
  "екатеринославка",
  "ерофей павлович",
  "завитинск",
  "зея",
  "златоустовск",
  "коболдо",
  "магдагачи",
  "новобурейский",
  "поярково",
  "райчихинск",
  "ромны",
  "свободный",
  "серышево",
  "сковородино",
  "стойба",
  "тамбовка",
  "тында",
  "шимановск",
  "экимчан",
  "ядрино",
  "амдерма",
  "архангельск",
  "березник",
  "вельск",
  "верхняя тойма",
  "волошка",
  "вычегодский",
  "емца",
  "илеза",
  "ильинско-подомское",
  "каргополь",
  "карпогоры",
  "кодино",
  "коноша",
  "коряжма",
  "котлас",
  "красноборск",
  "лешуконское",
  "мезень",
  "нарьян-мар",
  "новодвинск",
  "няндома",
  "онега",
  "пинега",
  "плесецк",
  "северодвинск",
  "сольвычегодск",
  "холмогоры",
  "шенкурск",
  "яренск",
  "астрахань",
  "ахтубинск",
  "верхний баскунчак",
  "володарский",
  "енотаевка",
  "икряное",
  "камызяк",
  "капустин яр",
  "лиман",
  "началово",
  "харабали",
  "черный яр",
  "аксаково",
  "амзя",
  "аскино",
  "баймак",
  "бакалы",
  "белебей",
  "белорецк",
  "бижбуляк",
  "бирск",
  "большеустьикинское",
  "верхнеяркеево",
  "верхние киги",
  "верхние татышлы",
  "верхний авзян",
  "давлеканово",
  "дуван",
  "дюртюли",
  "ермекеево",
  "ермолаево",
  "зилаир",
  "зирган",
  "иглино",
  "инзер",
  "исянгулово",
  "ишимбай",
  "кананикольское",
  "кандры",
  "караидель",
  "караидельский",
  "киргиз-мияки",
  "красноусольский",
  "кумертау",
  "кушнаренково",
  "малояз",
  "мелеуз",
  "месягутово",
  "мраково",
  "нефтекамск",
  "раевский",
  "салават",
  "сибай",
  "старобалтачево",
  "старосубхангулово",
  "стерлибашево",
  "стерлитамак",
  "туймазы",
  "уфа",
  "учалы",
  "федоровка",
  "чекмагуш",
  "чишмы",
  "шаран",
  "янаул",
  "белгород",
  "борисовка",
  "валуйки",
  "вейделевка",
  "волоконовка",
  "грайворон",
  "губкин",
  "ивня",
  "короча",
  "красногвардейское",
  "новый оскол",
  "ракитное",
  "ровеньки",
  "старый оскол",
  "строитель",
  "чернянка",
  "шебекино",
  "алтухово",
  "белая березка",
  "белые берега",
  "большое полпино",
  "брянск",
  "бытошь",
  "выгоничи",
  "гордеевка",
  "дубровка",
  "жирятино",
  "жуковка",
  "злынка",
  "ивот",
  "карачев",
  "клетня",
  "климово",
  "клинцы",
  "кокаревка",
  "комаричи",
  "красная гора",
  "локоть",
  "мглин",
  "навля",
  "новозыбков",
  "погар",
  "почеп",
  "ржаница",
  "рогнедино",
  "севск",
  "стародуб",
  "суземка",
  "сураж",
  "трубчевск",
  "унеча",
  "бабушкин",
  "багдарин",
  "баргузин",
  "баянгол",
  "бичура",
  "выдрино",
  "гусиное озеро",
  "гусиноозерск",
  "заиграево",
  "закаменск",
  "иволгинск",
  "илька",
  "кабанск",
  "каменск",
  "кижинга",
  "курумкан",
  "кырен",
  "кяхта",
  "монды",
  "мухоршибирь",
  "нижнеангарск",
  "орлик",
  "петропавловка",
  "романовка",
  "селенгинск",
  "сосново-озерское",
  "турунтаево",
  "улан-удэ",
  "хоринск",
  "александров",
  "андреево",
  "анопино",
  "бавлены",
  "балакирево",
  "боголюбово",
  "великодворский",
  "вербовский",
  "владимир",
  "вязники",
  "городищи",
  "гороховец",
  "гусевский",
  "гусь хрустальный",
  "золотково",
  "иванищи",
  "камешково",
  "карабаново",
  "киржач",
  "ковров",
  "кольчугино",
  "красная горбатка",
  "меленки",
  "муром",
  "петушки",
  "покров",
  "собинка",
  "судогда",
  "суздаль",
  "юрьев-польский",
  "алексеевская",
  "алущевск",
  "быково",
  "волгоград",
  "волжский",
  "дубовка",
  "елань",
  "жирновск",
  "иловля",
  "калач-на-дону",
  "камышин",
  "клетский",
  "котельниково",
  "котово",
  "кумылженская",
  "ленинск",
  "нехаевский",
  "николаевск",
  "новоаннинский",
  "новониколаевский",
  "ольховка",
  "палласовка",
  "рудня",
  "светлый яр",
  "серафимович",
  "средняя ахтуба",
  "сталинград",
  "старая полтавка",
  "суровикино",
  "урюпинск",
  "фролово",
  "чернышковский",
  "бабаево",
  "белозерск",
  "великий устюг",
  "верховажье",
  "вожега",
  "вологда",
  "вохтога",
  "вытегра",
  "грязовец",
  "кадников",
  "кадуй",
  "кичменгский городок",
  "липин бор",
  "никольск",
  "нюксеница",
  "сокол",
  "сямжа",
  "тарногский городок",
  "тотьма",
  "устюжна",
  "харовск",
  "чагода",
  "череповец",
  "шексна",
  "шуйское",
  "анна",
  "бобров",
  "богучар",
  "борисоглебск",
  "бутурлиновка",
  "верхний мамон",
  "верхняя хава",
  "воробьевка",
  "воронеж",
  "лиски",
  "грибановский",
  "давыдовка",
  "елань-коленовский",
  "калач",
  "кантемировка",
  "нижнедевицк",
  "новая усмань",
  "новохоперск",
  "ольховатка",
  "острогожск",
  "панино",
  "поворино",
  "подгоренский",
  "рамонь",
  "репьевка",
  "россошь",
  "семилуки",
  "таловая",
  "терновка",
  "хохольский",
  "эртиль",
  "ардатов",
  "арзамас",
  "арья",
  "балахна",
  "богородск",
  "большереченск",
  "большое болдино",
  "большое козино",
  "большое мурашкино",
  "большое пикино",
  "бор",
  "бутурлино",
  "вад",
  "варнавино",
  "васильсурск",
  "вахтан",
  "вача",
  "велетьма",
  "ветлуга",
  "виля",
  "вознесенское",
  "володарск",
  "воротынец",
  "ворсма",
  "воскресенское",
  "выездное",
  "выкса",
  "гагино",
  "гидроторф",
  "горбатов",
  "горбатовка",
  "городец",
  "горький",
  "дальнее константиново",
  "дивеево",
  "досчатое",
  "заволжье",
  "катунки",
  "керженец",
  "княгинино",
  "ковернино",
  "красные баки",
  "кстово",
  "кулебаки",
  "лукоянов",
  "лысково",
  "навашино",
  "нижний новгород",
  "павлово",
  "первомайск",
  "перевоз",
  "пильна",
  "починки",
  "сергач",
  "сеченово",
  "сосновское",
  "спасское",
  "тонкино",
  "тоншаево",
  "уразовка",
  "урень",
  "чкаловск",
  "шаранга",
  "шатки",
  "шахунья",
  "агвали",
  "акуша",
  "ахты",
  "ачису",
  "бабаюрт",
  "бежта",
  "ботлих",
  "буйнакск",
  "вачи",
  "гергебиль",
  "гуниб",
  "дагестанские огни",
  "дербент",
  "дылым",
  "ершовка",
  "избербаш",
  "карабудахкент",
  "карата",
  "каспийск",
  "касумкент",
  "кизилюрт",
  "кизляр",
  "кочубей",
  "кумух",
  "курах",
  "магарамкент",
  "маджалис",
  "махачкала",
  "мехельта",
  "новолакское",
  "рутул",
  "советское",
  "тарумовка",
  "терекли-мектеб",
  "тлярата",
  "тпиг",
  "уркарах",
  "хасавюрт",
  "хив",
  "хунзах",
  "цуриб",
  "южно-сухокумск",
  "биробиджан",
  "архиповка",
  "верхний ландех",
  "вичуга",
  "гаврилов посад",
  "долматовский",
  "дуляпино",
  "заволжск",
  "заречный",
  "иваново",
  "иваньковский",
  "ильинское-хованское",
  "каминский",
  "кинешма",
  "комсомольск",
  "лух",
  "палех",
  "пестяки",
  "приволжск",
  "пучеж",
  "родники",
  "савино",
  "сокольское",
  "тейково",
  "фурманов",
  "шуя",
  "южа",
  "юрьевец",
  "алексеевск",
  "алзамай",
  "алыгжер",
  "ангарск",
  "артемовский",
  "атагай",
  "байкал",
  "байкальск",
  "балаганск",
  "баяндай",
  "бирюсинск",
  "бодайбо",
  "большая речка",
  "большой луг",
  "бохан",
  "братск",
  "видим",
  "витимский",
  "вихоревка",
  "еланцы",
  "ербогачен",
  "железногорск-илимский",
  "жигалово",
  "забитуй",
  "залари",
  "звездный",
  "зима",
  "иркутск",
  "казачинское",
  "качуг",
  "квиток",
  "киренск",
  "куйтун",
  "кутулик",
  "мама",
  "нижнеудинск",
  "оса",
  "слюдянка",
  "тайшет",
  "тулун",
  "усолье-сибирское",
  "усть-илимск",
  "усть-кут",
  "усть-ордынский",
  "усть-уда",
  "черемхово",
  "шелехов",
  "баксан",
  "майский",
  "нальчик",
  "нарткала",
  "прохладный",
  "терек",
  "тырныауз",
  "чегем-первый",
  "багратионовск",
  "балтийск",
  "гвардейск",
  "гурьевск",
  "гусев",
  "железнодорожный",
  "зеленоградск",
  "знаменск",
  "калининград",
  "кенисберг",
  "краснознаменск",
  "мамоново",
  "неман",
  "нестеров",
  "озерск",
  "полесск",
  "правдинск",
  "светлый",
  "славск",
  "советск",
  "черняховск",
  "андреаполь",
  "бежецк",
  "белый",
  "белый городок",
  "березайка",
  "бологое",
  "васильевский мох",
  "выползово",
  "вышний волочек",
  "жарковский",
  "западная двина",
  "заречье",
  "зубцов",
  "изоплит",
  "калашниково",
  "калинин",
  "калязин",
  "кашин",
  "кесова гора",
  "кимры",
  "конаково",
  "красный холм",
  "кувшиново",
  "лесное",
  "лихославль",
  "максатиха",
  "молоково",
  "нелидово",
  "оленино",
  "осташков",
  "пено",
  "рамешки",
  "ржев",
  "сандово",
  "селижарово",
  "сонково",
  "спирово",
  "старица",
  "тверь",
  "торжок",
  "торопец",
  "фирово",
  "аршань",
  "каспийский",
  "комсомольский",
  "малые дербеты",
  "приютное",
  "утта",
  "цаган-аман",
  "элиста",
  "юста",
  "яшалта",
  "яшкуль",
  "бабынино",
  "балабаново",
  "барятино",
  "белоусово",
  "бетлица",
  "боровск",
  "дугна",
  "дудоровский",
  "думиничи",
  "еленский",
  "жиздра",
  "износки",
  "калуга",
  "киров",
  "козельск",
  "кондрово",
  "людиново",
  "малоярославец",
  "медынь",
  "мещовск",
  "мосальск",
  "обнинск",
  "перемышль",
  "спас-деменск",
  "сухиничи",
  "таруса",
  "ульяново",
  "ферзиково",
  "хвастовичи",
  "юхнов",
  "атласово",
  "аянка",
  "большерецк",
  "ильпырский",
  "каменское",
  "крапивная",
  "мильково",
  "никольское",
  "оссора",
  "палана",
  "парень",
  "пахачи",
  "петропавловск-камчатский",
  "тигиль",
  "тиличики",
  "усть-большерецк",
  "усть-камчатск",
  "амбарный",
  "беломорск",
  "валаам",
  "вирандозеро",
  "гирвас",
  "деревянка",
  "идель",
  "ильинский",
  "импалахти",
  "калевала",
  "кемь",
  "кестеньга",
  "кондопога",
  "костомукша",
  "лахденпохья",
  "лоухи",
  "медвежьегорск",
  "муезерский",
  "олонец",
  "петрозаводск",
  "питкяранта",
  "повенец",
  "пряжа",
  "пудож",
  "сегежа",
  "сортавала",
  "софпорог",
  "суоярви",
  "анжеро-судженск",
  "барзас",
  "березовский",
  "грамотеино",
  "ижморский",
  "итатский",
  "калтан",
  "кедровка",
  "кемерово",
  "киселевск",
  "крапивинский",
  "ленинск-кузнецкий",
  "мариинск",
  "междуреченск",
  "мыски",
  "новокузнецк",
  "осинники",
  "прокопьевск",
  "промышленная",
  "тайга",
  "таштагол",
  "тисуль",
  "топки",
  "тяжинский",
  "юрга",
  "яшкино",
  "яя",
  "арбаж",
  "аркуль",
  "белая холуница",
  "богородское",
  "боровой",
  "верхошижемье",
  "зуевка",
  "каринторф",
  "кикнур",
  "кильмезь",
  "кирово-чепецк",
  "кирс",
  "кобра",
  "котельнич",
  "кумены",
  "луза",
  "малмыж",
  "мураши",
  "нагорск",
  "нема",
  "нововятск",
  "нолинск",
  "омутнинск",
  "опарино",
  "оричи",
  "пижанка",
  "подосиновец",
  "санчурск",
  "свеча",
  "слободской",
  "суна",
  "тужа",
  "уни",
  "уржум",
  "фаленки",
  "халтурин",
  "юрья",
  "яранск",
  "абезь",
  "айкино",
  "верхняя инта",
  "визинга",
  "водный",
  "вожаель",
  "воркута",
  "вуктыл",
  "гешарт",
  "елецкий",
  "емва",
  "заполярный",
  "ижма",
  "инта",
  "ираель",
  "каджером",
  "кажым",
  "кожым",
  "койгородок",
  "корткерос",
  "кослан",
  "объячево",
  "печора",
  "сосногорск",
  "сыктывкар",
  "троицко-печерск",
  "усинск",
  "усогорск",
  "усть-кулом",
  "усть-цильма",
  "ухта",
  "антропово",
  "боговарово",
  "буй",
  "волгореченск",
  "галич",
  "горчуха",
  "зебляки",
  "кадый",
  "кологрив",
  "кострома",
  "красное-на-волге",
  "макарьев",
  "мантурово",
  "нерехта",
  "нея",
  "островское",
  "павино",
  "парфентьево",
  "поназырево",
  "солигалич",
  "судиславль",
  "сусанино",
  "чухлома",
  "шарья",
  "шемятино",
  "абинск",
  "абрау-дюрсо",
  "анапа",
  "апшеронск",
  "армавир",
  "архипо-осиповка",
  "афипский",
  "ахтырский",
  "ачуево",
  "белореченск",
  "верхнебаканский",
  "выселки",
  "геленджик",
  "гиагинская",
  "горячий ключ",
  "джубга",
  "динская",
  "ейск",
  "ильский",
  "кабардинка",
  "калинино",
  "калининская",
  "каменномостский",
  "каневская",
  "кореновск",
  "красноармейская",
  "краснодар",
  "кропоткин",
  "крыловская",
  "крымск",
  "кущевская",
  "лабинск",
  "лениградская",
  "майкоп",
  "мостовской",
  "новороссийск",
  "отрадная",
  "павловская",
  "приморско-ахтарск",
  "северская",
  "славянск-на-кубани",
  "сочи",
  "староминская",
  "старощербиновская",
  "тбилисская",
  "темрюк",
  "тимашевск",
  "тихорецк",
  "туапсе",
  "тульский",
  "усть-лабинск",
  "шовгеновский",
  "абаза",
  "абакан",
  "абан",
  "агинское",
  "артемовск",
  "аскиз",
  "ачинск",
  "байкит",
  "балахта",
  "балыкса",
  "белый яр",
  "бельтырский",
  "бея",
  "бискамжа",
  "боготол",
  "боград",
  "богучаны",
  "большая мурта",
  "большой улуй",
  "бородино",
  "ванавара",
  "верхнеимбатск",
  "горячегорск",
  "дзержинское",
  "дивногорск",
  "диксон",
  "дудинка",
  "емельяново",
  "енисейск",
  "ермаковское",
  "заозерный",
  "игарка",
  "идринское",
  "иланский",
  "ирбейское",
  "канск",
  "каратузское",
  "караул",
  "кежма",
  "козулька",
  "копьево",
  "краснотуранск",
  "красноярск",
  "курагино",
  "лесосибирск",
  "минусинск",
  "мотыгино",
  "назарово",
  "нижний ингаш",
  "новоселово",
  "норильск",
  "партизанское",
  "пировское",
  "саяногорск",
  "северо-енисейский",
  "тасеево",
  "таштып",
  "тура",
  "туруханск",
  "тюхтет",
  "ужур",
  "усть-авам",
  "уяр",
  "хатанга",
  "черемушки",
  "черногорск",
  "шалинское",
  "шира",
  "шушенское",
  "варгаши",
  "глядянское",
  "далматово",
  "каргаполье",
  "катайск",
  "кетово",
  "курган",
  "куртамыш",
  "макушино",
  "мишкино",
  "мокроусово",
  "петухово",
  "половинное",
  "сафакулево",
  "шадринск",
  "шатрово",
  "шумиха",
  "щучье",
  "юргамыш",
  "альменево",
  "белая",
  "большое солдатское",
  "глушково",
  "горшечное",
  "дмитриев-льговский",
  "золотухино",
  "касторное",
  "конышевка",
  "коренево",
  "курск",
  "курчатов",
  "кшенский",
  "льгов",
  "медвенка",
  "обоянь",
  "поныри",
  "пристень",
  "прямицыно",
  "рыльск",
  "суджа",
  "тим",
  "фатеж",
  "хомутовка",
  "черемисиново",
  "щигры",
  "грязи",
  "данхов",
  "доброе",
  "долгоруково",
  "елец",
  "задонск",
  "измалково",
  "казинка",
  "лебедянь",
  "лев толстой",
  "липецк",
  "тербуны",
  "усмань",
  "хлевное",
  "чаплыгин",
  "анадырь",
  "атка",
  "балыгычан",
  "беринговский",
  "билибино",
  "ванкарем",
  "иульитин",
  "кадыкчан",
  "лаврентия",
  "магадан",
  "мыс шмидта",
  "ола",
  "омонск",
  "омсукчан",
  "палатка",
  "певек",
  "провидения",
  "сеймчан",
  "синегорье",
  "сусуман",
  "усть-белая",
  "усть-омчуг",
  "эвенск",
  "эгвекинот",
  "ягодное",
  "волжск",
  "дубовский",
  "звенигово",
  "йошкар-ола",
  "килемары",
  "козьмодемьянск",
  "куженер",
  "мари-турек",
  "медведево",
  "морки",
  "новый торьял",
  "оршанка",
  "параньга",
  "сернур",
  "советский",
  "юрино",
  "атюрьево",
  "атяшево",
  "большие березники",
  "большое игнатово",
  "выша",
  "ельники",
  "зубова поляна",
  "инсар",
  "кадошкино",
  "кемля",
  "ковылкино",
  "кочкурово",
  "краснослободск",
  "лямбирь",
  "ромоданово",
  "саранск",
  "старое шайгово",
  "темников",
  "теньгушево",
  "торбеево",
  "чамзинка",
  "абрамцево",
  "алабино",
  "апрелевка",
  "архангельское",
  "ашитково",
  "бакшеево",
  "балашиха",
  "барыбино",
  "белоомут",
  "белые столбы",
  "бронницы",
  "валуево",
  "вербилки",
  "верея",
  "видное",
  "внуково",
  "вождь пролетариата",
  "волоколамск",
  "воскресенск",
  "восточный",
  "востряково",
  "высоковск",
  "голицино",
  "деденево",
  "дедовск",
  "джержинский",
  "дмитров",
  "долгопрудный",
  "домодедово",
  "дорохово",
  "дрезна",
  "дубки",
  "дубна",
  "егорьевск",
  "жилево",
  "жуковский",
  "загорск",
  "загорянский",
  "запрудная",
  "зарайск",
  "звенигород",
  "зеленоград",
  "ивантеевка",
  "икша",
  "истра",
  "кашира",
  "керва",
  "климовск",
  "клин",
  "клязьма",
  "кожино",
  "кокошкино",
  "коломна",
  "колюбакино",
  "косино",
  "котельники",
  "красково",
  "красногорск",
  "краснозаводск",
  "красный ткач",
  "крюково",
  "кубинка",
  "купавна",
  "куровское",
  "лесной городок",
  "ликино-дулево",
  "лобня",
  "лопатинский",
  "лосино-петровский",
  "лотошино",
  "лукино",
  "луховицы",
  "лыткарино",
  "львовский",
  "люберцы",
  "малаховка",
  "михайловское",
  "михнево",
  "можайск",
  "монино",
  "москва",
  "муханово",
  "мытищи",
  "нарофоминск",
  "нахабино",
  "некрасовка",
  "немчиновка",
  "новобратцевский",
  "новоподрезково",
  "ногинск",
  "обухово",
  "одинцово",
  "ожерелье",
  "озеры",
  "опалиха",
  "орехово-зуево",
  "павловский посад",
  "первомайский",
  "пески",
  "пироговский",
  "подольск",
  "полушкино",
  "правдинский",
  "привокзальный",
  "пролетарский",
  "пущино",
  "радовицкий",
  "раменское",
  "реутов",
  "решетниково",
  "рошаль",
  "рублево",
  "руза",
  "салтыковка",
  "северный",
  "сергиев посад",
  "серебряные пруды",
  "серпухов",
  "солнечногорск",
  "солнцево",
  "софрино",
  "старая купавна",
  "старбеево",
  "ступино",
  "сходня",
  "талдом",
  "текстильщик",
  "темпы",
  "тишково",
  "томилино",
  "троицк",
  "туголесский бор",
  "тучково",
  "уваровка",
  "удельная",
  "успенское",
  "фирсановка",
  "фосфоритный",
  "фрязино",
  "фряново",
  "химки",
  "хорлово",
  "хотьково",
  "черкизово",
  "черноголовка",
  "черусти",
  "чехов",
  "шарапово",
  "шатура",
  "шатурторф",
  "шаховская",
  "шереметьевский",
  "щелково",
  "щербинка",
  "электрогорск",
  "электросталь",
  "электроугли",
  "яхрома",
  "апатиты",
  "африканда",
  "верхнетуломский",
  "зареченск",
  "зашеек",
  "зеленоборский",
  "кандалакша",
  "кильдинстрой",
  "ковдор",
  "кола",
  "конда",
  "мончегорск",
  "мурманск",
  "мурмаши",
  "никель",
  "оленегорск",
  "полярный",
  "североморск",
  "умба",
  "анциферово",
  "батецкий",
  "большая вишера",
  "боровичи",
  "валдай",
  "волот",
  "деманск",
  "зарубино",
  "кресцы",
  "любытино",
  "малая вишера",
  "марево",
  "мошенское",
  "новгород",
  "окуловка",
  "парфино",
  "пестово",
  "поддорье",
  "сольцы",
  "старая русса",
  "хвойное",
  "холм",
  "чудово",
  "шимск",
  "баган",
  "барабинск",
  "бердск",
  "биаза",
  "болотное",
  "венгерово",
  "довольное",
  "завьялово",
  "искитим",
  "карасук",
  "каргат",
  "колывань",
  "краснозерское",
  "крутиха",
  "куйбышев",
  "купино",
  "кыштовка",
  "маслянино",
  "михайловский",
  "мошково",
  "новосибирск",
  "ордынское",
  "северное",
  "сузун",
  "татарск",
  "тогучин",
  "убинское",
  "усть-тарка",
  "чаны",
  "черепаново",
  "чистоозерное",
  "чулым",
  "береговой",
  "большеречье",
  "большие уки",
  "горьковское",
  "знаменское",
  "исилькуль",
  "калачинск",
  "колосовка",
  "кормиловка",
  "крутинка",
  "любинский",
  "марьяновка",
  "муромцево",
  "называевск",
  "нижняя омка",
  "нововаршавка",
  "одесское",
  "оконешниково",
  "омск",
  "павлоградка",
  "полтавка",
  "русская поляна",
  "саргатское",
  "седельниково",
  "таврическое",
  "тара",
  "тевриз",
  "тюкалинск",
  "усть-ишим",
  "черлак",
  "шербакуль",
  "абдулино",
  "адамовка",
  "айдырлинский",
  "акбулак",
  "аккермановка",
  "асекеево",
  "беляевка",
  "бугуруслан",
  "бузулук",
  "гай",
  "грачевка",
  "домбаровский",
  "дубенский",
  "илек",
  "ириклинский",
  "кувандык",
  "курманаевка",
  "матвеевка",
  "медногорск",
  "новоорск",
  "новосергиевка",
  "новотроицк",
  "оренбург",
  "орск",
  "переволоцкий",
  "пономаревка",
  "саракташ",
  "соль-илецк",
  "сорочинск",
  "ташла",
  "тоцкое",
  "тюльган",
  "шарлык",
  "энергетик",
  "ясный",
  "болхов",
  "верховье",
  "глазуновка",
  "дмитровск-орловский",
  "долгое",
  "залегощь",
  "змиевка",
  "колпны",
  "красная заря",
  "кромы",
  "ливны",
  "малоархангельск",
  "мценск",
  "нарышкино",
  "новосиль",
  "орел",
  "покровское",
  "сосково",
  "тросна",
  "хомутово",
  "хотынец",
  "шаблыкино",
  "башмаково",
  "беднодемьяновск",
  "беково",
  "белинский",
  "бессоновка",
  "вадинск",
  "верхозим",
  "евлашево",
  "земетчино",
  "золотаревка",
  "исса",
  "колышлей",
  "кондоль",
  "кузнецк",
  "лопатино",
  "малая сердоба",
  "мокшан",
  "наровчат",
  "неверкино",
  "нижний ломов",
  "пачелма",
  "пенза",
  "русский камешкир",
  "сердобск",
  "сосновоборск",
  "сура",
  "тамала",
  "шемышейка",
  "березники",
  "большая соснова",
  "верещагино",
  "гайны",
  "горнозаводск",
  "гремячинск",
  "губаха",
  "добрянка",
  "елово",
  "зюкайка",
  "карагай",
  "керчевский",
  "кизел",
  "коса",
  "кочево",
  "красновишерск",
  "краснокамск",
  "кудымкар",
  "куеда",
  "кунгур",
  "лысьва",
  "ныроб",
  "нытва",
  "орда",
  "оханск",
  "очер",
  "пермь",
  "соликамск",
  "суксун",
  "уинское",
  "усолье",
  "усть-кишерть",
  "чайковский",
  "частые",
  "чердынь",
  "чернореченский",
  "чернушка",
  "чусовой",
  "юрла",
  "юсьва",
  "анучино",
  "арсеньев",
  "артем",
  "большой камень",
  "валентин",
  "владивосток",
  "высокогорск",
  "горные ключи",
  "горный",
  "дальнегорск",
  "дальнереченск",
  "кавалерово",
  "камень-рыболов",
  "лазо",
  "лесозаводск",
  "лучегорск",
  "находка",
  "новопокровка",
  "ольга",
  "партизанск",
  "пограничный",
  "русский",
  "самарга",
  "славянка",
  "спасск-дальний",
  "терней",
  "уссурийск",
  "хасан",
  "хороль",
  "черниговка",
  "чугуевка",
  "яковлевка",
  "бежаницы",
  "великие луки",
  "гдов",
  "дедовичи",
  "дно",
  "заплюсье",
  "идрица",
  "красногородское",
  "кунья",
  "локня",
  "невель",
  "новоржев",
  "новосокольники",
  "опочка",
  "остров",
  "палкино",
  "печоры",
  "плюсса",
  "порхов",
  "псков",
  "пустошка",
  "пушкинские горы",
  "пыталово",
  "себеж",
  "струги-красные",
  "усвяты",
  "азов",
  "аксай",
  "алмазный",
  "аютинск",
  "багаевский",
  "батайск",
  "белая калитва",
  "боковская",
  "большая мартыновка",
  "вешенская",
  "волгодонск",
  "восход",
  "гигант",
  "горняцкий",
  "гуково",
  "донецк",
  "донской",
  "дубовское",
  "жирнов",
  "заветное",
  "заводской",
  "зверево",
  "зерноград",
  "зимовники",
  "кагальницкая",
  "казанская",
  "каменоломни",
  "каменск-шахтинский",
  "кашары",
  "коксовый",
  "константиновск",
  "красный сулин",
  "куйбышево",
  "матвеев курган",
  "мигулинская",
  "миллерово",
  "милютинская",
  "морозовск",
  "новочеркасск",
  "новошахтинск",
  "обливская",
  "орловский",
  "песчанокопское",
  "пролетарск",
  "ремонтное",
  "родионово-несветайская",
  "ростов-на-дону",
  "сальск",
  "семикаракорск",
  "таганрог",
  "тарасовский",
  "тацинский",
  "усть-донецкий",
  "целина",
  "цимлянск",
  "чалтырь",
  "чертково",
  "шахты",
  "шолоховский",
  "александро-невский",
  "гусь железный",
  "елатьма",
  "ермишь",
  "захарово",
  "кадом",
  "касимов",
  "кораблино",
  "милославское",
  "михайлов",
  "пителино",
  "пронск",
  "путятино",
  "рыбное",
  "ряжск",
  "рязань",
  "сапожок",
  "сараи",
  "сасово",
  "скопин",
  "спас-клепики",
  "спасск-рязанский",
  "старожилово",
  "ухолово",
  "чучково",
  "шацк",
  "шилово",
  "безенчук",
  "богатое",
  "богатырь",
  "большая глущица",
  "большая черниговка",
  "борское",
  "жигулевск",
  "зольное",
  "исаклы",
  "камышла",
  "кинель",
  "кинель-черкасы",
  "клявлино",
  "кошки",
  "красноармейское",
  "нефтегорск",
  "новокуйбышевск",
  "отрадный",
  "пестравка",
  "похвистнево",
  "приволжье",
  "самара",
  "сызрань",
  "тольятти",
  "хворостянка",
  "чапаевск",
  "челно-вершины",
  "шентала",
  "шигоны",
  "александровская",
  "бокситогорск",
  "большая ижора",
  "будогощь",
  "вознесенье",
  "волосово",
  "волхов",
  "всеволожск",
  "выборг",
  "вырица",
  "высоцк",
  "гатчина",
  "дружная горка",
  "ефимовский",
  "зеленогорск",
  "ивангород",
  "каменногорск",
  "кикерино",
  "кингисепп",
  "кириши",
  "кобринское",
  "колпино",
  "кронштадт",
  "лисий нос",
  "лодейное поле",
  "ломоносов",
  "луга",
  "парголово",
  "петродворец",
  "подпорожье",
  "приозерск",
  "пушкин",
  "санкт-петербург",
  "сестрорецк",
  "сланцы",
  "сосновый бор",
  "тихвин",
  "тосно",
  "александров гай",
  "аркадак",
  "аткарск",
  "базарный карабулак",
  "балаково",
  "балашов",
  "балтай",
  "возрождение",
  "вольск",
  "дергачи",
  "духовницкое",
  "екатериновка",
  "ершов",
  "калининск",
  "каменский",
  "красный кут",
  "лысые горы",
  "маркс",
  "мокроус",
  "новоузенск",
  "новые бурасы",
  "озинки",
  "перелюб",
  "петровск",
  "питерка",
  "пугачев",
  "ровное",
  "ртищево",
  "самойловка",
  "саратов",
  "степное",
  "татищево",
  "турки",
  "хвалынск",
  "энгельс",
  "абый",
  "алдан",
  "амга",
  "батагай",
  "бердигестях",
  "беркакит",
  "бестях",
  "борогонцы",
  "верхневилюйск",
  "верхнеколымск",
  "верхоянск",
  "вилюйск",
  "витим",
  "власово",
  "жиганск",
  "зырянка",
  "кангалассы",
  "канкунский",
  "ленск",
  "майя",
  "менкеря",
  "мирный",
  "нерюнгри",
  "нычалах",
  "нюрба",
  "олекминск",
  "покровск",
  "сангар",
  "саскылах",
  "среднеколымск",
  "сунтар",
  "тикси",
  "усть-мая",
  "усть-нера",
  "хандыга",
  "хонуу",
  "черский",
  "чокурдах",
  "чурапча",
  "якутск",
  "александровск-сахалинский",
  "анбэцу",
  "анива",
  "бошняково",
  "быков",
  "вахрушев",
  "взморье",
  "гастелло",
  "долинск",
  "катангли",
  "корсаков",
  "курильск",
  "макаров",
  "невельск",
  "ноглики",
  "оха",
  "поронайск",
  "северо-курильск",
  "смирных",
  "томари",
  "тымовское",
  "углегорск",
  "холмск",
  "шахтерск",
  "южно-сахалинск",
  "алапаевск",
  "алтынай",
  "арамиль",
  "арти",
  "асбест",
  "ачит",
  "байкалово",
  "басьяновский",
  "белоярский",
  "богданович",
  "буланаш",
  "верхний тагил",
  "верхняя пышма",
  "верхняя салда",
  "верхняя синячиха",
  "верхняя сысерть",
  "верхняя тура",
  "верхотурье",
  "висим",
  "волчанск",
  "воронцовка",
  "гари",
  "дегтярск",
  "екатеринбург",
  "ертарский",
  "заводоуспенское",
  "зыряновский",
  "зюзельский",
  "ивдель",
  "изумруд",
  "ирбит",
  "ис",
  "каменск-уральский",
  "камышлов",
  "карпинск",
  "карпунинский",
  "качканар",
  "кировград",
  "краснотурьинск",
  "красноуральск",
  "красноуфимск",
  "кушва",
  "михайловск",
  "невьянск",
  "нижние серги",
  "нижний тагил",
  "нижняя салда",
  "нижняя тура",
  "новая ляля",
  "оус",
  "первоуральск",
  "полевской",
  "пышма",
  "ревда",
  "реж",
  "свердловск",
  "североуральск",
  "серов",
  "сосьва",
  "среднеуральск",
  "сухой лог",
  "сысерть",
  "таборы",
  "тавда",
  "талица",
  "тугулым",
  "туринск",
  "туринская слобода",
  "алагир",
  "ардон",
  "беслан",
  "бурон",
  "владикавказ",
  "дигора",
  "моздок",
  "чикола",
  "велиж",
  "верхнеднепровский",
  "ворга",
  "вязьма",
  "гагарин",
  "глинка",
  "голынки",
  "демидов",
  "дорогобуж",
  "духовщина",
  "екимовичи",
  "ельня",
  "ершичи",
  "издешково",
  "кардымово",
  "красный",
  "монастырщина",
  "новодугино",
  "починок",
  "рославль",
  "сафоново",
  "смоленск",
  "сычевка",
  "угра",
  "хиславичи",
  "холм-жирковский",
  "шумячи",
  "ярцево",
  "александровское",
  "арзгир",
  "благодарный",
  "буденновск",
  "георгиевск",
  "дивное",
  "домбай",
  "донское",
  "ессентуки",
  "иноземцево",
  "ипатово",
  "карачаевск",
  "кисловодск",
  "кочубеевское",
  "курсавка",
  "левокумское",
  "минеральные воды",
  "невинномысск",
  "нефтекумск",
  "новоалександровск",
  "новоалександровская",
  "новопавловск",
  "новоселицкое",
  "преградная",
  "пятигорск",
  "светлоград",
  "ставрополь",
  "теберда",
  "усть-джегута",
  "хабез",
  "черкесск",
  "бондари",
  "гавриловка вторая",
  "жердевка",
  "знаменка",
  "инжавино",
  "кирсанов",
  "мичуринск",
  "мордово",
  "моршанск",
  "мучкапский",
  "петровское",
  "пичаево",
  "рассказово",
  "ржакса",
  "староюрьево",
  "тамбов",
  "уварово",
  "умет",
  "агрыз",
  "азнакаево",
  "аксубаево",
  "актюбинский",
  "алексеевское",
  "альметьевск",
  "апастово",
  "арск",
  "бавлы",
  "базарные матаки",
  "балтаси",
  "богатые сабы",
  "брежнев",
  "бугульма",
  "буинск",
  "васильево",
  "верхний услон",
  "высокая гора",
  "дербешкинский",
  "елабуга",
  "заинск",
  "зеленодольск",
  "казань",
  "камское устье",
  "карабаш",
  "кукмод",
  "кукмор",
  "лаишево",
  "мамадыш",
  "менделеевск",
  "мензелинск",
  "муслюмово",
  "набережные челны",
  "нижнекамск",
  "новошешминск",
  "нурлат",
  "пестрецы",
  "рыбная слобода",
  "сарманово",
  "старое дрожжаное",
  "тетюши",
  "чистополь",
  "асино",
  "бакчар",
  "батурино",
  "зырянское",
  "итатка",
  "каргасок",
  "катайга",
  "кожевниково",
  "колпашево",
  "кривошеино",
  "мельниково",
  "молчаново",
  "парабель",
  "первомайское",
  "подгорное",
  "стрежевой",
  "томск",
  "тымск",
  "ак-довурак",
  "бай хаак",
  "кызыл",
  "самагалтай",
  "сарыг-сеп",
  "суть-холь",
  "тоора-хем",
  "туран",
  "тээли",
  "хову-аксы",
  "чадан",
  "шагонар",
  "эрзин",
  "агеево",
  "алексин",
  "арсеньево",
  "барсуки",
  "бегичевский",
  "богородицк",
  "болохово",
  "велегож",
  "венев",
  "волово",
  "горелки",
  "епифань",
  "ефремов",
  "заокский",
  "казановка",
  "кимовск",
  "киреевск",
  "куркино",
  "ленинский",
  "новомосковск",
  "одоев",
  "плавск",
  "суворов",
  "тула",
  "узловая",
  "щекино",
  "ясногорск",
  "абатский",
  "аксарка",
  "армизонское",
  "аромашево",
  "бердюжье",
  "большое сорокино",
  "вагай",
  "викулово",
  "винзили",
  "голышманово",
  "заводопетровский",
  "заводоуковск",
  "исетское",
  "ишим",
  "казанское",
  "казым-мыс",
  "кондинское",
  "красноселькуп",
  "лабытнанги",
  "мужи",
  "надым",
  "нефтеюганск",
  "нижневартовск",
  "нижняя тавда",
  "новый уренгой",
  "ноябрьск",
  "нягань",
  "омутинский",
  "радужный",
  "салехард",
  "сладково",
  "сургут",
  "тазовский",
  "тарко-сале",
  "тобольск",
  "тюмень",
  "уват",
  "упорово",
  "урай",
  "ханты-мансийск",
  "юрибей",
  "ялуторовск",
  "яр-сале",
  "ярково",
  "алнаши",
  "балезино",
  "вавож",
  "воткинск",
  "глазов",
  "грахово",
  "дебесы",
  "игра",
  "ижевск",
  "кама",
  "камбарка",
  "каракулино",
  "кез",
  "кизнер",
  "киясово",
  "можга",
  "сарапул",
  "селты",
  "сюмси",
  "ува",
  "устинов",
  "шаркан",
  "юкаменское",
  "якшур-бодья",
  "яр",
  "базарный сызган",
  "барыш",
  "большое нагаткино",
  "вешкайма",
  "глотовка",
  "игнатовка",
  "измайлово",
  "инза",
  "ишеевка",
  "канадей",
  "карсун",
  "кузоватово",
  "майна",
  "новая малыкла",
  "новоспасское",
  "павловка",
  "радищево",
  "сенгилей",
  "старая кулатка",
  "старая майна",
  "сурское",
  "тереньга",
  "ульяновск",
  "чердаклы",
  "дарьинское",
  "деркул",
  "джамбейты",
  "джаныбек",
  "казталовка",
  "калмыково",
  "каратобе",
  "переметное",
  "сайхин",
  "уральск",
  "фурманово",
  "чапаев",
  "амурск",
  "аян",
  "березовый",
  "бикин",
  "бира",
  "биракан",
  "болонь",
  "ванино",
  "волочаевка вторая",
  "высокогорный",
  "вяземский",
  "гурское",
  "дормидонтовка",
  "заветы ильича",
  "известковый",
  "иннокентьевка",
  "комсомольск-на-амуре",
  "нелькан",
  "николаевск-на-амуре",
  "облучье",
  "охотск",
  "переяславка",
  "смидович",
  "советская гавань",
  "софийск",
  "тугур",
  "хабаровск",
  "чегдомын",
  "чумикан",
  "агаповка",
  "аргаяш",
  "аша",
  "бакал",
  "бреды",
  "верхнеуральск",
  "верхний уфалей",
  "еманжелинск",
  "златоуст",
  "карталы",
  "касли",
  "катав-ивановск",
  "копейск",
  "коркино",
  "кунашак",
  "куса",
  "кыштым",
  "магнитогорск",
  "миасс",
  "пласт",
  "сатка",
  "сим",
  "увельский",
  "уйское",
  "усть-катав",
  "фершампенуаз",
  "чебаркуль",
  "челябинск",
  "чесма",
  "южно-уральск",
  "юрюзань",
  "аргун",
  "грозный",
  "гудермез",
  "малгобек",
  "назрань",
  "наурская",
  "ножай-юрт",
  "орджоникидзевская",
  "урус-мартан",
  "шали",
  "аксеново-зиловское",
  "акша",
  "александровский завод",
  "амазар",
  "арбагар",
  "атамановка",
  "балей",
  "борзя",
  "букачача",
  "газимурский завод",
  "давенда",
  "дарасун",
  "дровяная",
  "дульдурга",
  "жиндо",
  "забайкальск",
  "итака",
  "калга",
  "карымское",
  "кличка",
  "ключевский",
  "кокуй",
  "краснокаменск",
  "красный чикой",
  "кыра",
  "моготуй",
  "могоча",
  "нерчинск",
  "нерчинский завод",
  "нижний часучей",
  "оловянная",
  "петровск-забайкальский",
  "приаргунск",
  "сретенск",
  "тупик",
  "улеты",
  "хилок",
  "чара",
  "чернышевск",
  "чита",
  "шелопугино",
  "шилка",
  "алатырь",
  "аликово",
  "батырева",
  "вурнары",
  "ибреси",
  "канаш",
  "киря",
  "комсомольское",
  "красные четаи",
  "кугеси",
  "мариинский посад",
  "моргауши",
  "новочебоксарск",
  "порецкое",
  "урмары",
  "цивильск",
  "чебоксары",
  "шемурша",
  "шумерля",
  "ядрин",
  "яльчики",
  "янтиково",
  "андропов",
  "берендеево",
  "большое село",
  "борисоглебский",
  "брейтово",
  "бурмакино",
  "варегово",
  "волга",
  "гаврилов ям",
  "данилов",
  "любим",
  "мышкино",
  "некрасовское",
  "новый некоуз",
  "переславль-залесский",
  "пошехонье-володарск",
  "ростов",
  "рыбинск",
  "тутаев",
  "углич",
  "ярославль",
  "ахуачапан",
  "коютепекуэ",
  "нуэва сан салвадор",
  "закатеколука",
  "ла унион",
  "сан мигуэл",
  "сан-сальвадор",
  "санта ана",
  "сонсонат",
  "трнава",
  "братислава",
  "зилина",
  "любляна",
  "марибор",
  "парамарибо",
  "айдахо-фоллс",
  "арко",
  "барли",
  "бойсе",
  "левистон",
  "маунтейн-хоум",
  "монтпелье",
  "орофино",
  "покателло",
  "рексбург",
  "руперт",
  "айова-сити",
  "аллеман",
  "амес",
  "асбури",
  "беттендорф",
  "блуэ грасс",
  "буффало",
  "вест-де-мойн",
  "виндсор-хейгтс",
  "вудвард",
  "гилбертвилл",
  "гринфилд",
  "давенпорт",
  "де-мойн",
  "декора",
  "денвер",
  "джайнсвилл",
  "дубукуэ",
  "елдридж",
  "калумет",
  "камминг",
  "картер-лейк",
  "кеокук",
  "клайв",
  "кларинда",
  "клинтон",
  "консил-блаффс",
  "коридон",
  "крескент",
  "креско",
  "лайон",
  "маршаллтаун",
  "масон-сити",
  "норвалк",
  "онава",
  "осадж",
  "оттумва",
  "плисант-хилл",
  "ред-оак",
  "реймонд",
  "ривердал",
  "сагевилл",
  "седар-рапидс",
  "седар-фоллс",
  "сиу-сити",
  "урбандал",
  "форт-додж",
  "чаритон",
  "чарльс-сити",
  "эвансдейл",
  "элдора",
  "элк-ран-хейгтс",
  "эмметсбург",
  "эстервилл",
  "авон",
  "айрондейл",
  "акрон",
  "альбертвиль",
  "андалусиа",
  "аннистон",
  "атенс",
  "атмор",
  "аубурн",
  "аутаугавилл",
  "бабби",
  "бентон",
  "берри",
  "бессемер",
  "бир крик",
  "бирмингам",
  "блу-маунтайн",
  "боаз",
  "бревтон",
  "бригтон",
  "бриллиант",
  "бруквуд",
  "ваверли",
  "валдо",
  "ванк",
  "вебб",
  "веставиа хиллс",
  "ветумпка",
  "вивер",
  "вилмер",
  "вудвилл",
  "гадсден",
  "гардендал",
  "гералдин",
  "голдвилл",
  "грант",
  "гров хилл",
  "гу-вин",
  "гудватер",
  "гуин",
  "гурли",
  "далевилл",
  "дафна",
  "декатур",
  "дора",
  "дотан",
  "дуттон",
  "елба",
  "еуфаула",
  "карбон хилл",
  "кауартс",
  "кинси",
  "кинстон",
  "клантон",
  "клэйхатчи",
  "коллинсвилл",
  "коттонвуд",
  "коуртланд",
  "креола",
  "кэмп-хилл",
  "лангдал",
  "ланетт",
  "лаундесборо",
  "лафэйетт",
  "лейгтон",
  "лексингтон",
  "липскомб",
  "лисбург",
  "литтл шавмут",
  "лоачапока",
  "локсли",
  "локхарт",
  "луверн",
  "малверн",
  "маундвилл",
  "мидланд-сити",
  "мидфилд",
  "миллбрук",
  "мобил",
  "монтгомери",
  "моултон",
  "моунтаин брук",
  "моунтаинборо",
  "муресвилл",
  "мускл шоалс",
  "напир-филд",
  "нортпорт",
  "нотасулга",
  "нью-сайт",
  "ньювилл",
  "оак хилл",
  "оакман",
  "озарк",
  "онича",
  "опелика",
  "опп",
  "охатчи",
  "паинт рок",
  "парриш",
  "пинкард",
  "плисант гров",
  "пойнт-клир",
  "поллард",
  "праттвилл",
  "прикевилл",
  "причард",
  "раинсвилл",
  "редстон арсенал",
  "ривер вив",
  "рик-сити",
  "робинсон спрингс",
  "рогерсвилл",
  "русселлвилл",
  "рутледж",
  "сакс",
  "санфорд",
  "сараланд",
  "сатсума",
  "седар-блуфф",
  "селма",
  "селмонт",
  "силакауга",
  "силваниа",
  "сипси",
  "слокомб",
  "сомервилл",
  "талладега",
  "таррант",
  "таррант-сити",
  "теодор",
  "тиллманс корнер",
  "триана",
  "трой",
  "тускалуса",
  "тускеги",
  "тускумбиа",
  "уайт-халл",
  "унионтаун",
  "фаирфакс",
  "фаирфилд",
  "файрхоп",
  "фаунсдал",
  "феникс-сити",
  "фифф",
  "флинт-сити",
  "фломатон",
  "флорала",
  "флоренк",
  "форестдал",
  "форт-пэйн",
  "форт-рукер",
  "фултон",
  "фултондал",
  "хаклебург",
  "хартфорд",
  "хенагар",
  "хидланд",
  "хомевуд",
  "хорн хилл",
  "хувер",
  "хугули",
  "хунтсвилл",
  "чикасав",
  "шавмут",
  "яксон",
  "яксонвилл",
  "яспер",
  "анкоридж",
  "юно",
  "авондейл",
  "аджо",
  "багдад",
  "бенсон",
  "велда-рос-эстатес",
  "викенбург",
  "виллкокс",
  "гилберт",
  "глендейл",
  "глоб",
  "грин-вэлли",
  "гуадалуп",
  "гудиир",
  "давис-монтан афб",
  "дримланд-вилла",
  "йоунгтаун",
  "кайента",
  "кашион",
  "кингман",
  "кларкдейл",
  "клэйпул",
  "литчфилд-парк",
  "лук",
  "майми",
  "марана",
  "меса",
  "оракл",
  "парадайс-вэлли",
  "паркер",
  "пеориа",
  "пиртлевилл",
  "прескотт",
  "пэйсон",
  "сан-мануэль",
  "сан-сити",
  "саут-таксон",
  "селлс",
  "скоттсдейл",
  "спрингервилл",
  "сьерра-виста",
  "таксон",
  "темп",
  "толлесон",
  "туба-сити",
  "тусон",
  "финикс",
  "флагстафф",
  "флоренц",
  "форт-дефианс",
  "форт-хуачука",
  "чандлер",
  "чинли",
  "шау-ло",
  "эль-мираг",
  "юма",
  "александер",
  "арканзас-сити",
  "аткинс",
  "бакнер",
  "балд-кноб",
  "барлинг",
  "бауксит",
  "бетел-хейгтс",
  "блевинс",
  "блитевилл",
  "бонанза",
  "булл-шоалс",
  "бурдетт",
  "валдрон",
  "валнут-ридж",
  "ван-бурен",
  "варрен",
  "вашингтон",
  "вест хелена",
  "вест-мемфис",
  "виллисвилл",
  "винн",
  "гассвилл",
  "де-витт",
  "дермотт",
  "джадсониа",
  "джексонвилл",
  "едмондсон",
  "ингленд",
  "йонесборо",
  "калдвелл",
  "каммак-виллидж",
  "кейл",
  "кенсетт",
  "киблер",
  "колт",
  "корнинг",
  "коттер",
  "кравфордсвилл",
  "кроссетт",
  "лавака",
  "левисвилл",
  "лейк-виллидж",
  "лейк-хамилтон",
  "литтл-рок",
  "лонсдейл",
  "луксора",
  "магнесс",
  "мак-гехи",
  "мак-каскилл",
  "мак-нейл",
  "марианна",
  "марион",
  "маунтайн-хоум",
  "мена",
  "мэйфлауер",
  "норт-литтл-рок",
  "норфорк",
  "нэшвилл",
  "оакхавен",
  "озан",
  "ойл-троуг",
  "оскеола",
  "пайн-блафф",
  "парагоулд",
  "парис",
  "перритаун",
  "пигготт",
  "плисант-плайнс",
  "плумервилл",
  "покахонтас",
  "поттсвилл",
  "расселл",
  "расселлвилл",
  "рокпорт",
  "росстон",
  "руди",
  "сабиако",
  "сентрал-сити",
  "сирки",
  "скрантон",
  "смаковер",
  "спрингдал",
  "стампс",
  "статтгарт",
  "толлетт",
  "тонтитаун",
  "тэйлор",
  "фейеттевилл",
  "флиппин",
  "фордик",
  "форрест-сити",
  "форт-смит",
  "харди",
  "хаскелл",
  "хелена",
  "хоппер",
  "хот-спрингс",
  "хот-спрингс (национальный парк)",
  "хоуп",
  "шаннон-хиллс",
  "шервуд",
  "элкинс",
  "элм-спрингс",
  "эль-дорадо",
  "эмерсон",
  "эммет",
  "каспер",
  "шайенн",
  "шеридан",
  "алдервуд-манор",
  "беллевуэ",
  "беллингем",
  "бонни-лейк",
  "ботелл",
  "бревстер",
  "бремертон",
  "брин-мавр",
  "венатчи",
  "голдендейл",
  "дишман",
  "дэйтон",
  "дюпонт",
  "женева",
  "интерсити",
  "ист-венатчи-бенч",
  "истгейт",
  "кенмор",
  "кингсгейт",
  "киркланд",
  "клайд-хилл",
  "кли-элам",
  "колвилл",
  "колфакс",
  "лонгвью",
  "мак-хорд база ввс",
  "маунт-вернон",
  "медина",
  "меркер-айланд",
  "миллвуд",
  "мукилтео",
  "ньюпорт-хиллс",
  "олимпия",
  "омак",
  "оппортунити",
  "паркланд",
  "порт-анжелес",
  "рентон",
  "ривертон",
  "ритзвилл",
  "ричланд",
  "рок-айленд",
  "рос-хилл",
  "сентралиа",
  "сиэттл",
  "скайвэй",
  "сноухомиш",
  "спокан",
  "такома",
  "таун-энд-кантри",
  "томпсон-плэйс",
  "тонаскет",
  "уайт-сентер",
  "файрмонт",
  "форт-левис",
  "хантс-пойнт",
  "эверетт",
  "эйрвэй-хейгтс",
  "юанита",
  "якима",
  "яррау-пойнт",
  "берлингтон",
  "миддлбури",
  "монпелье",
  "ньюбури",
  "олбани-центр",
  "питтсфорд",
  "айсл-оф-вигт",
  "александрия",
  "аннандейл",
  "арлингтон",
  "байлис-кроссроадс",
  "беллвуд",
  "бенсли",
  "блу-ридж",
  "бон-айр",
  "бурквилл",
  "вайс",
  "варрентон",
  "вилльямсбург",
  "винтон",
  "вирджиния-бич",
  "витвилл",
  "вудбридж",
  "вэйнсборо",
  "глен-аллен",
  "данвилл",
  "думс",
  "ист-хайленд-парк",
  "йорктаун",
  "кейв-спринг",
  "крозет",
  "лаурел",
  "лейксайд",
  "линчбург",
  "лурэй",
  "манассас-парк",
  "меканиксвилл",
  "монтроз",
  "норфолк",
  "ньюпорт-ньюс",
  "петерсбург",
  "пирисбург",
  "радфорд",
  "рашмер",
  "роанок",
  "салем",
  "саут-бостон",
  "севен-корнерс",
  "стаунтон",
  "стьюартс-драфт",
  "таппаханнок",
  "троутвилл",
  "тукахоэ",
  "финкастл",
  "форт-бельвоир",
  "фредериксбург",
  "хайленд-спрингс",
  "холлинс",
  "хоупвелл",
  "хэмптон",
  "чарлоттесвилл",
  "чесапик",
  "эмпориа",
  "апплетон",
  "белоит",
  "брукфилд",
  "вауватоса",
  "ваукеша",
  "ваусау",
  "вест-аллис",
  "грин-бэй",
  "и-клер",
  "кеноша",
  "ла-кросс",
  "мадисон",
  "манитауок",
  "меномони фаллс",
  "милвауки",
  "нью-берлин",
  "ошкош",
  "ракин",
  "супериор",
  "фонд-дю-лак",
  "шебоиган",
  "янесвилл",
  "ваикапу",
  "ваилуку",
  "гонолулу",
  "каилуа",
  "канеоха",
  "капаау",
  "кахулуи",
  "килакекуа",
  "кихей",
  "лиху",
  "паия",
  "пуунен",
  "хило",
  "блэйдс",
  "вилмингтон",
  "вилмингтон-манор",
  "довер",
  "миллсборо",
  "стантон",
  "талливилл",
  "челси-эстатес",
  "элсмер",
  "авондал естатес",
  "атланта",
  "аттапулгус",
  "баинбридж",
  "барвик",
  "белведер парк",
  "блаирсвилл",
  "валдоста",
  "варнер-робинс",
  "вернонбург",
  "вест поинт",
  "вестсайд",
  "вилмингтон-айленд",
  "вхигам",
  "вэйкросс",
  "гарден-сити",
  "грешам парк",
  "гринсборо",
  "грэйсвилл",
  "деморест",
  "джесап",
  "друид хиллс",
  "ист-пойнт",
  "каиро",
  "картерсвилл",
  "климакс",
  "клэйтон",
  "колумбус",
  "коммерк",
  "кулидж",
  "куллоден",
  "лукоут моунтаин",
  "макон",
  "мариэтта",
  "мкафи",
  "моултри",
  "норт декатур",
  "норт друид хиллс",
  "огаста",
  "паво",
  "порт-вентворт",
  "пулер",
  "рингголд",
  "ром",
  "россвилл",
  "саванна",
  "тандерболт",
  "томасвилл",
  "фитзгералд",
  "форт оглеторп",
  "франклин",
  "хардвик",
  "хомервилл",
  "чикамауга",
  "бакханнон",
  "барбурсвилл",
  "бекли",
  "бенвуд",
  "вейртон",
  "вилинг",
  "моргантаун",
  "паркерсбург",
  "середо",
  "хунтингтон",
  "чарльстон",
  "аледо",
  "алтон",
  "аппл ривер",
  "арлингтон-хейгтс",
  "аурора",
  "белвидер",
  "беллевилл",
  "бенлд",
  "бервин",
  "беталто",
  "блумингтон",
  "бондвилл",
  "букнер",
  "бурбанк",
  "валир",
  "ваукеган",
  "венеция",
  "вест чикаго",
  "вилдвуд",
  "вилла-парк",
  "вилметт",
  "винтроп харбор",
  "вуд ривер",
  "вхитон",
  "галесбург",
  "гленвив",
  "голф",
  "гранвилл",
  "гранит-сити",
  "грин рок",
  "гурни",
  "д калб",
  "далзелл",
  "даунерс-гров",
  "дес-плайнс",
  "долтон",
  "еванстон",
  "евергрин парк",
  "елгин",
  "елмвуд парк",
  "елмхурст",
  "зейглер",
  "ист алтон",
  "ист дубукуэ",
  "ист молин",
  "ист пеориа",
  "ист саинт лоуис",
  "йолит",
  "канкаки",
  "кантон",
  "карбон клифф",
  "кахокиа",
  "коал валли",
  "колона",
  "крев коэур",
  "куинси",
  "ла салл",
  "ладд",
  "лак блуфф",
  "лансинг",
  "либертивилл",
  "линвуд",
  "линколнвуд",
  "лионс",
  "литчфилд",
  "ловес парк",
  "ломбард",
  "макомб",
  "марк",
  "маркуэтт хейгтс",
  "маунт-проспект",
  "мелрос-парк",
  "меррионетт парк",
  "мидаубрук",
  "молин",
  "мортон гров",
  "мэйвуд",
  "нилес",
  "нормал",
  "норридж",
  "норт парк",
  "норт риверсид",
  "норт-чикаго",
  "нортбрук",
  "нортфилд",
  "оак лавн",
  "оак парк",
  "оглесби",
  "палатин",
  "парк форест",
  "парк-ридж",
  "парк-сити",
  "пекин",
  "перу",
  "рантоул",
  "ривер гров",
  "ривер форест",
  "риверсид",
  "роббинс",
  "роиалтон",
  "рок исланд",
  "роксана",
  "рокфорд",
  "росевуд хейгтс",
  "роскоэ",
  "савои",
  "сант-чарльз",
  "саугет",
  "саут-роксана",
  "седар поинт",
  "силвис",
  "ситонвилл",
  "скоки",
  "спринг валли",
  "спрингфилд",
  "стандард",
  "стикни",
  "суммит",
  "урбаин",
  "урбана",
  "форест вив",
  "форест парк",
  "форест хомес",
  "фрипорт",
  "хазел крест",
  "хамптон",
  "харви",
  "харвуд хейгтс",
  "харрисбург",
  "хеброн",
  "хигланд парк",
  "холлауэйвилл",
  "хометаун",
  "христофер",
  "чампаигн",
  "черри",
  "черри валли",
  "чикаго",
  "чикаго хейгтс",
  "чикеро",
  "алтона",
  "андерсон",
  "бич гров",
  "брук",
  "бурнеттсвилл",
  "валпараисо",
  "варрен парк",
  "виллиамс крик",
  "виннедал",
  "галвестон",
  "гарретт",
  "грабилл",
  "гриффит",
  "диер",
  "дун-акрес",
  "евансвилл",
  "елкхарт",
  "индианаполис",
  "ист чикаго",
  "кокомо",
  "краун поинт",
  "краус нест",
  "кумберланд",
  "лавренк",
  "лейк-стейшн",
  "логанспорт",
  "меридиан хиллс",
  "мерриллвилл",
  "мичиган-сити",
  "мишавака",
  "мунки",
  "норт краус нест",
  "норт-вернон",
  "нью-кастл",
  "нью-олбани",
  "нью-чикаго",
  "онвард",
  "портаг",
  "портер",
  "равенсвуд",
  "роки риппл",
  "рушвилл",
  "саут-бенд",
  "саут-хейвен",
  "скоттсбург",
  "сулливан",
  "счерервилл",
  "терр хаут",
  "улен",
  "форт вэйн",
  "хаммонд",
  "хигланд",
  "хомекрофт",
  "хунтертаун",
  "хунтингбург",
  "честертон",
  "чурубуско",
  "шелбивилл",
  "элвуд",
  "азуса",
  "аламеда",
  "алондра-парк",
  "алтадена",
  "альгамбра",
  "анахейм",
  "антиох",
  "апленд",
  "арден",
  "аркад",
  "аркадиа",
  "артесия",
  "ашланд",
  "бакерсфилд",
  "балдвин-парк",
  "барбэнк",
  "барлингейм",
  "беверли-хиллс",
  "белл",
  "белл-гарденс",
  "беллфлауер",
  "белмонт",
  "беркли",
  "блит",
  "броули",
  "буэна-парк",
  "вакавилл",
  "валледжо",
  "валнут-крик",
  "валнут-парк",
  "вентура",
  "вест-атенс",
  "вест-голливуд",
  "вест-карсон",
  "вест-ковайн",
  "вест-комптон",
  "вест-модесто",
  "вестминстер",
  "вестмонт",
  "виндсор-хиллс",
  "висалия",
  "виста",
  "виттьер",
  "вудленд",
  "вью-парк",
  "гавайиан-гарденс",
  "гарден-гров",
  "гардена",
  "гасиенда-хейгтс",
  "глендора",
  "грахам",
  "гридли",
  "дауни",
  "дейли-сити",
  "дели",
  "дель-ри",
  "дель-эйр",
  "денаир",
  "динуба",
  "дэвис",
  "империал-бич",
  "инглвуд",
  "ист-комптон",
  "ист-лос-анжелес",
  "ист-пало-альто",
  "ист-портервилл",
  "истон",
  "калва",
  "кампбелл",
  "кармичел",
  "карсон",
  "карутерс",
  "каситас-спрингс",
  "кастро-велли",
  "кингсбург",
  "кипресс",
  "клермонт",
  "кловис",
  "ковайн",
  "колтон",
  "коммерц",
  "комптон",
  "конкорд",
  "корона",
  "коронадо",
  "коста-меса",
  "кулвер-сити",
  "ла-канада",
  "ла-крескента",
  "ла-меса",
  "ла-мирада",
  "ла-пальма",
  "ла-пуэнте",
  "ла-хабра",
  "ладера-хейгтс",
  "лаундейл",
  "лафайетт",
  "лейквуд",
  "лейтон",
  "лемон-гров",
  "леннокс",
  "ливермор",
  "линда",
  "лоди",
  "ломпок",
  "лонг-бич",
  "лос аламитос",
  "лос-альтос",
  "лос-анжелес",
  "лос-гатос",
  "лос-ньетос",
  "мантека",
  "манхаттан-бич",
  "марина-дель-ри",
  "марисвилл",
  "маунт-хеликс",
  "менло-парк",
  "меркед",
  "милл-вэлли",
  "миллбре",
  "милпитас",
  "модесто",
  "монровиа",
  "монтебелло",
  "монтерей",
  "монтери-парк",
  "монтклейр",
  "моунтайн-вью",
  "мэйфлауер-виллидж",
  "напа",
  "нешенал-сити",
  "новато",
  "норволк",
  "норт-хайлендс",
  "ньюпорт-бич",
  "ньюхалл",
  "оакхарст",
  "ойлдейл",
  "окланд",
  "окснард",
  "оливхарст",
  "онтарио",
  "оушнсайд",
  "палм-спрингс",
  "пало-альто",
  "парамоунт",
  "парлир",
  "пасадена",
  "паттерсон",
  "пацифика",
  "петалума",
  "пико-ривера",
  "питтсбург",
  "плакентиа",
  "помона",
  "ранчо-кордова",
  "редвуд-сити",
  "реддинг",
  "редландс",
  "редондо-бич",
  "риалто",
  "ривербанк",
  "риверсайд",
  "риджкрест",
  "ридли",
  "рипон",
  "росемид",
  "россмур",
  "сакраменто",
  "салинас",
  "сан-андрис",
  "сан-бернардино",
  "сан-бруно",
  "сан-габриэль",
  "сан-диего",
  "сан-карлос",
  "сан-линдро",
  "сан-лоренцо",
  "сан-луис-обиспо",
  "сан-марино",
  "сан-матео",
  "сан-рафель",
  "сан-фернандо",
  "сан-франциско",
  "сангер",
  "саннивейл",
  "санта-ана",
  "санта-барбара",
  "санта-клара",
  "санта-круз",
  "санта-моника",
  "санта-фе-спрингс",
  "санти",
  "саратога",
  "саугус",
  "саус-модесто",
  "саут-виттьер",
  "саут-гейт",
  "саут-ель-монт",
  "саут-лейк-тахо",
  "саут-пасадена",
  "саут-сан-габриэль",
  "саут-сан-франциско",
  "саут-юба",
  "серритос",
  "сигнал-хилл",
  "сил-бич",
  "сими",
  "сисайд",
  "спринг-вэлли",
  "сусалито",
  "сьерра-мадре",
  "талмаг",
  "тамалпаис-вэлли",
  "тарлок",
  "тастин",
  "темпл-сити",
  "тибурон",
  "тиерра-буэна",
  "торранц",
  "тоусанд-оакс",
  "укия",
  "файрфилд",
  "фаулер",
  "фаунтайн-вэлли",
  "флинтридж",
  "фонтана",
  "фремонт",
  "фресно",
  "фуллертон",
  "хавторн",
  "хагсон",
  "хантингтон-бич",
  "хантингтон-парк",
  "хебер",
  "хейвард",
  "холтвилл",
  "хоумстид-вэлли",
  "церес",
  "цитрус-хейгтс",
  "черриленд",
  "чино",
  "чула-виста",
  "эль-кайон",
  "эль-монт",
  "эль-сегундо",
  "эль-серрито",
  "эмеривилл",
  "эскалон",
  "эскондидо",
  "эурека",
  "юба-сити",
  "вествуд",
  "вествуд-хиллс",
  "винфилд",
  "вичита",
  "вэлли-сентер",
  "грейт-бенд",
  "джанкшин-сити",
  "додж-сити",
  "индепенденс",
  "истборо",
  "канзас-сити",
  "кантрисайд",
  "карбондал",
  "кечи",
  "колби",
  "колвич",
  "ларнед",
  "лекомптон",
  "ливенворт",
  "лоуренс",
  "манхаттан",
  "мерриам",
  "миссион",
  "миссион-вудс",
  "миссион-хиллс",
  "нортон",
  "оакли",
  "обурн",
  "овербрук",
  "оверленд-парк",
  "огден",
  "палмер",
  "парсонс",
  "перри",
  "прейри-виллидж",
  "роланд-парк",
  "салина",
  "силвер-лейк",
  "топика",
  "файрвэй",
  "форт-райли",
  "фронтенак",
  "хатчинсон",
  "хэйс",
  "чанут",
  "адубон-парк",
  "баулинг грин",
  "беллефонт",
  "валлинс-крик",
  "версаиллес",
  "вилмор",
  "вэйланд",
  "гутри",
  "джорджтаун",
  "еминенк",
  "катлеттсбург",
  "кентон-вейл",
  "кингсли",
  "ковингтон",
  "ла фэйетт",
  "линнвив",
  "лоуисвилл",
  "лудлау",
  "маунт-стерлинг",
  "николасвиль",
  "овенсборо",
  "падуках",
  "парк-хиллс",
  "парквэй-виллидж",
  "певи валли",
  "пемброк",
  "ракеланд",
  "русселл",
  "саут-шор",
  "саутгейт",
  "сенека-гарденс",
  "стампинг-граунд",
  "стратмур-гарденс",
  "стратмур-манор",
  "трентон",
  "флатвудс",
  "форт кампбелл норт",
  "форт-вригт",
  "форт-митчелл",
  "форт-нокс",
  "форт-томас",
  "франкфорт",
  "хиден",
  "хопкинсвилл",
  "хорс-кейв",
  "шивели",
  "айдахо-спрингс",
  "арвада",
  "блэк-форест",
  "боулдер",
  "браш",
  "велби",
  "вет-ридж",
  "вудленд-парк",
  "гленвуд-спрингс",
  "гранд-джанкшин",
  "грили",
  "грин-маунтайн-фоллс",
  "гринвуд-виллидж",
  "диллон",
  "инглевуд",
  "колорадо-спрингс",
  "коммерц-сити",
  "крайг",
  "лас-анимас",
  "литтлетон",
  "манитоу-спрингс",
  "нанн",
  "нортгленн",
  "пуэбло",
  "саутгленн",
  "свинк",
  "секьюрити",
  "форт-карсон",
  "форт-коллинс",
  "черри-хиллс-виллидж",
  "шеррелвуд",
  "эджуотер",
  "эйр-форс-академи",
  "бриджпорт",
  "валлингфорд",
  "вест-хавен",
  "вест-хартфорд",
  "вестпорт",
  "ветерсфилд",
  "гластонбури",
  "гринвич",
  "данбури",
  "ист-хавен",
  "ист-хартфорд",
  "кенсингтон",
  "куинбаг",
  "мериден",
  "миддлетаун",
  "милфорд",
  "невингтон",
  "норт-гросвенор-дейл",
  "нью-бритайн",
  "нью-лондон",
  "нью-хейвен",
  "патнам",
  "роки-хилл",
  "стамфорд",
  "торрингтон",
  "трамбалл",
  "уотербури",
  "фармингтон",
  "хамден",
  "шелтон",
  "абита-спрингс",
  "анги",
  "балл",
  "батон-руж",
  "бейкер",
  "бланчард",
  "богалуса",
  "боссир-сити",
  "варнадо",
  "велш",
  "видалиа",
  "вильсон",
  "вудворт",
  "гонзалес",
  "грамблинг",
  "де-риддер",
  "денхам-спрингс",
  "джексон",
  "дусон",
  "зачари",
  "канктон",
  "карвилл",
  "кеннер",
  "клейтон",
  "коттон-вэлли",
  "краули",
  "куллен",
  "лейк-чарльз",
  "лекомпт",
  "лисвилл",
  "марреро",
  "мерривилл",
  "метаири",
  "монро",
  "морган-сити",
  "мосс-блуфф",
  "новый орлеан",
  "нью-ибериа",
  "пайнвилл",
  "пирл ривер",
  "порт-аллен",
  "рэйн",
  "сансет",
  "сарепта",
  "скотландвилл",
  "скотт",
  "слаутер",
  "спрингилл",
  "стоунволл",
  "сун",
  "урания",
  "ферридэй",
  "франклинтон",
  "хаугтон",
  "хоума",
  "хэйнесвилл",
  "чёрч-пойнт",
  "шонгалу",
  "шривпорт",
  "айер",
  "актон",
  "атол",
  "аттлеборо",
  "боурн",
  "брайнтри",
  "броктон",
  "бруклин",
  "валтам",
  "варехам",
  "веллесли",
  "вест-бойлстон",
  "вест-бриджуотер",
  "вест-варехам",
  "вест-спрингфилд",
  "вестборо",
  "вестон",
  "вестфилд",
  "винтроп",
  "вобурн",
  "врентам",
  "графтон",
  "данверс",
  "дедхам",
  "дракут",
  "ист-бриджуотер",
  "ист-лонгмидоу",
  "карвер",
  "лейкестер",
  "леоминстер",
  "линн",
  "линнфилд",
  "ловелл",
  "малден",
  "марлборо",
  "медфорд",
  "мелроз",
  "метуэн",
  "миллбури",
  "милтон",
  "натик",
  "нахант",
  "нидхам",
  "норвуд",
  "норт-андовер",
  "норт-дигтон",
  "нортамптон",
  "нортборо",
  "нью-бедфорд",
  "ньютон",
  "оксфорд",
  "оксфорд-сентер",
  "пибоди",
  "питтсфилд",
  "ратланд",
  "ревер",
  "рехобот",
  "рэндольф",
  "сагамор",
  "сандвич",
  "саттон",
  "саут-ланкастер",
  "свампскотт",
  "сомерсет",
  "спенсер",
  "стерлинг",
  "стоунхам",
  "три-риверс",
  "тьюксбури",
  "уотертаун",
  "фитчбург",
  "фолл-ривер",
  "фрамингам",
  "фритаун",
  "хаверхилл",
  "холден",
  "холиок",
  "челси",
  "чикопи",
  "шроусбури",
  "бейпорт",
  "бирон",
  "брайнерд",
  "браунсвилл",
  "бруклин-парк",
  "бруклин-сентер",
  "валкер",
  "вест-сант-пол",
  "виллмар",
  "винона",
  "вреншалл",
  "германтаун",
  "голден-вэлли",
  "дакота",
  "дулут",
  "каннон-фоллс",
  "клокуэт",
  "колумбия-хейгтс",
  "кристал",
  "кун-рапидс",
  "лаудердейл",
  "лилидейл",
  "литтл-фоллс",
  "манкато",
  "маплвуд",
  "медисин-лейк",
  "мендота",
  "мендота-хейгтс",
  "миннеаполис",
  "миннетонка",
  "мурхид",
  "норт манкато",
  "нью-брайтон",
  "остин",
  "проктор",
  "ричфилд",
  "роббинсдейл",
  "росевилл",
  "сант-антони",
  "сант-клауд",
  "сант-пол",
  "сент-луис-парк",
  "сканлон",
  "скилин",
  "стефен",
  "стиллуотер",
  "томсон",
  "фалкон-хейгтс",
  "фергус-фоллс",
  "фридли",
  "хиллтоп",
  "хока",
  "эдина",
  "эйота",
  "аккерман",
  "амори",
  "балдвин",
  "бассфилд",
  "батесвилл",
  "билокси",
  "боил",
  "брукхавен",
  "буневилл",
  "бэй спрингс",
  "ватер валли",
  "вейр",
  "вест",
  "виксбург",
  "гаттман",
  "глендал",
  "гренада",
  "гринвилл",
  "гудман",
  "гулф хиллс",
  "гулфпорт",
  "д`ибервилл",
  "доддсвилл",
  "древ",
  "дурант",
  "еллисвилл",
  "индианола",
  "каледониа",
  "кингс",
  "клевеланд",
  "коллинс",
  "колумбиа",
  "коринт",
  "коссут",
  "куитман",
  "лак",
  "лонг бич",
  "лоуин",
  "лула",
  "лумбертон",
  "мериголд",
  "меридиан",
  "миз",
  "мккул",
  "монтикелло",
  "монтрос",
  "моунд бэйоу",
  "натчес",
  "неллибург",
  "неттлетон",
  "норт гулфпорт",
  "окин спрингс",
  "околона",
  "олив бранч",
  "оранг гров",
  "палмерс кроссинг",
  "паскагоула",
  "пасс чристиан",
  "паулдинг",
  "пачута",
  "пелахатчи",
  "петал",
  "пикэйун",
  "пирл",
  "пирл-сити",
  "плантерсвилл",
  "поп",
  "попларвилл",
  "пурвис",
  "ралейг",
  "ренова",
  "риджеланд",
  "ринзи",
  "роллинг-форк",
  "рулевилл",
  "саллис",
  "сандерсвилл",
  "саутхейвен",
  "себастопол",
  "семинари",
  "силварена",
  "силвер-крик",
  "смитвилл",
  "сосо",
  "старквилл",
  "сумнер",
  "сумралл",
  "тилертаун",
  "тупело",
  "тутвилер",
  "флаууд",
  "форест",
  "френч камп",
  "хармони",
  "хатли",
  "хаттисбург",
  "хендерсон поинт",
  "хернандо",
  "хикори",
  "хьюстон",
  "чунки",
  "шав",
  "шаннон",
  "юмпертаун",
  "бисмарк",
  "бонн терр",
  "брансон",
  "варсон вудс",
  "вебстер гровес",
  "велда виллидж хиллс",
  "веллстон",
  "вест-плайнс",
  "гриндал",
  "дес перес",
  "деслог",
  "джефферсон-сити",
  "джоплин",
  "дулиттл",
  "елвинс",
  "естер",
  "ирондал",
  "камдентон",
  "кап гирардиу",
  "кирквуд",
  "кирксвилл",
  "колумбия",
  "кристал лак парк",
  "лемэй",
  "лидвуд",
  "лидингтон",
  "макензи",
  "маплевуд",
  "маршалл",
  "метц",
  "невада",
  "норт-канзас-сити",
  "нортви",
  "нортвудс",
  "нортмур",
  "нью-блумфилд",
  "ньюбург",
  "окленд-парк",
  "олбани (генри кантри)",
  "олбани (рэй кантри)",
  "олбани-джанкшн",
  "пагедал",
  "пакифик",
  "пилот кноб",
  "пин лавн",
  "риверминес",
  "ричмонд хейгтс",
  "ролла",
  "рэйтаун",
  "седалиа",
  "седар-сити",
  "сент-джозеф",
  "сент-луис",
  "спаниш лак",
  "упландс парк",
  "фаирвив акрес",
  "фергусон",
  "флат ривер",
  "флориссант",
  "харвуд",
  "хартсбург",
  "хигли хейгтс",
  "хиллсдал",
  "хунтлейг",
  "эдгар-спрингс",
  "эйрпорт-драйв",
  "эшланд",
  "юниверсити-сити",
  "аллен-парк",
  "бартон-хиллс",
  "баттл крик",
  "беллаир",
  "биг рапидс",
  "бингам-фармс",
  "бирч-ран",
  "бичер",
  "бойн-сити",
  "бойн-фоллс",
  "бэй-сити",
  "вестланд",
  "виандотт",
  "виоминг",
  "волф лак",
  "вэйкфилд",
  "гранд-бланк",
  "гранд-рапидс",
  "гросс-пойнт-парк",
  "гудрич",
  "дависон",
  "детройт",
  "дирборн",
  "дирборн-хейгтс",
  "екорс",
  "есканаба",
  "инкстер",
  "иониа",
  "ипсиланти",
  "ист йордан",
  "ист-гранд-рапидс",
  "ист-детройт",
  "ист-лансинг",
  "иствуд",
  "кадиллак",
  "каламазу",
  "каро",
  "кентвуд",
  "колдватер",
  "кутлервилл",
  "ламбертвилл",
  "лейк-анжелус",
  "ливониа",
  "линкольн-парк",
  "луна-пир",
  "мадисон-хейтс",
  "маркуэтт",
  "маунт-моррис",
  "мелвиндейл",
  "меномини",
  "мидланд",
  "мунисинг",
  "мускегон",
  "мускегон-хейгтс",
  "норт мускегон",
  "нортон шорес",
  "ньюберри",
  "отисвилл",
  "парчмент",
  "понтиак",
  "порт-гурон",
  "редфорд",
  "ривер-руж",
  "роял-оак",
  "сагинав",
  "сант-клэр-шорес",
  "саут-лайон",
  "саутфилд",
  "сентрал лак",
  "стерлинг-хейтс",
  "траверс-сити",
  "траубридж парк",
  "уитмор-лейк",
  "фаир плаин",
  "ферндал",
  "флинт",
  "хамтрамк",
  "харпер-вудс",
  "хезел-парк",
  "хигланд-парк",
  "холланд",
  "шварц-крик",
  "энн-арбор",
  "анаконда",
  "биллингс",
  "бьютт",
  "валкервилл",
  "гласгоу",
  "грейт-фоллс",
  "калиспелл",
  "ливингстон",
  "миссоула",
  "раундап",
  "силвер-бау",
  "эвергрин",
  "эннис",
  "бакспорт",
  "бакстон",
  "биддефорд",
  "бревер",
  "вестбрук",
  "визи",
  "винтерпорт",
  "горхам",
  "камберленд-сентер",
  "кейп-элизабет",
  "кеннебанк",
  "олд-орчард-бич",
  "олд-таун",
  "ороно",
  "портленд",
  "сако",
  "саут-портланд",
  "фалмаут-форсайд",
  "хампден",
  "ярмаут",
  "аннаполис",
  "арбутус",
  "балтимор",
  "балтимор-хайлендс",
  "бауи",
  "бетесда",
  "бладенсбург",
  "брукмонт",
  "витон",
  "вудлаун",
  "глен-барни",
  "дандальк",
  "ессекс",
  "камберленд",
  "карни",
  "катонсвилл",
  "колледж-парк",
  "колмар-манор",
  "корал-хиллс",
  "коттедж-сити",
  "крисфилд",
  "лансдаун",
  "латервилл",
  "линтикум",
  "лочирн",
  "марлау-хейгтс",
  "маунт-рейнье",
  "норт-брентвуд",
  "оверли",
  "орчард-хиллс",
  "пайксвилл",
  "памфри",
  "парквилл",
  "роквилл",
  "роседейл",
  "силвер спринг",
  "суитленд",
  "такома-парк",
  "таусон",
  "уолкер-милл",
  "фрутленд",
  "хагерстаун",
  "чеви-час",
  "чиллум",
  "элликотт-сити",
  "беллив",
  "битрайс",
  "боис-таун",
  "гранд-айленд",
  "дентон",
  "лависта",
  "мак-кук",
  "небраска-сити",
  "норт-платт",
  "омаха",
  "оффутт база ввс",
  "папиллион",
  "ралстон",
  "рока",
  "скоттсблуфф",
  "спрагуэ",
  "хикман",
  "вегас-крик",
  "виннемукка",
  "ист-лас-вегас",
  "йерингтон",
  "калинт",
  "карсон-сити",
  "лас-вегас",
  "ловелок",
  "норт-лас-вегас",
  "овертон",
  "парадайс",
  "рино",
  "тонопа",
  "фаллон",
  "эврика",
  "эли",
  "вольфеборо",
  "вудсвилл",
  "нашуа",
  "портсмоут",
  "эппинг",
  "айленд-хейгтс",
  "атлантик-сити",
  "белмар",
  "бергенфилд",
  "бичвуд",
  "блумфилд",
  "брик",
  "брик-таун",
  "бруклаун",
  "бэйонн",
  "вест-лонг-бранч",
  "вест-нью-йорк",
  "вест-орандж",
  "виктори-гарденс",
  "виллингборо",
  "винланд",
  "вихавкен",
  "вэйн",
  "гарфилд",
  "гилфорд-парк",
  "глен-ридж",
  "глочестер-сити",
  "гуттенберг",
  "деланко",
  "дельран",
  "денвилл",
  "джерси-сити",
  "инглевуд-клиффс",
  "ирвингтон",
  "ист-брунсвик",
  "ист-ньюарк",
  "ист-орандж",
  "итонтаун",
  "камден",
  "кирни",
  "клифтон",
  "клиффсайд-парк",
  "коллингсвуд",
  "лейк-парсиппани",
  "лейкхарст",
  "леониа",
  "линден",
  "лонг-бранч",
  "маунтайн-лейкс",
  "медфорд-лейкс",
  "мендхам",
  "мершантвилл",
  "монтклайр",
  "моррис-плайнс",
  "морристаун",
  "мэдисон",
  "натли",
  "нептун-сити",
  "норт-берген",
  "нью-брунсвик",
  "оаклин",
  "орандж",
  "оушн-гейт",
  "пайн-бич",
  "палисадес-парк",
  "пальмира",
  "парамус",
  "парсиппани",
  "пассаик",
  "патерсон",
  "пеннингтон",
  "пеннсаукен",
  "перт-амбой",
  "пискатавэй",
  "плайнфилд",
  "равэй",
  "риджвуд",
  "риджефилд",
  "саут-белмар",
  "саут-томс-ривер",
  "секаукус",
  "силвертон",
  "сисайд-хейгтс",
  "сэйревилл",
  "тинек",
  "томс-ривер",
  "трой-хиллс",
  "файр-лаун",
  "файрвью",
  "флорам-парк",
  "форт-ли",
  "хаддон",
  "хакенсак",
  "хановер",
  "харрисон",
  "хиллсайд",
  "хобокен",
  "холидэй-сити",
  "черри-хилл",
  "чиннаминсон",
  "эдисон",
  "элизабет",
  "юнион",
  "юнион-сити",
  "айрондекуит",
  "апалачин",
  "аргил",
  "ардсли",
  "балдвинсвилл",
  "балмвилл",
  "батавиа",
  "беллероз",
  "бетпейдж",
  "бикон",
  "бингамтон",
  "бласделл",
  "блаувелт",
  "блумингдейл",
  "брайтуотерс",
  "бринкерхофф",
  "броквэй",
  "бронкс",
  "бэй-шор",
  "бэйберри",
  "ваппингерс-фоллс",
  "ватертаун",
  "вест-айслип",
  "вест-бэбилон",
  "вест-сенека",
  "вест-хаверстроу",
  "вест-хемпстид",
  "вестал",
  "вествейл",
  "вестмер",
  "виллард",
  "вилльямсвилл",
  "виола",
  "вудсайд",
  "вэлли-стрим",
  "галвэй",
  "гейтс",
  "гилбертсвилл",
  "глен-коув",
  "гленхэм",
  "гованда",
  "грин-айленд",
  "грис",
  "грэйт-нек-эстейтс",
  "грэйтт-нек-плаза",
  "гувернье",
  "девитт",
  "депев",
  "джамайка",
  "джеймстаун",
  "джефферсон-хейгтс",
  "джонсон-сити",
  "дир-парк",
  "ист-вестал",
  "ист-миддлтаун",
  "ист-мидоу",
  "ист-патчога",
  "ист-сиракус",
  "истчестер",
  "йонкерс",
  "йорквилл",
  "йорктаун-хейгтс",
  "камиллус",
  "катскилл",
  "каттарагус",
  "квинс",
  "кев-гарденс",
  "кларенс-сентер",
  "кларк-миллс",
  "колони",
  "коммак",
  "кохоэс",
  "лакаванна",
  "латам",
  "лауренс",
  "левиттаун",
  "лейк-плэсид",
  "лейк-ронконкома",
  "лейк-саксесс",
  "либерти",
  "линденхарст",
  "линелл-мидаус",
  "линкурт",
  "локпорт",
  "лонг-айленд-сити",
  "лоудонвилл",
  "майерс-корнер",
  "манхассет",
  "маркеллус",
  "массапеква",
  "маттидейл",
  "менандс",
  "меррик",
  "миддл-айденд",
  "миддл-хоуп",
  "миноа",
  "монси",
  "моррис",
  "нануэт",
  "несконсет",
  "нискаюна",
  "норт-бэбилон",
  "норт-вэлли-стрим",
  "норт-гейтс",
  "норт-коллинс",
  "норт-сиракус",
  "норт-тонаванда",
  "нью-виндсор",
  "нью-йорк",
  "нью-йорк-миллс",
  "нью-рочелл",
  "нью-сити",
  "нью-хакенсак",
  "нью-хартфорд",
  "оберн",
  "огденсбург",
  "олин",
  "онеонта",
  "орискани",
  "орчард-парк",
  "отего",
  "оушннсайд",
  "перрисбург",
  "питчер-хилл",
  "плайнвью",
  "порт-джервис",
  "порт-джефферсон",
  "порт-честер",
  "пугкипси",
  "расселл-гарденс",
  "ред-оакс-милл",
  "ренсселер",
  "риверхед",
  "рослин-хейгтс",
  "росслевилл",
  "саддл-рок",
  "сант-джордж",
  "саранак-лейк",
  "саратога-спрингс",
  "саут-бич",
  "саут-дэйтон",
  "саут-флорал-парк",
  "сент-джеймс",
  "сентерич",
  "сентрал-айслип",
  "сильвер-крик",
  "сиракус",
  "скарсдейл",
  "слоан",
  "смиттаун",
  "солвэй",
  "стейтен-айленд",
  "стони-пойнт",
  "стоттвилл",
  "стьюарт-манор",
  "тонаванда",
  "уайт-плайнс",
  "уайтсборо",
  "уотервлит",
  "фейрмаунт",
  "филмонт",
  "фишкилл",
  "флашинг",
  "флорал-парк",
  "форест-хиллс",
  "форествилл",
  "форт-эдвард",
  "франклин-сквер",
  "фэйеттевилл",
  "хадсон",
  "хадсон-фоллс",
  "хантингтон-стэйшн",
  "харрис-хилл",
  "хартсдал",
  "хауппауг",
  "хемпстид",
  "хид-оф-ти-харбор",
  "хиксвилл",
  "хиллкрест",
  "холланд-патент",
  "черри-крик",
  "чиктовага",
  "шайлервилл",
  "шенектади",
  "элма-сентер",
  "элмира",
  "элмонт",
  "элмхарст",
  "эльмсфорд",
  "эндвелл",
  "эндикотт",
  "ютика",
  "аламогордо",
  "альбукерк",
  "антони",
  "байярд",
  "берналилло",
  "вагон-маунд",
  "гэллап",
  "декстер",
  "деминг",
  "ислета-пуэбло",
  "карлсбад",
  "карризозо",
  "киртленд",
  "корралес",
  "лас-крукес",
  "лос-аламос",
  "лос-лунас",
  "лос-ранчос-де-альбукерк",
  "месилла",
  "норт-валли",
  "парадайс-хиллс",
  "пекос",
  "ранчес-оф-таос",
  "ранчос-де-таос",
  "рейтон",
  "рио-ранчо-эстатес",
  "рой",
  "росвелл",
  "сан-фелипе-пуэбло",
  "сандиа",
  "саут-вэлли",
  "сентрал",
  "силвер-сити",
  "сокорро",
  "таос",
  "татум",
  "тесукуэ",
  "тийерас",
  "трас-ор-консекуэнсес",
  "тукумкари",
  "тьерра-амарилла",
  "уайт-рок",
  "форт-самнер",
  "харли",
  "хоббс",
  "чама",
  "чимэйо",
  "эспанола",
  "айронтон",
  "алжер",
  "амберли",
  "амесвилл",
  "амхерст",
  "аппер-арлингтон",
  "аппер-сандуски",
  "аталия",
  "аштабула",
  "баллвилл",
  "барбертон",
  "барнесвилл",
  "бачтел",
  "бедфорд-хейгтс",
  "белпр",
  "бери",
  "берки",
  "беттсвилл",
  "блеклик-эстатс",
  "блу-эш",
  "боардман",
  "браднер",
  "братеналь",
  "брук-парк",
  "бруклин-хейтс",
  "букланд",
  "бургун",
  "бутлер",
  "валбридж",
  "ван верт",
  "вандалиа",
  "варренсвилл-хейгтс",
  "ватервилл",
  "ваусеон",
  "вест карроллтон",
  "вест-портсмут",
  "вестлак",
  "виклифф",
  "виллауик",
  "виллугби-хиллс",
  "вортингтон",
  "вудбоурн",
  "вудлавн",
  "вустер",
  "галион",
  "гарфилд-хейгтс",
  "гаханна",
  "генева",
  "гирард",
  "голф манор",
  "грандвив-хейтс",
  "грин-спрингс",
  "гринхиллс",
  "гров-сити",
  "гроэсбек",
  "дальтон",
  "девола",
  "дели-хиллс",
  "дефианк",
  "джефферсон",
  "доннелсвилл",
  "евклид",
  "енон",
  "женева-он-лейк",
  "залески",
  "занесвилл",
  "индиан хилл",
  "ист-кливленд",
  "истлак",
  "йеллоу-спрингс",
  "канал-фултон",
  "касстаун",
  "касталиа",
  "катавба",
  "кенвуд",
  "кент",
  "кингсвилл",
  "кливленд",
  "кливленд-хейгтс",
  "клид",
  "клэй-сентер",
  "коал-гров",
  "коведал",
  "кридерсвилл",
  "ксениа",
  "кулвилл",
  "лакевуд",
  "лакелин",
  "лауелл",
  "лаура",
  "лейкмор",
  "лима",
  "линдхарст",
  "линколн-хейгтс",
  "линкольн-виллидж",
  "линндейл",
  "логан",
  "локингтон",
  "лорейн",
  "лоуренсвилл",
  "луки",
  "мадейра",
  "майерс-лейк",
  "мапл-хейгтс",
  "марбл-клифф",
  "маримонт",
  "маритта",
  "массиллон",
  "масури",
  "маунт-гилид",
  "маунт-хелси",
  "ментор",
  "ментор-он-те-лейк",
  "миддлбург-хейтс",
  "минерва-парк",
  "минстер",
  "миффлин",
  "могадор",
  "монфорт-хейгтс",
  "мораин",
  "муррэй-сити",
  "мутуал",
  "мэйфилд-хейгтс",
  "найлс",
  "нелсонвилл",
  "норт-кантон",
  "норт-кингсвилл",
  "норт-колледж-хилл",
  "норт-мэдисон",
  "норт-олмстед",
  "норт-рендалл",
  "норт-риджевилл",
  "нортвуд",
  "нортридж",
  "нью-бостон",
  "нью-бремен",
  "нью-винна",
  "нью-конкорд",
  "нью-ригель",
  "нью-ром",
  "нью-филадельфия",
  "ньюбург-хейгтс",
  "ньюкомерстаун",
  "ньютаун",
  "оберлин",
  "обетс",
  "оверлук",
  "олмстед-фоллс",
  "орегон",
  "оррвилл",
  "остинтаун",
  "отвэй",
  "оттава-хиллс",
  "парма-хейтс",
  "пейдж-манор",
  "пенинсула",
  "пикуа",
  "писга",
  "плайнс",
  "полк",
  "померой",
  "порт-клинтон",
  "портадж-лейкс",
  "прокторвилл",
  "рарден",
  "репаблик",
  "риверли",
  "ринолдсбург",
  "ричмонд-хейгтс",
  "розмаунт",
  "роки-ривер",
  "россфорд",
  "сабина",
  "сандуски",
  "сант-бернард",
  "саут-амхерст",
  "саут-винна",
  "саут-евклид",
  "саут-маунт-вернон",
  "саут-пойнт",
  "саут-салем",
  "севен-хиллс",
  "сиухога-фоллс",
  "сиухога-хейгтс",
  "спенкервилл",
  "стубенвилл",
  "таллмадж",
  "террак парк",
  "тимберлак",
  "тиффин",
  "толидо",
  "тремонт-сити",
  "трои",
  "тротвуд",
  "уайт-оак",
  "уайтехолл",
  "урбанкрест",
  "фаирборн",
  "файрвью-парк",
  "финдлэй",
  "флетчер",
  "форест-парк",
  "форт мккинли",
  "форт-лорами",
  "форт-шавни",
  "хаббард",
  "хайленд-хейгтс",
  "харбор-вью",
  "харрод",
  "хауленд",
  "хид-парк",
  "хиллиард",
  "христиансбург",
  "хубер-ридж",
  "хубер-хейгтс",
  "цинциннати",
  "цирклвилл",
  "чаунки",
  "чевиот",
  "честервилл",
  "честерхилл",
  "шакер-хейгтс",
  "шелби",
  "эвендейл",
  "элирия",
  "эллианс",
  "элмвуд-плейс",
  "эппл-крик",
  "юнгстаун",
  "юниверсити-хейгтс",
  "аркома",
  "атока",
  "бартлесвилл",
  "бетани",
  "варр-акрес",
  "винита",
  "вудлавн-парк",
  "вэлли-брук",
  "гленпул",
  "дель-сити",
  "дженкс",
  "жеронимо",
  "колгейт",
  "лаутон",
  "маскоги",
  "медсайн-парк",
  "мидвест-сити",
  "моффетт",
  "николс-хиллс",
  "норман",
  "оклахома",
  "покола",
  "понка-сити",
  "роланд",
  "росдейл",
  "салфур",
  "санд-спрингс",
  "сапалпа",
  "талса",
  "тарли",
  "ти-виллидж",
  "тулса",
  "форт-сапплай",
  "форт-силл",
  "чикаша",
  "шавни",
  "энид",
  "белый дом",
  "штаб главного командования",
  "бивертон",
  "вест-слоп",
  "вильсонвилл",
  "гарден-хоум",
  "даллес",
  "калли",
  "коквиль",
  "корваллис",
  "ла-гранд",
  "лейк-освего",
  "мак-миннвилл",
  "милуоки",
  "оак-гров",
  "освего",
  "паркрос",
  "пауэллхарст",
  "пендлетон",
  "портланд",
  "ралей-хиллс",
  "редмонд",
  "седар-хиллс",
  "уайтфорд",
  "хазелвуд",
  "хеликс",
  "хеппнер",
  "эррол-хейгтс",
  "эуген",
  "абингтон",
  "авока",
  "авониа",
  "аликвиппа",
  "аллентаун",
  "алтуна",
  "амблер",
  "амбридж",
  "аппер-даблин",
  "аппер-дарби",
  "аппер-мерион",
  "аппер-сант-клер",
  "ардмор",
  "аспинвалл",
  "атглен",
  "баден",
  "бала-кинвид",
  "батлер",
  "белльвью",
  "бенсалем",
  "бентливилл",
  "бетел-парк",
  "бетлехем",
  "бивер",
  "биллсвилл",
  "браддок",
  "бриджвилл",
  "брин-атин",
  "брумалл",
  "бурнхам",
  "вайомиссинг",
  "вайомиссинг-хиллс",
  "ванпорт",
  "варминстер",
  "ваттсбург",
  "вашингтонвилл",
  "веймарт",
  "вернерсвилл",
  "весливилл",
  "вест-вью",
  "вест-коншохокен",
  "вест-миддлетаун",
  "вест-миффлин",
  "вест-норритон",
  "вест-ридинг",
  "вест-фейрвью",
  "вилкес-барр",
  "вилкинсбург",
  "вилльямспорт",
  "вормлисбург",
  "вэйн-хейгтс",
  "вэйнесборо",
  "галлицин",
  "гаррисберг",
  "гейстаун",
  "грин-три",
  "данмор",
  "дарби",
  "даунингтаун",
  "дженкинтаун",
  "джонстаун",
  "дормонт",
  "дункансвилл",
  "дэвидсвилл",
  "инграм",
  "индастри",
  "ист батлер",
  "ист-бервик",
  "ист-вашингтон",
  "ист-конемауг",
  "ист-лансдаун",
  "ист-норритон",
  "ист-проспект",
  "ист-рочестер",
  "йидон",
  "йоркана",
  "канонсбург",
  "кармичелс",
  "карнеги",
  "катасуква",
  "кембридж-спрингс",
  "кенхорст",
  "кларкс-грин",
  "клифтон-хейгтс",
  "клэйсбург",
  "коатсвилл",
  "кокбург",
  "колвин",
  "колледжвилл",
  "коллингдейл",
  "конвей",
  "коннокуэнессинг",
  "коншохокен",
  "крафтон",
  "крейнсвилл",
  "крессон",
  "лангелот",
  "латроб",
  "лаурелдейл",
  "лебанон",
  "левисбург",
  "левистаун",
  "лемойн",
  "линдора",
  "линнтаун",
  "лиспорт",
  "литтл мидаус",
  "ловер-мерион",
  "ловер-мореланд",
  "лоуренс-парк",
  "лоусон-хейгтс",
  "мак-кис-рокс",
  "мак-киспорт",
  "мак-эвенсвилл",
  "манхалл",
  "марпл",
  "мартинсбург",
  "маунт-гретна",
  "маунт-лебанон",
  "маунт-оливер",
  "милл-виллидж",
  "миллбурн",
  "миллвейл",
  "монака",
  "монровилл",
  "монт-альто",
  "монтон",
  "мусик",
  "нарберт",
  "немаколин",
  "норристаун",
  "нортумберленд",
  "нью-камберленд",
  "олбани (лехай кантри)",
  "олбани (файет кантри)",
  "олд-форг",
  "пайнт",
  "пакстанг",
  "парксбург",
  "пенбрук",
  "пенн-хиллс",
  "плати",
  "раднор",
  "ранкин",
  "римс",
  "роаринг-спринг",
  "ройерсфорд",
  "рокледж",
  "росслин-фармс",
  "роузервилл",
  "саксонбург",
  "санди",
  "сант-марис",
  "саут-коатсвилл",
  "саутмонт",
  "сватара",
  "свиссвейл",
  "селлерсвилл",
  "синкинг-спринг",
  "скалп-левел",
  "спринг-сити",
  "стейт-колледж",
  "стилтон",
  "таннелхилл",
  "темпл",
  "торнбург",
  "трапп",
  "труп",
  "трупер",
  "уайтмарш",
  "филадельфия",
  "финиксвилл",
  "финливилл",
  "флемингтон",
  "фонтайн-хилл",
  "фридом",
  "хавертаун",
  "хаверфорд",
  "хазлтон",
  "хайспайр",
  "хаммельстаун",
  "хантингдон",
  "хеллертаун",
  "холлидэйсбург",
  "хоумикр",
  "хоумстид",
  "чарлерой",
  "чикора",
  "шайрманстаун",
  "швенксвилл",
  "шиллингтон",
  "шиппингпорт",
  "эвансбург",
  "эдинборо",
  "экономи",
  "эллсворт",
  "эри",
  "вунсокет",
  "ист-провиденкс",
  "кранстон",
  "паутакет",
  "провиденс",
  "гранд-форкс",
  "лер",
  "минот",
  "тиога",
  "фарго",
  "балфоур",
  "батнер",
  "билтмор-форест",
  "блак-маунтайн",
  "бурлингтон",
  "валдес",
  "вест-конкорд",
  "виллиамстон",
  "вильмингтон",
  "винстон-салем",
  "висперинг-пайнс",
  "вудфин",
  "гастониа",
  "голдсборо",
  "горман",
  "гранит-куарри",
  "гранит-фоллс",
  "давидсон",
  "дархам",
  "дрексель",
  "икард",
  "индиан-трейл",
  "каннаполис",
  "корнелиус",
  "кридмур",
  "кулими",
  "кэмп-леюн",
  "ландис",
  "ленойр",
  "мак-линсвилл",
  "маунт-холли",
  "минт-хилл",
  "моксвилл",
  "моргантон",
  "мэттьюс",
  "норт-белмонт",
  "норт-вилкесборо",
  "норт-конкорд",
  "пенелоп",
  "пинеблуфф",
  "родхисс",
  "роквелл",
  "роки-маунт",
  "рутерфордтон",
  "саммерфилд",
  "саутерн-пайнс",
  "сваннаноа",
  "силва",
  "сильвер-сити",
  "сталлингс",
  "стем",
  "уайтвилл",
  "файт",
  "фэйеттвилл",
  "хай-пойнт",
  "хантерсвилл",
  "харкерс-айленд",
  "хендерсонвилл",
  "хилдебран",
  "чайна-гров",
  "чапел-хилл",
  "шарлотт",
  "эдентон",
  "элизабет-сити",
  "эллерб",
  "энка",
  "эночвилл",
  "эшвилль",
  "адамсвиль",
  "айрон-сити",
  "аламо",
  "алгуд",
  "алкоа",
  "алтамонт",
  "аубурнтаун",
  "ашланд-сити",
  "бакстер",
  "бартлетт",
  "белл букл",
  "беллс",
  "берри хилл",
  "бетел спрингс",
  "билтмор",
  "блайн",
  "блоунтвилл",
  "блуфф-сити",
  "бридвелл-хейтс",
  "буллс-гап",
  "бунес-крик",
  "валден",
  "вартрак",
  "вудбури",
  "вэлли-форж",
  "гаинесборо",
  "галлатин",
  "гатес",
  "гибсон",
  "глисон",
  "гордонсвилл",
  "грэй",
  "гудлеттсвилл",
  "даиси",
  "дечерд",
  "джеллико",
  "джохнсон-сити",
  "диерсбург",
  "доил",
  "доуэллтаун",
  "дресден",
  "енвилл",
  "естилл спрингс",
  "етридж",
  "иглетон-виллидж",
  "иорквилл",
  "ист ридж",
  "калхоун",
  "карнс",
  "картейж",
  "кауан",
  "кентон",
  "кингстон-спрингс",
  "кларксвилл",
  "коалмонт",
  "коллегедал",
  "коллирвилл",
  "колониал-хейтс",
  "корнерсвилл",
  "кросс плаинс",
  "кукевилл",
  "кумберленд-сити",
  "ла вергн",
  "лавренкебург",
  "лакесит",
  "леноир-сити",
  "линнвилл",
  "лоретто",
  "маривилл",
  "мартин",
  "маунтайн-сити",
  "маури-сити",
  "медон",
  "мемфис",
  "миддл валли",
  "милледжевилл",
  "миллингтон",
  "минор хилл",
  "мичи",
  "мккензи",
  "мклеморесвилл",
  "мкминнвилл",
  "монтигл",
  "моррисон",
  "моунт юлит",
  "мошейм",
  "мунфорд",
  "мурфрисборо",
  "нашвилл",
  "ниота",
  "ноксвилл",
  "норманди",
  "норрис",
  "нью-маркет",
  "оак ридж",
  "обион",
  "оливер спрингс",
  "онейда",
  "оребанк",
  "пауелл",
  "пеграм",
  "пипертон",
  "пуласки",
  "ред банк",
  "риджетоп",
  "рипли",
  "руссельвиль",
  "рутерфорд",
  "салливаногарденс",
  "саут-картейж",
  "саут-кливленд",
  "саут-клинтон",
  "свитуотер",
  "севани",
  "селмер",
  "сентертаун",
  "сигнал моунтаин",
  "силертон",
  "слэйден",
  "смирна",
  "содди-даиси",
  "спарта",
  "спургеон",
  "траки-сити",
  "трезевант",
  "тримбл",
  "туллахома",
  "тун",
  "уайт-пин",
  "уайт-хаус",
  "фингер",
  "фолл-бранч",
  "фриндсвилл",
  "халлс",
  "хартсвилл",
  "хендерсон",
  "хеннинг",
  "хорнсби",
  "хохенвалд",
  "хумболдт",
  "чаттануга",
  "шарон",
  "элизабеттон",
  "эрвин",
  "этвуд",
  "этова",
  "яместаун",
  "абилин",
  "аламо-хейгтс",
  "алдайн",
  "алпин",
  "амарилло",
  "арп",
  "аспермонт",
  "бакхольтс",
  "балконес-хейгтс",
  "банкер-хилл-виллидж",
  "барнет",
  "беллэйр",
  "биг-спринг",
  "брайан",
  "брекенридж",
  "бренхам",
  "бьюмонт",
  "бэйтаун",
  "вако",
  "васком",
  "вест-лейк-хиллс",
  "вест-юниверсити-плэйс",
  "вестворт",
  "вестовер-хиллс",
  "викториа",
  "виндкрест",
  "вичита-фоллс",
  "вольффорт",
  "галена-парк",
  "гарленд",
  "гранд-прейри",
  "дайнгерфилд",
  "даллас",
  "далхарт",
  "дель-рио",
  "джакинто-сити",
  "джанкшин",
  "джордантон",
  "идалоу",
  "ирвинг",
  "камерон",
  "кастл-хиллс",
  "кермит",
  "киллин",
  "кирби",
  "кловерлиф",
  "комбес",
  "корпус-кристи",
  "купер",
  "куэро",
  "лаббок",
  "лайон-вэлли",
  "лакленд база ввс",
  "ларедо",
  "лейк-ворт",
  "либерти-сити",
  "лулинг",
  "мак-аллен",
  "мак-кинни",
  "малакофф",
  "манор",
  "мескуит",
  "мидленд",
  "миссури-сити",
  "норт-ричланд-хиллс",
  "нью-дил",
  "нью-хоум",
  "одем",
  "одесса",
  "олмос-парк",
  "олни",
  "пайни-пойнт-виллидж",
  "пампа",
  "пирленд",
  "пирсалл",
  "порт-артур",
  "праймера",
  "пфлугервилл",
  "ривер-оакс",
  "ричардсон",
  "ричланд-хиллс",
  "робстаун",
  "роллингвуд",
  "сагинау",
  "сан-анжело",
  "сан-антонио",
  "сан-бенито",
  "сансет-вэлли",
  "саут-хьюстон",
  "саутсайд-плэйс",
  "сегуин",
  "сенсом-парк-виллидж",
  "слатон",
  "сплендора",
  "тафт",
  "тексаркана",
  "тексас-сити",
  "террелл",
  "террелл-хиллс",
  "тилер",
  "торндейл",
  "тралл",
  "уайт-сеттлмент",
  "фармерс-бранч",
  "форест-хилл",
  "форт-ворт",
  "форт-уэрт",
  "халтом-сити",
  "хантерс-крик-виллидж",
  "харлинген",
  "харст",
  "хедвиг-виллидж",
  "хилл-кантри-виллидж",
  "худсон",
  "шаллоуотер",
  "шерман",
  "эль-кампо",
  "эль-пасо",
  "эндрюс",
  "азали-парк",
  "айвес-эстейтс",
  "алачуа",
  "апалачикола",
  "апопка",
  "арчер",
  "атлантик-бич",
  "бал-харбор",
  "банч-парк",
  "бартау",
  "белл-глейд",
  "беллайр",
  "беллиир",
  "беллиир-бич",
  "беллиир-блуффс",
  "бельвью",
  "би-ридж",
  "бискейн-парк",
  "бойнтон-бич",
  "бока-рейтон",
  "брадентон",
  "браунс-виллидж",
  "брент",
  "бровардейл",
  "бродвью-парк",
  "брукер",
  "бэй пинес",
  "бэй-харбор-айлендс",
  "бэйшор-гарденс",
  "вамо",
  "вахнета",
  "векива-спрингс",
  "веро-бич",
  "вест-винтер-хавен",
  "вест-и-галли",
  "вест-майами",
  "вест-палм-бич",
  "вествуд-лейкс",
  "вествью",
  "вестчестер",
  "виллистон",
  "вилтон-манорс",
  "виндермер",
  "винтер-парк",
  "винтер-хавен",
  "виргиниа-гарденс",
  "вортингтон-спрингс",
  "вригт",
  "гавана",
  "гайнесвилл",
  "галф-гейт-эстатс",
  "галф-стрим",
  "галфпорт",
  "гарлем",
  "гасьенда-виллидж",
  "гиффорд",
  "гленвар-хейгтс",
  "голден-бич",
  "голливуд",
  "гордонвилл",
  "гоулдинг",
  "гоулдс",
  "гракевилл",
  "грин-ков-спрингс",
  "гринакрес-сити",
  "дайтона-бич",
  "даниа",
  "деви",
  "джасмин-эстатс",
  "джексонвилл-бич",
  "дуннеллон",
  "египт-лейк",
  "еглин аир форк бас",
  "енсли",
  "есто",
  "игл-лейк",
  "инвуд",
  "индиан-рокс-бич",
  "индиан-харбор-бич",
  "индиан-шорес",
  "ист-лейк-парк",
  "итон-парк",
  "итонвилл",
  "каллавэй",
  "каллахан",
  "кампбеллтон",
  "карол-сити",
  "каррабелл",
  "кейп-корал",
  "кендалл",
  "ки-бискейн",
  "ки-уэст",
  "киллирн естатес",
  "кипресс-гарденс",
  "кистон-хейтс",
  "клауд-лейк",
  "клевистон",
  "клейр-мел-сити",
  "клирватер",
  "кокоа-бич",
  "коконат-крик",
  "колльер-сити",
  "комби-сеттлмент",
  "корал-габлс",
  "лак магдален",
  "лак-керролл",
  "лакеланд",
  "лантана",
  "ларго",
  "лаудердейл-бай-ти-си",
  "лаудердейл-лейкс",
  "лаудерхилл",
  "леди-лейк",
  "лей-люцерн",
  "лейзи-лейк",
  "лейк-альфред",
  "лейк-кларк-шорес",
  "лейквуд-парк",
  "лейсур-сити",
  "лето",
  "лив-оак",
  "лилман",
  "линн-хавен",
  "лонгбоат-ки",
  "лутз",
  "мадейра-бич",
  "майами",
  "майами-бич",
  "майами-спрингс",
  "майами-шорес",
  "майтленд (лейк майтленд)",
  "макинтош",
  "малабар",
  "маналапан",
  "манго",
  "мангониа-парк",
  "маратон",
  "медли",
  "мельбурн-виллидж",
  "мерритт-айленд",
  "мидоубрук-террас",
  "миканопи",
  "мирамар",
  "молино",
  "наплес",
  "нептун-бич",
  "никевилл",
  "нома",
  "норланд",
  "норт-бэй-виллидж",
  "норт-майами",
  "норт-майами-бич",
  "норт-порт",
  "норт-редингтон-бич",
  "норт-форт-майерс",
  "норт-эндрюс-гарденс",
  "оакленд-парк",
  "обурндейл",
  "окала",
  "окин-сити",
  "олдсмар",
  "олимпиа-хейгтс",
  "онеко",
  "опа-лока",
  "оранж-парк",
  "оринт-парк",
  "орландо",
  "орловиста",
  "ормонд-бич",
  "оспри",
  "оушн-ридж",
  "оюс",
  "пайн-хиллс",
  "пайнвуд",
  "пак",
  "пакстон",
  "палм-бич",
  "палм-ривер",
  "палм-шорес",
  "панама-сити",
  "пахоки",
  "пемброк-пайнс",
  "пемброк-парк",
  "пенни-фармс",
  "пенсакола",
  "пинеллас-парк",
  "плантешн",
  "помпано-бич",
  "помпано-парк",
  "порт-санта-лючия",
  "порт-шарлотт",
  "принстон",
  "пунта-горда",
  "реддик",
  "редингтон-бич",
  "редингтон-шорес",
  "рускин",
  "самосет",
  "санни-айлс",
  "санрайс",
  "сант-аугустин",
  "сант-петерсбург",
  "сант-петерсбург-бич",
  "сарасота",
  "сарасота-спрингс",
  "сарфсайд",
  "сателлайт-бич",
  "саут-апопка",
  "саут-бэй",
  "саут-дайтона",
  "саут-майами",
  "саут-майами-хейгтс",
  "саут-палм-бич",
  "сафти-харбор",
  "свитватер-крик",
  "свитвотер",
  "седар-гров",
  "сентури",
  "сеффнер",
  "си-ранч-лейкс",
  "сиеста-ки",
  "солана",
  "таварес",
  "тавернир",
  "талахасси",
  "тамайами",
  "тамарак",
  "тампа",
  "темпл-террас",
  "тик",
  "титусвилл",
  "трайлер-эстатс",
  "трежа-айленд",
  "уайтфилд-эстатс",
  "уматилла",
  "файрвью-шорес",
  "ферн-парк",
  "ферри пасс",
  "форест-сити",
  "форт-лаудердейл",
  "форт-майерс",
  "форт-мид",
  "форт-пирс",
  "фрутвилл",
  "фрутланд-парк",
  "хайленд-парк",
  "хайленд-сити",
  "хиалеа",
  "хиполуксо",
  "холден-хейгтс",
  "холли-хилл",
  "хоместид-айр-форс-бэйс",
  "шалимар",
  "шарлотт-парк",
  "шарлотт-харбор",
  "эджвуд",
  "элоис",
  "эль-портал",
  "яи",
  "гурон",
  "митчелл",
  "пирр",
  "рапид-сити",
  "редфилд",
  "сиу-фоллс",
  "спирфиш",
  "аркадиа-лейкс",
  "валенсиа-хейгтс",
  "вест-колумбиа",
  "вудфилд",
  "гринвуд",
  "дентсвилл",
  "джеймс-айленд",
  "капитол-вью",
  "кейси",
  "пайнридж",
  "рок-хилл",
  "самтер",
  "сенека",
  "спартанбург",
  "флоренс",
  "форест-акрес",
  "хемингуэй",
  "чарльстон-хейгтс",
  "американ-форк",
  "беннион",
  "боунтифул",
  "бригам-сити",
  "вал-верда",
  "вашингтон-террас",
  "вернал",
  "вест-боунтифул",
  "вест-джордан",
  "вест-пойнт",
  "вудс-кросс",
  "ганнисон",
  "гранит-парк",
  "делта",
  "ист-лэйтон",
  "ист-миллкрик",
  "канаб",
  "кирнс",
  "клирфилд",
  "коттонвуд-хейгтс",
  "линдон",
  "маунт-олимпус",
  "мидвейл",
  "моаб",
  "монтичелло",
  "моунт-плисант",
  "муррей",
  "нефи",
  "норт-солт-лейк",
  "орем",
  "пангуитч",
  "плисант-гров",
  "прик",
  "прово",
  "ривердейл",
  "русвельт",
  "саут-вебер",
  "саут-коттонвуд",
  "саут-огден",
  "саут-солт-лейк",
  "солт-лейк-сити",
  "спрингвилл",
  "тэйлорсвилл",
  "уинта",
  "филлмор",
  "харрисвилл",
  "холладей",
  "ванч",
  "висхарв",
  "вранг",
  "ишкашим",
  "кудара",
  "мургаб",
  "рангкуль",
  "рушан",
  "токтомуш",
  "хорог",
  "шазуд",
  "шаймак",
  "дангара",
  "куляб",
  "лениградский",
  "пархар",
  "ховалинг",
  "калининабад",
  "колхозабад",
  "курган-тюбе",
  "нижний пяндж",
  "пяндж",
  "шаартуз",
  "яван",
  "адрасман",
  "айни",
  "ашт",
  "бустон",
  "ганчи",
  "гафуров",
  "зафарабад",
  "зеравшан",
  "исфара",
  "кайракуум",
  "канибадам",
  "кансай",
  "нау",
  "наугарзан",
  "пенджикент",
  "табошар",
  "ура-тюбе",
  "шураб",
  "варзоб",
  "гарм",
  "гиссар",
  "джиргатель",
  "душанбе",
  "калаи-хумб",
  "насруд",
  "нурек",
  "турсунзаде",
  "файзабад",
  "ашхабад",
  "бабадурмаз",
  "бахарден",
  "бахардок",
  "безмеин",
  "геок-тепе",
  "дарваза",
  "душак",
  "каахка",
  "полехатум",
  "серахс",
  "теджен",
  "бекдаш",
  "гасан-кули",
  "джанга",
  "джебел",
  "казанджик",
  "кара-кала",
  "карагель",
  "кизыл-арват",
  "кизыл-атрек",
  "кизыл-су",
  "красноводск",
  "кум-даг",
  "небит-даг",
  "уфра",
  "чагыл",
  "челекен",
  "байрам-али",
  "захмет",
  "иолотань",
  "кушка",
  "мары",
  "сакар-чага",
  "сандыкачи",
  "тахта-базар",
  "ташкепри",
  "туркмен-кала",
  "уч-аджи",
  "куня-ургенч",
  "ташауз",
  "аму-дарья",
  "газ-ачак",
  "гаурдак",
  "дарган-ата",
  "дейнау",
  "карабекаул",
  "керки",
  "мукры",
  "нефтезаводск",
  "сакар",
  "саят",
  "фараб",
  "халач",
  "чарджоу",
  "чаршанга",
  "кев",
  "теркс-айлендс",
  "бартын",
  "байбурт",
  "карабук",
  "адана",
  "айдын",
  "амасья",
  "анкара",
  "анталия",
  "артвин",
  "афьон",
  "балыкесир",
  "биледжик",
  "бурса",
  "газиантеп",
  "денизли",
  "измир",
  "испарта",
  "мерсин",
  "кэйсери",
  "карс",
  "измит",
  "кокели",
  "кониа",
  "кириккал",
  "кутахиа",
  "малатиа",
  "маниса",
  "адапазари",
  "самсун",
  "сивас",
  "стамбул",
  "трабзон",
  "требизонд",
  "корум",
  "эдирн",
  "элазиг",
  "эрзинкан",
  "эрзурум",
  "ескисехир",
  "йиня",
  "кампала",
  "алтынкуль",
  "андижан",
  "балыкчи",
  "мархамат",
  "советабад",
  "шахрихан",
  "алат",
  "бухара",
  "вабкент",
  "газли",
  "галаасия",
  "гиждуван",
  "каган",
  "каракуль",
  "ромитан",
  "галляарал",
  "джизак",
  "заамин",
  "койташ",
  "усмат",
  "янгикишлак",
  "кегейли",
  "кунград",
  "мангит",
  "муйнак",
  "нукус",
  "тахиаташ",
  "тахтакупыр",
  "турткуль",
  "ходжейли",
  "чимбай",
  "шуманай",
  "бешкент",
  "гузар",
  "карши",
  "касан",
  "китаб",
  "шахрисабз",
  "навои",
  "тамдыбулак",
  "учкудук",
  "касансай",
  "наманган",
  "пап",
  "учкурган",
  "чартак",
  "чуст",
  "янгикурган",
  "ингичка",
  "каттакурган",
  "красногвардейск",
  "самарканд",
  "ургут",
  "байсун",
  "денау",
  "карлук",
  "термез",
  "узун",
  "шерабад",
  "шурчи",
  "бахт",
  "верхневолынское",
  "гулистан",
  "димитровское",
  "крестьянский",
  "сырдарья",
  "сырьдарья",
  "хаваст",
  "янгиер",
  "алимкент",
  "алмазар",
  "алмалык",
  "ангрен",
  "ахангаран",
  "бакабад",
  "бекабад",
  "бука",
  "газалкент",
  "искандар",
  "келес",
  "паркент",
  "пскент",
  "сиджак",
  "солдатский",
  "ташкент",
  "тойтепа",
  "чиназ",
  "чирчик",
  "янгиабад",
  "янгибазар",
  "янгиюль",
  "алтыарык",
  "вуадиль",
  "коканд",
  "кува",
  "кувасай",
  "маргилан",
  "учкуприк",
  "фергана",
  "язъяван",
  "яйпан",
  "ургенч",
  "хива",
  "бар",
  "бершадь",
  "браилов",
  "брацлав",
  "вапнярка",
  "вендичаны",
  "винница",
  "вороновица",
  "гайсин",
  "гнивань",
  "дашев",
  "жмеринка",
  "ильинцы",
  "казатин",
  "калиновка",
  "крыжополь",
  "липовец",
  "литин",
  "могилев-подольский",
  "мурованные куриловцы",
  "немиров",
  "оратов",
  "песчанка",
  "погребище",
  "теплик",
  "томашполь",
  "тростянец",
  "тульчин",
  "тывров",
  "хмельник",
  "чечельник",
  "шаргород",
  "ямполь",
  "берестечко",
  "владимир-волынский",
  "голобы",
  "головно",
  "горохов",
  "заболотье",
  "иваничи",
  "камень-каширский",
  "киверцы",
  "ковель",
  "локачи",
  "луцк",
  "любешов",
  "любомль",
  "маневичи",
  "нововолынск",
  "ратно",
  "рожище",
  "старая выжевка",
  "турийск",
  "апостолово",
  "аулы",
  "брагиновка",
  "васильковка",
  "верхнеднепровск",
  "верховцево",
  "вольногорск",
  "гвардейское",
  "горняцкое",
  "губиниха",
  "демурино",
  "днепродзержинск",
  "днепропетровск",
  "желтые воды",
  "зализничное",
  "зеленое",
  "илларионово",
  "ингулец",
  "карнауховка",
  "кривой рог",
  "кринички",
  "магдалиновка",
  "марганец",
  "межевая",
  "никополь",
  "павлоград",
  "пятихатки",
  "синельниково",
  "софиевка",
  "томаковка",
  "царичанка",
  "широкое",
  "авдеевка",
  "александровка",
  "алексеево-дружковка",
  "амвросиевка",
  "артемово",
  "безыменное",
  "беленькое",
  "белицкое",
  "благодатное",
  "былбасовка",
  "великая новоселка",
  "войковский",
  "волноваха",
  "гольмовский",
  "горбачево-михайловка",
  "горловка",
  "гродовка",
  "грузско-зорянское",
  "дебальцево",
  "димитров",
  "доброполье",
  "докучаевск",
  "донецкая",
  "дробышево",
  "дружковка",
  "енакиево",
  "жданов",
  "желанное",
  "зугрэс",
  "иловайск",
  "карло-либкнехтовск",
  "карло-марксово",
  "краматорск",
  "красный лиман",
  "макеевка",
  "мариуполь",
  "марьинка",
  "новоазовск",
  "новоэкономическое",
  "першотравневое",
  "селидово",
  "славянск",
  "снежное",
  "старобешево",
  "тельманово",
  "торез",
  "харцызск",
  "ясиноватая",
  "андрушевка",
  "барановка",
  "белая криница",
  "бердичев",
  "броницкая гута",
  "брусилов",
  "быковка",
  "великие коровинцы",
  "володарск-волынский",
  "городница",
  "гришковцы",
  "довбыш",
  "емильчино",
  "житомир",
  "иванополь",
  "каменный брод",
  "коростень",
  "коростышев",
  "лугины",
  "любар",
  "малин",
  "народичи",
  "новоград-волынский",
  "овруч",
  "олевск",
  "попельня",
  "радомышль",
  "ружин",
  "червоноармейск",
  "черняхов",
  "чуднов",
  "берегово",
  "буштына",
  "великий березный",
  "великий бычков",
  "виноградов",
  "воловец",
  "иршава",
  "межгорье",
  "мукачево",
  "перечин",
  "рахов",
  "свалява",
  "тячев",
  "ужгород",
  "хуст",
  "чоп",
  "акимовка",
  "балабино",
  "бердянск",
  "веселое",
  "гуляйполе",
  "запорожье",
  "каменка-днепровская",
  "каменное",
  "камыш-заря",
  "мелитополь",
  "новониколаевка",
  "орехов",
  "пологи",
  "приазовское",
  "приморск",
  "богородчаны",
  "болехов",
  "болшовцы",
  "брошнев-осада",
  "букачевцы",
  "бурштын",
  "бытков",
  "верховина",
  "войнилов",
  "ворохта",
  "выгода",
  "гвоздец",
  "городенка",
  "делятин",
  "жовтень",
  "заболотов",
  "ивано-франковск",
  "калуж",
  "калуш",
  "коломыя",
  "косов",
  "надворна",
  "надворная",
  "рогатин",
  "рожнятов",
  "снятын",
  "станиславов",
  "тлумач",
  "тысменица",
  "яремча",
  "барышевка",
  "белая церковь",
  "березань",
  "богуслав",
  "борисполь",
  "боровая",
  "бородянка",
  "бровары",
  "васильков",
  "володарка",
  "ворзель",
  "гребенки",
  "дымер",
  "згуровка",
  "иванков",
  "ирпень",
  "кагарлык",
  "киев",
  "киевская",
  "кодра",
  "кожанка",
  "козин",
  "обухов",
  "переяслав-хмельницкий",
  "полесское",
  "сквира",
  "ставище",
  "тараща",
  "тетиев",
  "фастов",
  "чернобыль",
  "яготин",
  "алексадровка",
  "бобринец",
  "гайворон",
  "голованевск",
  "добровеличковка",
  "долинская",
  "елизаветградка",
  "завалье",
  "знаменка-вторая",
  "капитановка",
  "кировоград",
  "компанеевка",
  "малая виска",
  "новгородка",
  "новоархангельск",
  "новомиргород",
  "новоукраинка",
  "ольшанка",
  "онуфриевка",
  "петрово",
  "светловодск",
  "ульяновка",
  "устиновка",
  "азовское",
  "алупка",
  "алушта",
  "багерово",
  "балаклава",
  "бахчисарай",
  "гаспра",
  "гурзуф",
  "джанкой",
  "евпатория",
  "зуя",
  "керчь",
  "красноперекопск",
  "ленино",
  "массандра",
  "нижнегорский",
  "раздольное",
  "саки",
  "севастополь",
  "симферополь",
  "судак",
  "феодосия",
  "форос",
  "черноморское",
  "ялта",
  "алексадровск",
  "алчевск",
  "антрацит",
  "байрачки",
  "беловодск",
  "белогоровка",
  "белое",
  "белокуракино",
  "белолуцк",
  "бирюково",
  "боково-платово",
  "боровское",
  "брянка",
  "бугаевка",
  "вахрушево",
  "великий лог",
  "вергулевка",
  "волчеяровка",
  "ворошиловград",
  "врубовка",
  "врубовский",
  "горское",
  "есауловка",
  "зимогорье",
  "золотое",
  "зоринск",
  "изварино",
  "калининский",
  "калиново",
  "камышеваха",
  "коммунарск",
  "краснодон",
  "красный луч",
  "кременная",
  "лисичанск",
  "луганск",
  "лутугино",
  "марковка",
  "меловое",
  "новоайдар",
  "новопсков",
  "перевальск",
  "попасная",
  "рубежное",
  "сватово",
  "северодонецк",
  "славяносербск",
  "станично-луганское",
  "старобельск",
  "стаханов",
  "белз",
  "бобрка",
  "борислав",
  "броды",
  "буск",
  "великие мосты",
  "верхнее синевидное",
  "винники",
  "глиняны",
  "дашава",
  "добротвор",
  "дрогобыч",
  "жидачов",
  "жолкиев",
  "золочев",
  "ивано-франково",
  "каменка-бугская",
  "львов",
  "мостиска",
  "николаев",
  "перемышляны",
  "пустомыты",
  "рава русская",
  "радехов",
  "самбор",
  "сколе",
  "сокаль",
  "старый самбор",
  "стрый",
  "трускавец",
  "турка",
  "червоноград",
  "яворов",
  "арбузинка",
  "баштанка",
  "березнеговатое",
  "братское",
  "великая корениха",
  "веселиново",
  "вознесенск",
  "доманевка",
  "еланец",
  "казанка",
  "кривое озеро",
  "новая одесса",
  "новый буг",
  "очаков",
  "снигиревка",
  "ананьев",
  "арциз",
  "балта",
  "белгород-днестровский",
  "березовка",
  "болград",
  "великая михайловка",
  "великодолининское",
  "вилково",
  "затишье",
  "измаил",
  "килия",
  "кодыма",
  "коминтерновское",
  "красные окны",
  "любашевка",
  "николаевка",
  "овидиополь",
  "раздельная",
  "рени",
  "саврань",
  "сарата",
  "тарутино",
  "татарбунары",
  "фрунзовка",
  "ширяево",
  "белики",
  "великая багачка",
  "гадяч",
  "глобино",
  "гоголево",
  "градижск",
  "гребенка",
  "диканька",
  "зеньков",
  "карловка",
  "кобеляки",
  "козельщина",
  "котельва",
  "кременчуг",
  "лохвица",
  "лубны",
  "машевка",
  "миргород",
  "новые санжары",
  "оржица",
  "пирянтин",
  "пирятин",
  "полтава",
  "решетиловка",
  "семеновка",
  "хорол",
  "чернухи",
  "чутово",
  "шишаки",
  "владимирец",
  "гоща",
  "демидовка",
  "дубно",
  "дубровица",
  "заречное",
  "здолбунов",
  "клевань",
  "клесов",
  "корец",
  "костополь",
  "кузнецовск",
  "млинов",
  "острог",
  "ровно",
  "сарны",
  "ахтырка",
  "белополье",
  "бурынь",
  "великая писаревка",
  "ворожба",
  "глухов",
  "дружба",
  "знобь-новгородское",
  "кириковка",
  "конотоп",
  "кровелец",
  "лебедин",
  "липовая долина",
  "недригайлов",
  "путивль",
  "середина-буда",
  "сумы",
  "шостка",
  "шурупинское",
  "бережаны",
  "борщев",
  "бучач",
  "великие борки",
  "вишневец",
  "гримайлов",
  "гусятин",
  "залещики",
  "заложцы",
  "збараж",
  "зборов",
  "золотники",
  "золотойпоток",
  "козлов",
  "козова",
  "кременец",
  "лановцы",
  "монастыриска",
  "подволочиск",
  "теребовля",
  "тернополь",
  "чортков",
  "шумское",
  "балаклея",
  "барвенково",
  "близнюки",
  "богодухов",
  "борки",
  "буды",
  "валки",
  "великий бурлук",
  "готвальд",
  "гуты",
  "зачепиловка",
  "зидьки",
  "изюм",
  "казачья лопань",
  "кегичевка",
  "красноград",
  "купянск",
  "лозовая",
  "люботин",
  "новая водолага",
  "сахновщина",
  "харьков",
  "чугуев",
  "шевченково",
  "аскания-нова",
  "белозерка",
  "берислав",
  "великая александровка",
  "великая лепетиха",
  "верхний рогачик",
  "высокополье",
  "геническ",
  "голая пристань",
  "горностаевка",
  "днепряны",
  "каланчак",
  "калининское",
  "каховка",
  "нижние серогозы",
  "новая каховка",
  "нововоронцовка",
  "скадовск",
  "херсон",
  "цюрупинск",
  "чаплинка",
  "антонины",
  "базалия",
  "белогорье",
  "виньковцы",
  "волочиск",
  "грицев",
  "деражня",
  "дунаевцы",
  "изяслав",
  "каменец-подольский",
  "красилов",
  "летичев",
  "новая ушица",
  "полонное",
  "славута",
  "старая синява",
  "староконстантинов",
  "теофиполь",
  "хмельницкий",
  "чемеровцы",
  "шепетовка",
  "ярмолинцы",
  "ватутино",
  "драбов",
  "ерки",
  "жашков",
  "зараевск",
  "звенигородка",
  "золотоноша",
  "ирдынь",
  "катеринополь",
  "корсунь-шевченковский",
  "лысянка",
  "маньковка",
  "монастырище",
  "смела",
  "тальное",
  "умань",
  "христиновка",
  "черкассы",
  "чернобай",
  "чигирин",
  "шпола",
  "батурин",
  "бахмач",
  "березна",
  "бобровица",
  "борзна",
  "варва",
  "вертиевка",
  "городня",
  "замглай",
  "ичня",
  "козелец",
  "короп",
  "корюковка",
  "куликовка",
  "нежин",
  "новгород северский",
  "носовка",
  "прилуки",
  "репки",
  "сосница",
  "талалаевка",
  "чернигов",
  "щорс",
  "берегомет",
  "вашковцы",
  "вижница",
  "герца",
  "глыбокая",
  "заставна",
  "кельменцы",
  "кицмань",
  "новоселица",
  "путила",
  "сокиряны",
  "сторожинец",
  "хотин",
  "черновцы",
  "лаппеенранта",
  "лахти",
  "вааса",
  "оулу",
  "куопио",
  "пори",
  "турку",
  "ийваскила",
  "хельсинки",
  "эспоо",
  "сен-брие",
  "montluзon",
  "гап",
  "антибе",
  "канны",
  "ницца",
  "шарлевиль",
  "бельфор",
  "а-ен-провенс",
  "марсель",
  "аргентоль",
  "виллежюи",
  "винсенне",
  "витри",
  "иври",
  "кретейл",
  "маисон-альфорт",
  "сен-мар-дес-фоссе",
  "фонтеней-су-буа",
  "чойси-ле-руа",
  "шампини-сюр-мар",
  "ла-сен-сюр-мер",
  "тулон",
  "эпиналь",
  "авиньон",
  "пуатье",
  "лимож",
  "ним",
  "тулуза",
  "ньор",
  "валенс",
  "монтелимар",
  "безансон",
  "бордо",
  "версаль",
  "ренн",
  "сант-мало",
  "бриве-ла-жилларде",
  "бастия",
  "аяччо",
  "дижон",
  "мон-де-марсан",
  "ажен",
  "манд",
  "блоис",
  "руанн",
  "сен-этьен",
  "нант",
  "сен-назар",
  "ле-пюи",
  "орлеан",
  "реймс",
  "шалон-сюр-мар",
  "анже",
  "чолет",
  "нанси",
  "мец",
  "лорьент",
  "валенсинье",
  "дуа",
  "лилль",
  "рубо",
  "туркуа",
  "невер",
  "асньер",
  "булонь-билланкур",
  "женневилльер",
  "исси-ле-мулино",
  "кламарт",
  "кличи",
  "коломбес",
  "курбеву",
  "левальлуи-перре",
  "монтруж",
  "нантерре",
  "нюилли-сюр-сен",
  "руэль-мальмасон",
  "сет",
  "суреснес",
  "труа",
  "каркассон",
  "алансон",
  "аррас",
  "бруа-эн-арто",
  "ленс",
  "париж",
  "байонна",
  "по",
  "тарб",
  "перпиньян",
  "колмар",
  "мулхаузен",
  "мулхаус",
  "страсбург",
  "вениссо",
  "виллеурбанн",
  "лион",
  "шамбери",
  "аннеси",
  "ле-ман",
  "бобини",
  "бонди",
  "дранси",
  "ла-курнье",
  "ле-бланк-меснил",
  "монтреуил",
  "обервилье",
  "ольни-су-буа",
  "пантин",
  "сен-дени",
  "эпини-сюр-сен",
  "гавр",
  "руан",
  "амьен",
  "шалон-сур-сон",
  "альби",
  "бювэ",
  "кемпер",
  "ангулем",
  "ла-рошель",
  "бурже",
  "сен-квентин",
  "шатору",
  "тур",
  "гренобль",
  "безье",
  "эвре",
  "чешке-будейовице",
  "брно",
  "карловы вары",
  "храдец-кралове",
  "либерец",
  "яблонец-над-нисой",
  "карвина",
  "опава",
  "острава",
  "фрыдек-мистек",
  "хавиров",
  "оломоук",
  "преров",
  "простеёв",
  "кладно",
  "дечин",
  "мост",
  "усти-над-лабем",
  "чомутов",
  "аарау",
  "базель",
  "берн",
  "кониц",
  "лозанна",
  "солотурн",
  "люцерн",
  "ла-шо-де-фонд",
  "ньюшатель",
  "лугано",
  "фрейбург",
  "фрибург",
  "винтертур",
  "цюрих",
  "лунд",
  "мальмё",
  "хельсингборг",
  "борас",
  "гетеборг",
  "троллхаттан",
  "карлстад",
  "уми",
  "сундсваль",
  "вастерас",
  "гавл",
  "эстерсунд",
  "йонкопинг",
  "эскилстуна",
  "содерталье",
  "сольна",
  "стокгольм",
  "уппсала",
  "хельмстад",
  "линкопинг",
  "абья-палуоя",
  "антсла",
  "валга",
  "васкнарва",
  "вильянди",
  "выру",
  "йыгева",
  "калласте",
  "кейла",
  "кехра",
  "кивиыли",
  "килинги",
  "килинги-нымме",
  "кохтла-ярве",
  "кярдла",
  "муствээ",
  "мыйзакюла",
  "нарва",
  "пайде",
  "пылтсамаа",
  "пярну",
  "раквере",
  "рапла",
  "силламяэ",
  "сууре-яани",
  "тапа",
  "тарту",
  "тырва",
  "хаапсалу",
  "эльва",
  "зренянин",
  "нови-сад",
  "панцево",
  "суботица",
  "приштина",
  "белград",
  "крагуевач",
  "нис",
  "чею",
  "кунсан",
  "намвон",
  "йосу",
  "мокп`о",
  "чечон",
  "чонгжу",
  "чунгжу",
  "ч`онан",
  "инчхон",
  "вонжу",
  "кангнунг",
  "чунчон",
  "кванчжу",
  "йонгжу",
  "сувон",
  "андонг",
  "кионгджу",
  "п`оханг",
  "сангю",
  "масан",
  "мирианг",
  "чинхэ",
  "чиню",
  "пусан",
  "сеул",
  "тэгу",
  "тэджон",
  "ульсан",
  "ичиномия",
  "касугаи",
  "нагоиа",
  "оказаки",
  "тойота",
  "тойохаши",
  "акита",
  "иокот",
  "ноширо",
  "ога",
  "одат",
  "аомори",
  "гошогавара",
  "тауада",
  "хачинохе",
  "хиросаки",
  "вакэйама",
  "шингу",
  "гифу",
  "огаки",
  "тайими",
  "такэйама",
  "кириу",
  "мебаши",
  "нумата",
  "ота",
  "такасаки",
  "ибараки",
  "ина",
  "катсута",
  "китаибараки",
  "мито",
  "омииа",
  "хитачи",
  "ичиносеки",
  "мизусава",
  "мииако",
  "мориока",
  "ханамаки",
  "кага",
  "каназава",
  "коматсу",
  "нанао",
  "сакаиде",
  "такаматсу",
  "изуми",
  "кагошима",
  "каноя",
  "наз",
  "айкава",
  "ацуги",
  "зуши",
  "йокогама",
  "йокосука",
  "камакура",
  "одавара",
  "сагамихара",
  "фуйисава",
  "хиратсука",
  "чигасаки",
  "камеока",
  "киото",
  "маизуру",
  "уйи",
  "фукучииама",
  "кочи",
  "нанкоку",
  "кумамото",
  "минамата",
  "хитоиоши",
  "исе",
  "матсусака",
  "сузука",
  "тсу",
  "ишиномаки",
  "кесеннума",
  "фурукава",
  "кобэйаши",
  "мииазаки",
  "мииаконойо",
  "нобеока",
  "саито",
  "хиуга",
  "матсумото",
  "нагано",
  "саку",
  "сува",
  "уеда",
  "исахая",
  "нагасаки",
  "сасэбо",
  "шимабара",
  "кашихара",
  "нара",
  "сакураи",
  "тенри",
  "кашивазаки",
  "нагаока",
  "оджия",
  "санйо",
  "цубаме",
  "шибата",
  "курашики",
  "окэйама",
  "цуяма",
  "ишигаки",
  "наха",
  "даито",
  "кайзука",
  "кишивада",
  "матсубара",
  "моригучи",
  "ниагава",
  "осака",
  "суита",
  "такаиши",
  "такатсуки",
  "тоионака",
  "тондабаяши",
  "хабикино",
  "хигашиосака",
  "хираката",
  "яо",
  "имари",
  "каратсу",
  "сага",
  "тосу",
  "ямато",
  "вараби",
  "иватсуки",
  "йоно",
  "кавагоэ",
  "кавагучи",
  "касукаб",
  "кошигэйа",
  "кумагэйа",
  "сока",
  "ханно",
  "чичибу",
  "отсу",
  "хикон",
  "атами",
  "фуджи",
  "иаизу",
  "ивата",
  "изумо",
  "ито",
  "масуда",
  "матсуэ",
  "мишима",
  "нумазу",
  "ода",
  "ояма",
  "хамада",
  "хамаматсу",
  "шизуока",
  "шимизу",
  "ичикава",
  "кашива",
  "кисаразу",
  "матсудо",
  "мобара",
  "нарашино",
  "нода",
  "савара",
  "татиама",
  "фунабаши",
  "хоши",
  "чиба",
  "кодаира",
  "мачида",
  "митака",
  "мусашино",
  "тачикава",
  "токио",
  "хачиойи",
  "хофу",
  "анан",
  "токушима",
  "ашикага",
  "кавачи",
  "канума",
  "отавара",
  "утсуномииа",
  "йонаго",
  "курэйоши",
  "тоттори",
  "камишии",
  "такаока",
  "тояма",
  "уозу",
  "хими",
  "оно",
  "сабе",
  "такефу",
  "тсуруга",
  "фукуи",
  "амаги",
  "иукухаши",
  "кавасаки",
  "китакиушу",
  "курум",
  "ногата",
  "омута",
  "фукуока",
  "иваки",
  "корииама",
  "кур",
  "ономичи",
  "фукуиама",
  "хирошима",
  "абашири",
  "асахигава",
  "ашибецу",
  "бибаи",
  "вакканаи",
  "китами",
  "куширо",
  "момбетсу",
  "муроран",
  "немуро",
  "обихиро",
  "отару",
  "румои",
  "саппоро",
  "томакомаи",
  "эбетсу",
  "юбари",
  "акаши",
  "амагасаки",
  "ашия",
  "итами",
  "каваниши",
  "какогава",
  "нишиномия",
  "тоёока",
  "химейи",
  "иаватахама",
  "имабари",
  "матсуиама",
  "озу",
  "увайима",
  "иамагата",
  "ионезава",
  "саката",
  "тендо",
  "тсуруока",
  "тсучиура",
  "шинйо",
  "ивакуни",
  "онода",
  "токуиама",
  "убе",
  "хаги",
  "шимоносеки",
  "ямагучи",
  "кофу",
  "биласувар",
  "апаран",
  "ванадзор",
  "севан",
  "ак-коль",
  "актобе",
  "акший",
  "аршалы",
  "атбасар",
  "атырау",
  "балкашино",
  "жезказган",
  "кокшетау",
  "костанай",
  "кызылорда",
  "махамбет",
  "шымкент",
  "ак-суу",
  "беловодское",
  "жалал абад",
  "каинда",
  "каракол",
  "кемин",
  "кербен",
  "кызыл суу",
  "лебединовка",
  "майлуу-суу",
  "пульгон",
  "сокулук",
  "чуй",
  "эски-ноокат",
  "гулбене",
  "нида",
  "вахш",
  "джиргаталь",
  "дусти",
  "кофарнихон",
  "куйбышевск",
  "московский",
  "орджоникидзеабад",
  "армянск",
  "артек",
  "береговое",
  "ботаническое",
  "кастрополь",
  "кацивели",
  "кореиз",
  "краснокаменка",
  "курпаты",
  "ливадия",
  "мисхор",
  "олива",
  "оползневое",
  "парковое",
  "понизовка",
  "санаторное",
  "симеиз",
  "таллинн",
  "авимор",
  "ада",
  "айзенштадт",
  "албена",
  "альмерия",
  "амштеттен",
  "арлон",
  "ауе",
  "бад киссинген",
  "бад херсфельд",
  "бельско-бяла",
  "бистрица",
  "борнмут",
  "боровец",
  "ботошани",
  "брегенц",
  "бремерхафен",
  "брюгге",
  "бурлэнге",
  "бухарест",
  "вайден",
  "вайсенбург",
  "вальядолид",
  "варен",
  "васа",
  "вране",
  "враца",
  "вршац",
  "гаага",
  "галац",
  "гарделеген",
  "гент",
  "геттинген",
  "гмунден",
  "госпич",
  "гус",
  "дева",
  "джурджу",
  "дорнбирн",
  "дортмунд",
  "дубровник",
  "дюнкерк",
  "елхово",
  "загреб",
  "замосць",
  "засниц",
  "зелена гура",
  "золотые пески",
  "ибиза",
  "ивало",
  "иломантси",
  "инсбрук",
  "иска",
  "кампобассо",
  "камчия",
  "карансебеш",
  "карлови-вари",
  "картахена",
  "касерес",
  "кельн",
  "кикинда",
  "кицбюэль",
  "клуж-напока",
  "колашин",
  "констанца",
  "коста брава",
  "коста дорада",
  "коста дель соль",
  "котка",
  "кочевье",
  "крайова",
  "кранево",
  "кротоне",
  "крушевац",
  "куфштайн",
  "кюстендил",
  "ла-корунья",
  "лемборк",
  "линген",
  "ловеч",
  "локарно",
  "лулеа",
  "майрхофен",
  "малунг",
  "мангалия",
  "махриханиш",
  "мерибель",
  "миккели",
  "михайловград",
  "монс",
  "муонио",
  "мюльдорф",
  "мюнхен",
  "наварра",
  "намюр",
  "неаполь",
  "ниш",
  "ольденбург",
  "орадя",
  "остроленка",
  "пардубице",
  "пелло",
  "перуджа",
  "петрошани",
  "плауен",
  "плевля",
  "плоешти",
  "пльзень",
  "постойна",
  "потенца",
  "прага",
  "призрен",
  "пшемысль",
  "пьяченца",
  "разград",
  "рацибуж",
  "риека",
  "римини",
  "рованиеми",
  "роман",
  "русе",
  "сандански",
  "сату-маре",
  "свег",
  "свиленград",
  "свиноуйсвце",
  "свиштов",
  "сеговия",
  "сибиу",
  "сиракуза",
  "славонский брод",
  "сомбор",
  "сория",
  "сплит",
  "суомисалми",
  "сьеница",
  "тампере",
  "тарвизио",
  "теруэль",
  "тетеров",
  "тиват",
  "тимишоара",
  "толедо",
  "тортоса",
  "торунь",
  "трибен",
  "тырговиште",
  "тыргу-жиу",
  "улцинь",
  "упсала",
  "устка",
  "фаенца",
  "фельдкирх",
  "фетешти",
  "филлах",
  "флорешти",
  "фрайбург",
  "фрайштадт",
  "фэгэраш",
  "хасково",
  "хасселт",
  "хаэн",
  "хвар",
  "хузум",
  "ченстохова",
  "шабла",
  "шамони",
  "шибеник",
  "эльблонг",
  "яссы",
  "аган",
  "куала-лумпур",
  "лос-анджелес",
  "сингапур",
  "тайбэй",
  "амман",
  "джакарта",
  "пуна",
  "бангалор",
  "хайдарабад",
  "мадрас",
  "калькутта",
  "бомбей",
  "гонконг",
  "сиэтл",
  "ашгабад",
  "тагтабазар",
  "куресааре",
  "маньчжурия",
  "когалым",
  "милтон кинз",
  "шлиссельбург",
  "бодэ",
  "боде",
  "кёнигсберг",
  "бураево",
  "адыгейск",
  "снежинск",
  "белев",
  "нововоронеж",
  "саянск",
  "добрич",
  "десногорск",
  "саров",
  "курганинск",
  "нетешин",
  "висагинас",
  "копенгаген",
  "дубаи",
  "фаро",
  "излучинск",
  "сантьяго",
  "заозерск",
  "зарафшан",
  "о. сан-джорджо маджоре",
  "шарыпово",
  "бейрут",
  "дамаск",
  "новоуральск",
  "степногорск",
  "тегусигальпа",
  "олесюн",
  "санто-доминго",
  "улан-батор",
  "kouvola",
  "энергодар",
  "муравленко",
  "саарлэнд",
  "королев",
  "чунский",
  "протвино",
  "таксимо",
  "трехгорный",
  "шарм эль шейх",
  "басра",
  "мосул",
  "култук",
  "ларьяк",
  "губкинский",
  "йоханесбург",
  "гральхейм",
  "скопье",
  "дуглас",
  "ончан",
  "рамси",
  "пил",
  "каслтаун",
  "порт-эрин",
  "порт-сент-мэри",
  "нойётинг",
  "южноукраинск",
  "циндао",
  "днестровск",
  "дятьково",
  "лянтор",
  "морокко",
  "beckum",
  "иматра",
  "girona",
  "танжер",
  "гюмри",
  "югорск",
  "першотравенск",
  "худжанд",
  "ариэль",
  "байконур",
  "раздан",
  "дингольфинг",
  "удомля",
  "брауншвейг",
  "salzgitter",
  "славутич",
  "гуанчжоу",
  "кирьят-ата",
  "палдиски",
  "южно-курильск",
  "хапаранда",
  "мошонмадьяровар",
  "мигдаль аэмек",
  "снежногорск",
  "лесной",
  "мегион",
  "кацрин",
  "хургада",
  "железноводск",
  "полярные зори",
  "сургут (самарская обл.)",
  "модиин",
  "ларнака",
  "северобайкальск",
  "вятские поляны",
  "торнхилл",
  "уиллоудэйл",
  "бургхаузен",
  "joensuu",
  "ноймюнстер",
  "nabeul",
  "пуровск",
  "азери",
  "кохма",
  "щёлкино",
  "брашов",
  "молде",
  "од-а шарон",
  "падуя",
  "бангкок",
  "керкира",
  "мапуто",
  "dagu",
  "кодинск",
  "моста",
  "хельсингор",
  "егорлыкская",
  "майнинген",
  "гирне",
  "исламабад",
  "карачи",
  "лахоре",
  "бейра",
  "нампула",
  "пемба",
  "балайм",
  "женьжень",
  "нидеркассель",
  "роттвайл",
  "туттлинген",
  "филлинген-швеннинген",
  "хамм",
  "розенхейм",
  "мерефа",
  "песочин",
  "цущиура",
  "ньюмаркет",
  "кито",
  "вышгород",
  "санкт-галлен",
  "солнечнодольск",
  "тарко",
  "кируна",
  "наария",
  "озерновский",
  "боярка",
  "коммунар",
  "изобильный",
  "кириллов",
  "амалфи",
  "северск",
  "константиновка",
  "волмирстэдт",
  "сорренто",
  "железногорск",
  "мистельбах",
  "пикалёво",
  "ниигата",
  "еребру",
  "карлово",
  "зеленокумск",
  "несбиен",
  "покачи",
  "фокино",
  "нассау",
  "кимпо",
  "ширин",
  "фредерик",
  "пыть-ях",
  "игрим",
  "августа",
  "унъюган",
  "кфар саба",
  "дятлово",
  "крайстчерч",
  "лангепас",
  "уральска",
  "южный",
  "приобье",
  "тахо",
  "строудсбург",
  "вилючинск",
];

export default cities;
